import * as e from "react";
import { createContext as t, createElement as n, forwardRef as r, useCallback as i, useContext as a, useEffect as o, useImperativeHandle as s, useLayoutEffect as c, useRef as l, useState as u } from "react";
import { Fragment as d, jsx as f, jsxs as p } from "react/jsx-runtime";
import * as m from "react-dom";
//#region ../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function h(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") {
		if (Array.isArray(e)) {
			var i = e.length;
			for (t = 0; t < i; t++) e[t] && (n = h(e[t])) && (r && (r += " "), r += n);
		} else for (n in e) e[n] && (r && (r += " "), r += n);
	}
	return r;
}
function g() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = h(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region ../node_modules/.pnpm/tailwind-merge@3.7.0/node_modules/tailwind-merge/dist/bundle-mjs.mjs
var _ = (e, t) => {
	let n = Array(e.length + t.length);
	for (let t = 0; t < e.length; t++) n[t] = e[t];
	for (let r = 0; r < t.length; r++) n[e.length + r] = t[r];
	return n;
}, v = (e, t) => ({
	classGroupId: e,
	validator: t
}), y = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), b = "-", x = [], S = "arbitrary..", C = (e) => {
	let t = E(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e.startsWith("[") && e.endsWith("]")) return T(e);
			let n = e.split(b);
			return w(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? _(i, t) : t : i || x;
			}
			return n[e] || x;
		}
	};
}, w = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = w(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(b) : e.slice(t).join(b), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, T = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
	let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
	return r ? S + r : void 0;
})(), E = (e) => {
	let { theme: t, classGroups: n } = e;
	return ee(n, t);
}, ee = (e, t) => {
	let n = y();
	for (let r in e) {
		let i = e[r];
		D(i, n, r, t);
	}
	return n;
}, D = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		te(i, t, n, r);
	}
}, te = (e, t, n, r) => {
	typeof e == "string" ? O(e, t, n) : typeof e == "function" ? k(e, t, n, r) : A(e, t, n, r);
}, O = (e, t, n) => {
	let r = e === "" ? t : j(t, e);
	r.classGroupId = n;
}, k = (e, t, n, r) => {
	M(e) ? D(e(r), t, n, r) : (t.validators === null && (t.validators = []), t.validators.push(v(n, e)));
}, A = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		D(o, j(t, a), n, r);
	}
}, j = (e, t) => {
	let n = e, r = t.split(b), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = y(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, M = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, ne = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a) => {
		n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
	};
	return {
		get(e) {
			let t = n[e];
			if (t !== void 0) return t;
			if ((t = r[e]) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			e in n ? n[e] = t : i(e, t);
		}
	};
}, N = "!", re = ":", ie = [], ae = (e, t, n, r, i) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: i
}), oe = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a, o = e.length;
		for (let s = 0; s < o; s++) {
			let o = e[s];
			if (n === 0 && r === 0) {
				if (o === re) {
					t.push(e.slice(i, s)), i = s + 1;
					continue;
				}
				if (o === "/") {
					a = s;
					continue;
				}
			}
			o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
		}
		let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
		s.endsWith(N) ? (c = s.slice(0, -1), l = !0) : s.startsWith(N) && (c = s.slice(1), l = !0);
		let u = a && a > i ? a - i : void 0;
		return ae(t, l, c, u);
	};
	if (t) {
		let e = t + re, n = r;
		r = (t) => t.startsWith(e) ? n(t.slice(e.length)) : ae(ie, !1, t, void 0, !0);
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, P = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.orderSensitiveModifiers.forEach((e, n) => {
		t.set(e, 1e6 + n);
	}), (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
		}
		return r.length > 0 && (r.sort(), n.push(...r)), n;
	};
}, F = (e) => ({
	cache: ne(e.cacheSize),
	parseClassName: oe(e),
	sortModifiers: P(e),
	postfixLookupClassGroupIds: se(e),
	...C(e)
}), se = (e) => {
	let t = Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, ce = /\s+/, I = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split(ce), l = "";
	for (let e = c.length - 1; e >= 0; --e) {
		let t = c[e], { isExternal: u, modifiers: d, hasImportantModifier: f, baseClassName: p, maybePostfixModifierPosition: m } = n(t);
		if (u) {
			l = t + (l.length > 0 ? " " + l : l);
			continue;
		}
		let h = !!m, g;
		if (h) {
			g = r(p.substring(0, m));
			let e = g && o[g] ? r(p) : void 0;
			e && e !== g && (g = e, h = !1);
		} else g = r(p);
		if (!g) {
			if (!h || (g = r(p), !g)) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			h = !1;
		}
		let _ = d.length === 0 ? "" : d.length === 1 ? d[0] : a(d).join(":"), v = f ? _ + N : _, y = v + g;
		if (s.indexOf(y) > -1) continue;
		s.push(y);
		let b = i(g, h);
		for (let e = 0; e < b.length; ++e) {
			let t = b[e];
			s.push(v + t);
		}
		l = t + (l.length > 0 ? " " + l : l);
	}
	return l;
}, le = (...e) => {
	let t = 0, n, r, i = "";
	for (; t < e.length;) (n = e[t++]) && (r = ue(n)) && (i && (i += " "), i += r);
	return i;
}, ue = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = ue(e[r])) && (n && (n += " "), n += t);
	return n;
}, de = (e, ...t) => {
	let n, r, i, a, o = (o) => (n = F(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e) => {
		let t = r(e);
		if (t) return t;
		let a = I(e, n);
		return i(e, a), a;
	};
	return a = o, (...e) => a(le(...e));
}, fe = [], L = (e) => {
	let t = (t) => t[e] || fe;
	return t.isThemeGetter = !0, t.themeKey = e, t;
}, pe = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, me = /^\((?:(\w[\w-]*):)?(.+)\)$/i, he = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, ge = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, _e = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, ve = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/, ye = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, be = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, xe = (e) => he.test(e), R = (e) => !!e && !Number.isNaN(Number(e)), Se = (e) => !!e && Number.isInteger(Number(e)), Ce = (e) => e.endsWith("%") && R(e.slice(0, -1)), we = (e) => ge.test(e), Te = () => !0, Ee = (e) => _e.test(e) && !ve.test(e), De = () => !1, Oe = (e) => ye.test(e), ke = (e) => be.test(e), Ae = (e) => !z(e) && !B(e), je = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), Me = (e) => qe(e, Ze, De), z = (e) => pe.test(e), Ne = (e) => qe(e, Qe, Ee), Pe = (e) => qe(e, $e, R), Fe = (e) => qe(e, tt, Te), Ie = (e) => qe(e, et, De), Le = (e) => qe(e, Ye, De), Re = (e) => qe(e, Xe, ke), ze = (e) => qe(e, nt, Oe), B = (e) => me.test(e), Be = (e) => Je(e, Qe), Ve = (e) => Je(e, et), He = (e) => Je(e, Ye), Ue = (e) => Je(e, Ze), We = (e) => Je(e, Xe), Ge = (e) => Je(e, nt, !0), Ke = (e) => Je(e, tt, !0), qe = (e, t, n) => {
	let r = pe.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Je = (e, t, n = !1) => {
	let r = me.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, Ye = (e) => e === "position" || e === "percentage", Xe = (e) => e === "image" || e === "url", Ze = (e) => e === "length" || e === "size" || e === "bg-size", Qe = (e) => e === "length", $e = (e) => e === "number", et = (e) => e === "family-name", tt = (e) => e === "number" || e === "weight", nt = (e) => e === "shadow", rt = /*#__PURE__*/ de(() => {
	let e = L("color"), t = L("font"), n = L("text"), r = L("font-weight"), i = L("tracking"), a = L("leading"), o = L("breakpoint"), s = L("container"), c = L("spacing"), l = L("radius"), u = L("shadow"), d = L("inset-shadow"), f = L("text-shadow"), p = L("drop-shadow"), m = L("blur"), h = L("perspective"), g = L("aspect"), _ = L("ease"), v = L("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		B,
		z
	], S = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], C = () => [
		"auto",
		"contain",
		"none"
	], w = () => [
		B,
		z,
		c
	], T = () => [
		xe,
		"full",
		"auto",
		...w()
	], E = () => [
		Se,
		"none",
		"subgrid",
		B,
		z
	], ee = () => [
		"auto",
		{ span: [
			"full",
			Se,
			B,
			z
		] },
		Se,
		B,
		z
	], D = () => [
		Se,
		"auto",
		B,
		z
	], te = () => [
		"auto",
		"min",
		"max",
		"fr",
		B,
		z
	], O = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], k = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], A = () => ["auto", ...w()], j = () => [
		xe,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], M = () => [
		s,
		xe,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...w()
	], ne = () => [
		xe,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], N = () => [
		e,
		B,
		z
	], re = () => [
		...b(),
		He,
		Le,
		{ position: [B, z] }
	], ie = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], ae = () => [
		"auto",
		"cover",
		"contain",
		Ue,
		Me,
		{ size: [B, z] }
	], oe = () => [
		Ce,
		Be,
		Ne
	], P = () => [
		"",
		"none",
		"full",
		l,
		B,
		z
	], F = () => [
		"",
		R,
		Be,
		Ne
	], se = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], ce = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], I = () => [
		R,
		Ce,
		He,
		Le
	], le = () => [
		"",
		"none",
		m,
		B,
		z
	], ue = () => [
		"none",
		R,
		B,
		z
	], de = () => [
		"none",
		R,
		B,
		z
	], fe = () => [
		R,
		B,
		z
	], pe = () => [
		xe,
		"full",
		...w()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [we],
			breakpoint: [we],
			color: [Te],
			container: [we],
			"drop-shadow": [we],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [Ae],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [we],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [we],
			shadow: [we],
			spacing: ["px", R],
			text: [we],
			"text-shadow": [we],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				xe,
				z,
				B,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				B,
				z
			] }],
			"container-named": [je],
			columns: [{ columns: [
				R,
				"auto",
				z,
				B,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: S() }],
			"overflow-x": [{ "overflow-x": S() }],
			"overflow-y": [{ "overflow-y": S() }],
			overscroll: [{ overscroll: C() }],
			"overscroll-x": [{ "overscroll-x": C() }],
			"overscroll-y": [{ "overscroll-y": C() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: T() }],
			"inset-x": [{ "inset-x": T() }],
			"inset-y": [{ "inset-y": T() }],
			start: [{
				"inset-s": T(),
				start: T()
			}],
			end: [{
				"inset-e": T(),
				end: T()
			}],
			"inset-bs": [{ "inset-bs": T() }],
			"inset-be": [{ "inset-be": T() }],
			top: [{ top: T() }],
			right: [{ right: T() }],
			bottom: [{ bottom: T() }],
			left: [{ left: T() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				Se,
				"auto",
				B,
				z
			] }],
			basis: [{ basis: [
				xe,
				"full",
				"auto",
				s,
				...w()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				R,
				xe,
				"auto",
				"initial",
				"none",
				z
			] }],
			grow: [{ grow: [
				"",
				R,
				B,
				z
			] }],
			shrink: [{ shrink: [
				"",
				R,
				B,
				z
			] }],
			order: [{ order: [
				Se,
				"first",
				"last",
				"none",
				B,
				z
			] }],
			"grid-cols": [{ "grid-cols": E() }],
			"col-start-end": [{ col: ee() }],
			"col-start": [{ "col-start": D() }],
			"col-end": [{ "col-end": D() }],
			"grid-rows": [{ "grid-rows": E() }],
			"row-start-end": [{ row: ee() }],
			"row-start": [{ "row-start": D() }],
			"row-end": [{ "row-end": D() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": te() }],
			"auto-rows": [{ "auto-rows": te() }],
			gap: [{ gap: w() }],
			"gap-x": [{ "gap-x": w() }],
			"gap-y": [{ "gap-y": w() }],
			"justify-content": [{ justify: [...O(), "normal"] }],
			"justify-items": [{ "justify-items": [...k(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...k()] }],
			"align-content": [{ content: ["normal", ...O()] }],
			"align-items": [{ items: [...k(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...k(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": O() }],
			"place-items": [{ "place-items": [...k(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...k()] }],
			p: [{ p: w() }],
			px: [{ px: w() }],
			py: [{ py: w() }],
			ps: [{ ps: w() }],
			pe: [{ pe: w() }],
			pbs: [{ pbs: w() }],
			pbe: [{ pbe: w() }],
			pt: [{ pt: w() }],
			pr: [{ pr: w() }],
			pb: [{ pb: w() }],
			pl: [{ pl: w() }],
			m: [{ m: A() }],
			mx: [{ mx: A() }],
			my: [{ my: A() }],
			ms: [{ ms: A() }],
			me: [{ me: A() }],
			mbs: [{ mbs: A() }],
			mbe: [{ mbe: A() }],
			mt: [{ mt: A() }],
			mr: [{ mr: A() }],
			mb: [{ mb: A() }],
			ml: [{ ml: A() }],
			"space-x": [{ "space-x": w() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": w() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: j() }],
			"inline-size": [{ inline: ["auto", ...M()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...M()] }],
			"max-inline-size": [{ "max-inline": ["none", ...M()] }],
			"block-size": [{ block: ["auto", ...ne()] }],
			"min-block-size": [{ "min-block": ["auto", ...ne()] }],
			"max-block-size": [{ "max-block": ["none", ...ne()] }],
			w: [{ w: [
				s,
				"screen",
				...j()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...j()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...j()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...j()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...j()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				"none",
				...j()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				Be,
				Ne
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				Ke,
				Fe
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				Ce,
				z
			] }],
			"font-family": [{ font: [
				Ve,
				Ie,
				t
			] }],
			"font-features": [{ "font-features": [z] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				B,
				z
			] }],
			"line-clamp": [{ "line-clamp": [
				R,
				"none",
				B,
				Pe
			] }],
			leading: [{ leading: [
				"none",
				a,
				...w()
			] }],
			"list-image": [{ "list-image": [
				"none",
				B,
				z
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				B,
				z
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: N() }],
			"text-color": [{ text: N() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...se(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				R,
				"from-font",
				"auto",
				B,
				Ne
			] }],
			"text-decoration-color": [{ decoration: N() }],
			"underline-offset": [{ "underline-offset": [
				R,
				"auto",
				B,
				z
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: w() }],
			"tab-size": [{ tab: [
				Se,
				B,
				z
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				B,
				z
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				B,
				z
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: re() }],
			"bg-repeat": [{ bg: ie() }],
			"bg-size": [{ bg: ae() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						Se,
						B,
						z
					],
					radial: [
						"",
						B,
						z
					],
					conic: [
						"",
						Se,
						B,
						z
					]
				},
				We,
				Re
			] }],
			"bg-color": [{ bg: N() }],
			"gradient-from-pos": [{ from: oe() }],
			"gradient-via-pos": [{ via: oe() }],
			"gradient-to-pos": [{ to: oe() }],
			"gradient-from": [{ from: N() }],
			"gradient-via": [{ via: N() }],
			"gradient-to": [{ to: N() }],
			rounded: [{ rounded: P() }],
			"rounded-s": [{ "rounded-s": P() }],
			"rounded-e": [{ "rounded-e": P() }],
			"rounded-t": [{ "rounded-t": P() }],
			"rounded-r": [{ "rounded-r": P() }],
			"rounded-b": [{ "rounded-b": P() }],
			"rounded-l": [{ "rounded-l": P() }],
			"rounded-ss": [{ "rounded-ss": P() }],
			"rounded-se": [{ "rounded-se": P() }],
			"rounded-ee": [{ "rounded-ee": P() }],
			"rounded-es": [{ "rounded-es": P() }],
			"rounded-tl": [{ "rounded-tl": P() }],
			"rounded-tr": [{ "rounded-tr": P() }],
			"rounded-br": [{ "rounded-br": P() }],
			"rounded-bl": [{ "rounded-bl": P() }],
			"border-w": [{ border: F() }],
			"border-w-x": [{ "border-x": F() }],
			"border-w-y": [{ "border-y": F() }],
			"border-w-s": [{ "border-s": F() }],
			"border-w-e": [{ "border-e": F() }],
			"border-w-bs": [{ "border-bs": F() }],
			"border-w-be": [{ "border-be": F() }],
			"border-w-t": [{ "border-t": F() }],
			"border-w-r": [{ "border-r": F() }],
			"border-w-b": [{ "border-b": F() }],
			"border-w-l": [{ "border-l": F() }],
			"divide-x": [{ "divide-x": F() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": F() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...se(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...se(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: N() }],
			"border-color-x": [{ "border-x": N() }],
			"border-color-y": [{ "border-y": N() }],
			"border-color-s": [{ "border-s": N() }],
			"border-color-e": [{ "border-e": N() }],
			"border-color-bs": [{ "border-bs": N() }],
			"border-color-be": [{ "border-be": N() }],
			"border-color-t": [{ "border-t": N() }],
			"border-color-r": [{ "border-r": N() }],
			"border-color-b": [{ "border-b": N() }],
			"border-color-l": [{ "border-l": N() }],
			"divide-color": [{ divide: N() }],
			"outline-style": [{ outline: [
				...se(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				R,
				B,
				z
			] }],
			"outline-w": [{ outline: [
				"",
				R,
				Be,
				Ne
			] }],
			"outline-color": [{ outline: N() }],
			shadow: [{ shadow: [
				"",
				"inner",
				"none",
				u,
				Ge,
				ze
			] }],
			"shadow-color": [{ shadow: N() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				Ge,
				ze
			] }],
			"inset-shadow-color": [{ "inset-shadow": N() }],
			"ring-w": [{ ring: F() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: N() }],
			"ring-offset-w": [{ "ring-offset": [R, Ne] }],
			"ring-offset-color": [{ "ring-offset": N() }],
			"inset-ring-w": [{ "inset-ring": F() }],
			"inset-ring-color": [{ "inset-ring": N() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				Ge,
				ze
			] }],
			"text-shadow-color": [{ "text-shadow": N() }],
			opacity: [{ opacity: [
				R,
				B,
				z
			] }],
			"mix-blend": [{ "mix-blend": [
				...ce(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": ce() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [R] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": I() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": I() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": N() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": N() }],
			"mask-image-t-from-pos": [{ "mask-t-from": I() }],
			"mask-image-t-to-pos": [{ "mask-t-to": I() }],
			"mask-image-t-from-color": [{ "mask-t-from": N() }],
			"mask-image-t-to-color": [{ "mask-t-to": N() }],
			"mask-image-r-from-pos": [{ "mask-r-from": I() }],
			"mask-image-r-to-pos": [{ "mask-r-to": I() }],
			"mask-image-r-from-color": [{ "mask-r-from": N() }],
			"mask-image-r-to-color": [{ "mask-r-to": N() }],
			"mask-image-b-from-pos": [{ "mask-b-from": I() }],
			"mask-image-b-to-pos": [{ "mask-b-to": I() }],
			"mask-image-b-from-color": [{ "mask-b-from": N() }],
			"mask-image-b-to-color": [{ "mask-b-to": N() }],
			"mask-image-l-from-pos": [{ "mask-l-from": I() }],
			"mask-image-l-to-pos": [{ "mask-l-to": I() }],
			"mask-image-l-from-color": [{ "mask-l-from": N() }],
			"mask-image-l-to-color": [{ "mask-l-to": N() }],
			"mask-image-x-from-pos": [{ "mask-x-from": I() }],
			"mask-image-x-to-pos": [{ "mask-x-to": I() }],
			"mask-image-x-from-color": [{ "mask-x-from": N() }],
			"mask-image-x-to-color": [{ "mask-x-to": N() }],
			"mask-image-y-from-pos": [{ "mask-y-from": I() }],
			"mask-image-y-to-pos": [{ "mask-y-to": I() }],
			"mask-image-y-from-color": [{ "mask-y-from": N() }],
			"mask-image-y-to-color": [{ "mask-y-to": N() }],
			"mask-image-radial": [{ "mask-radial": [B, z] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": I() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": I() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": N() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": N() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [R] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": I() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": I() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": N() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": N() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: re() }],
			"mask-repeat": [{ mask: ie() }],
			"mask-size": [{ mask: ae() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				B,
				z
			] }],
			filter: [{ filter: [
				"",
				"none",
				B,
				z
			] }],
			blur: [{ blur: le() }],
			brightness: [{ brightness: [
				R,
				B,
				z
			] }],
			contrast: [{ contrast: [
				R,
				B,
				z
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				Ge,
				ze
			] }],
			"drop-shadow-color": [{ "drop-shadow": N() }],
			grayscale: [{ grayscale: [
				"",
				R,
				B,
				z
			] }],
			"hue-rotate": [{ "hue-rotate": [
				R,
				B,
				z
			] }],
			invert: [{ invert: [
				"",
				R,
				B,
				z
			] }],
			saturate: [{ saturate: [
				R,
				B,
				z
			] }],
			sepia: [{ sepia: [
				"",
				R,
				B,
				z
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				B,
				z
			] }],
			"backdrop-blur": [{ "backdrop-blur": le() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				R,
				B,
				z
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				R,
				B,
				z
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				R,
				B,
				z
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				R,
				B,
				z
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				R,
				B,
				z
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				R,
				B,
				z
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				R,
				B,
				z
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				R,
				B,
				z
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": w() }],
			"border-spacing-x": [{ "border-spacing-x": w() }],
			"border-spacing-y": [{ "border-spacing-y": w() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				B,
				z
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				R,
				"initial",
				B,
				z
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				B,
				z
			] }],
			delay: [{ delay: [
				R,
				B,
				z
			] }],
			animate: [{ animate: [
				"none",
				v,
				B,
				z
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				B,
				z
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: ue() }],
			"rotate-x": [{ "rotate-x": ue() }],
			"rotate-y": [{ "rotate-y": ue() }],
			"rotate-z": [{ "rotate-z": ue() }],
			scale: [{ scale: de() }],
			"scale-x": [{ "scale-x": de() }],
			"scale-y": [{ "scale-y": de() }],
			"scale-z": [{ "scale-z": de() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: fe() }],
			"skew-x": [{ "skew-x": fe() }],
			"skew-y": [{ "skew-y": fe() }],
			transform: [{ transform: [
				B,
				z,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: pe() }],
			"translate-x": [{ "translate-x": pe() }],
			"translate-y": [{ "translate-y": pe() }],
			"translate-z": [{ "translate-z": pe() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				Se,
				B,
				z
			] }],
			accent: [{ accent: N() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: N() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				B,
				z
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": N() }],
			"scrollbar-track-color": [{ "scrollbar-track": N() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": w() }],
			"scroll-mx": [{ "scroll-mx": w() }],
			"scroll-my": [{ "scroll-my": w() }],
			"scroll-ms": [{ "scroll-ms": w() }],
			"scroll-me": [{ "scroll-me": w() }],
			"scroll-mbs": [{ "scroll-mbs": w() }],
			"scroll-mbe": [{ "scroll-mbe": w() }],
			"scroll-mt": [{ "scroll-mt": w() }],
			"scroll-mr": [{ "scroll-mr": w() }],
			"scroll-mb": [{ "scroll-mb": w() }],
			"scroll-ml": [{ "scroll-ml": w() }],
			"scroll-p": [{ "scroll-p": w() }],
			"scroll-px": [{ "scroll-px": w() }],
			"scroll-py": [{ "scroll-py": w() }],
			"scroll-ps": [{ "scroll-ps": w() }],
			"scroll-pe": [{ "scroll-pe": w() }],
			"scroll-pbs": [{ "scroll-pbs": w() }],
			"scroll-pbe": [{ "scroll-pbe": w() }],
			"scroll-pt": [{ "scroll-pt": w() }],
			"scroll-pr": [{ "scroll-pr": w() }],
			"scroll-pb": [{ "scroll-pb": w() }],
			"scroll-pl": [{ "scroll-pl": w() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				B,
				z
			] }],
			fill: [{ fill: ["none", ...N()] }],
			"stroke-w": [{ stroke: [
				R,
				Be,
				Ne,
				Pe
			] }],
			stroke: [{ stroke: ["none", ...N()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": [
				"start",
				"end",
				"right",
				"left"
			],
			"inset-y": [
				"inset-bs",
				"inset-be",
				"top",
				"bottom"
			],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: [
				"ps",
				"pe",
				"pr",
				"pl"
			],
			py: [
				"pbs",
				"pbe",
				"pt",
				"pb"
			],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: [
				"ms",
				"me",
				"mr",
				"ml"
			],
			my: [
				"mbs",
				"mbe",
				"mt",
				"mb"
			],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": [
				"border-w-s",
				"border-w-e",
				"border-w-r",
				"border-w-l"
			],
			"border-w-y": [
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-b"
			],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": [
				"border-color-s",
				"border-color-e",
				"border-color-r",
				"border-color-l"
			],
			"border-color-y": [
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-b"
			],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": [
				"scroll-ms",
				"scroll-me",
				"scroll-mr",
				"scroll-ml"
			],
			"scroll-my": [
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mb"
			],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": [
				"scroll-ps",
				"scroll-pe",
				"scroll-pr",
				"scroll-pl"
			],
			"scroll-py": [
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pb"
			],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
});
//#endregion
//#region src/utils/cn.ts
function V(...e) {
	return rt(g(e));
}
//#endregion
//#region ../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.mjs
var it = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, at = g, H = (e, t) => (n) => {
	if (t?.variants == null) return at(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = it(t) || it(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return at(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
}, ot = H([
	"agn-btn inline-flex items-center justify-center gap-2 whitespace-nowrap",
	"font-medium leading-none transition-colors",
	"[&_svg]:shrink-0",
	"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900",
	"disabled:pointer-events-none disabled:opacity-50",
	"touch-manipulation"
], {
	variants: {
		variant: {
			default: [
				"bg-slate-900 text-white",
				"hover:bg-slate-800",
				"focus-visible:ring-slate-900",
				"dark:bg-white dark:text-slate-900",
				"dark:hover:bg-slate-200",
				"dark:focus-visible:ring-white"
			],
			primary: [
				"bg-slate-900 text-white",
				"hover:bg-slate-800",
				"focus-visible:ring-slate-900",
				"dark:bg-white dark:text-slate-900",
				"dark:hover:bg-slate-200",
				"dark:focus-visible:ring-white"
			],
			outline: [
				"bg-white text-slate-700 border border-slate-300",
				"hover:bg-slate-50",
				"focus-visible:ring-slate-500",
				"dark:bg-slate-800 dark:text-slate-100 dark:border-slate-600",
				"dark:hover:bg-slate-700"
			],
			secondary: [
				"bg-white text-slate-700 border border-slate-300",
				"hover:bg-slate-50",
				"focus-visible:ring-slate-500",
				"dark:bg-slate-800 dark:text-slate-100 dark:border-slate-600",
				"dark:hover:bg-slate-700"
			],
			ghost: [
				"bg-transparent text-slate-700",
				"hover:bg-slate-100",
				"focus-visible:ring-slate-500",
				"dark:text-slate-100",
				"dark:hover:bg-slate-700"
			],
			destructive: [
				"agn-btn--destructive bg-rose-600 text-white",
				"hover:bg-rose-700",
				"focus-visible:ring-rose-600"
			],
			success: [
				"agn-btn--success bg-emerald-600 text-white",
				"hover:bg-emerald-700",
				"focus-visible:ring-emerald-600"
			],
			brand: [
				"agn-btn--brand bg-amber-500 text-white",
				"hover:bg-amber-600",
				"focus-visible:ring-amber-500"
			],
			link: [
				"bg-transparent text-slate-900 underline-offset-4",
				"hover:underline",
				"focus-visible:ring-slate-500",
				"dark:text-slate-100"
			]
		},
		size: {
			xs: "h-7 px-2 text-xs rounded",
			sm: "h-8 px-3 text-sm rounded-md",
			md: "h-10 px-4 text-sm rounded-md",
			default: "h-10 px-4 text-sm rounded-md",
			lg: "h-11 px-6 text-base rounded-md",
			xl: "h-12 px-8 text-base rounded-lg",
			icon: "h-10 w-10 rounded-md",
			"icon-sm": "h-8 w-8 rounded-md",
			"icon-lg": "h-12 w-12 rounded-lg"
		},
		fullWidth: {
			true: "w-full",
			false: ""
		}
	},
	defaultVariants: {
		variant: "primary",
		size: "md",
		fullWidth: !1
	}
}), st = H([
	"text-slate-900 placeholder-slate-400",
	"transition-all duration-150",
	"disabled:cursor-not-allowed disabled:opacity-50",
	"dark:text-white dark:placeholder-slate-500"
], {
	variants: {
		variant: {
			default: [
				"w-full bg-white border border-slate-200 rounded-md",
				"focus:outline-none focus:border-slate-400 focus:ring-1 focus:ring-slate-200",
				"disabled:bg-slate-50 dark:disabled:bg-slate-800",
				"dark:bg-slate-900 dark:border-slate-700",
				"dark:focus:border-slate-500 dark:focus:ring-slate-700"
			],
			inline: ["bg-transparent border-none outline-none", "focus:outline-none focus:ring-0"]
		},
		size: {
			sm: "h-8 px-3 text-sm",
			md: "h-10 px-3 text-sm",
			lg: "h-12 px-4 text-base"
		},
		hasError: {
			true: ["border-rose-500 focus:ring-rose-500", "dark:border-rose-500 dark:focus:ring-rose-500"],
			false: ""
		},
		hasIcon: {
			left: "pl-10",
			right: "pr-10",
			both: "px-10",
			none: ""
		}
	},
	defaultVariants: {
		variant: "default",
		size: "md",
		hasError: !1,
		hasIcon: "none"
	}
}), ct = H([
	"inline-flex items-center whitespace-nowrap box-border font-medium",
	"border rounded-md",
	"transition-colors",
	"[&_svg]:shrink-0"
], {
	variants: {
		variant: {
			default: ["bg-slate-100 text-slate-700 border-slate-200", "dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700"],
			secondary: ["bg-slate-50 text-slate-600 border-slate-200", "dark:bg-slate-900 dark:text-slate-400 dark:border-slate-700"],
			outline: ["bg-transparent text-slate-700 border-slate-300", "dark:text-slate-300 dark:border-slate-600"],
			muted: ["bg-slate-50 text-slate-500 border-transparent", "dark:bg-slate-800/50 dark:text-slate-400 dark:border-transparent"],
			success: ["bg-emerald-50 text-emerald-700 border-emerald-200", "dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-500/20"],
			warning: ["bg-amber-50 text-amber-700 border-amber-200", "dark:bg-amber-500/10 dark:text-amber-300 dark:border-amber-500/20"],
			error: ["bg-rose-50 text-rose-700 border-rose-200", "dark:bg-rose-500/10 dark:text-rose-300 dark:border-rose-500/20"],
			destructive: ["bg-rose-50 text-rose-700 border-rose-200", "dark:bg-rose-500/10 dark:text-rose-300 dark:border-rose-500/20"],
			info: ["bg-sky-50 text-sky-700 border-sky-200", "dark:bg-sky-500/10 dark:text-sky-300 dark:border-sky-500/20"],
			brand: ["bg-amber-100 text-amber-800 border-amber-300", "dark:bg-amber-500/15 dark:text-amber-200 dark:border-amber-500/25"],
			purple: ["bg-violet-50 text-violet-700 border-violet-200", "dark:bg-violet-500/10 dark:text-violet-300 dark:border-violet-500/20"],
			premium: ["bg-gradient-to-r from-amber-100 to-yellow-100 text-amber-800 border-amber-300", "dark:from-amber-500/15 dark:to-yellow-500/15 dark:text-amber-200 dark:border-amber-500/25"],
			cyan: ["bg-cyan-50 text-cyan-700 border-cyan-200", "dark:bg-cyan-500/10 dark:text-cyan-300 dark:border-cyan-500/20"],
			indigo: ["bg-indigo-50 text-indigo-700 border-indigo-200", "dark:bg-indigo-500/10 dark:text-indigo-300 dark:border-indigo-500/20"],
			orange: ["bg-orange-50 text-orange-700 border-orange-200", "dark:bg-orange-500/10 dark:text-orange-300 dark:border-orange-500/20"],
			pink: ["bg-pink-50 text-pink-700 border-pink-200", "dark:bg-pink-500/10 dark:text-pink-300 dark:border-pink-500/20"],
			blue: ["bg-blue-50 text-blue-700 border-blue-200", "dark:bg-blue-500/10 dark:text-blue-300 dark:border-blue-500/20"]
		},
		shape: {
			default: "",
			pill: "rounded-full",
			count: "rounded-full justify-center tabular-nums"
		},
		size: {
			sm: "h-[var(--inline-h,24px)] px-2 text-xs leading-none",
			md: "h-[var(--inline-h,24px)] px-2.5 text-xs leading-none",
			lg: "h-[var(--inline-h-lg,28px)] px-3 text-sm leading-none"
		}
	},
	compoundVariants: [{
		shape: "count",
		size: ["sm", "md"],
		className: "min-w-[var(--inline-h,24px)] px-1.5"
	}, {
		shape: "count",
		size: "lg",
		className: "min-w-[var(--inline-h-lg,28px)] px-1.5"
	}],
	defaultVariants: {
		variant: "default",
		shape: "default",
		size: "md"
	}
}), lt = H(["bg-white border border-slate-200 rounded-lg", "dark:bg-slate-800 dark:border-slate-700"], {
	variants: {
		variant: {
			default: "shadow-sm",
			elevated: "shadow-md",
			outline: "shadow-none",
			ghost: "border-transparent shadow-none bg-transparent"
		},
		interactive: {
			true: [
				"cursor-pointer transition-all",
				"hover:shadow-md hover:scale-[1.01]",
				"active:scale-[0.99]"
			],
			false: ""
		},
		padding: {
			none: "p-0",
			sm: "p-3",
			md: "p-4",
			lg: "p-6"
		}
	},
	defaultVariants: {
		variant: "default",
		interactive: !1,
		padding: "md"
	}
}), ut = H(["relative w-full rounded-lg border p-4 flex items-center gap-3", "[&>svg]:shrink-0"], {
	variants: { variant: {
		default: ["bg-slate-50 border-slate-200 text-slate-900", "dark:bg-slate-800 dark:border-slate-600 dark:text-slate-100"],
		success: [
			"bg-emerald-50 border-emerald-200 text-emerald-900",
			"dark:bg-emerald-500/10 dark:border-emerald-500/20 dark:text-emerald-100",
			"[&>svg]:text-emerald-600 dark:[&>svg]:text-emerald-400"
		],
		warning: [
			"bg-amber-50 border-amber-200 text-amber-900",
			"dark:bg-amber-500/10 dark:border-amber-500/20 dark:text-amber-100",
			"[&>svg]:text-amber-600 dark:[&>svg]:text-amber-400"
		],
		error: [
			"bg-rose-50 border-rose-200 text-rose-900",
			"dark:bg-rose-500/10 dark:border-rose-500/20 dark:text-rose-100",
			"[&>svg]:text-rose-600 dark:[&>svg]:text-rose-400"
		],
		info: [
			"bg-sky-50 border-sky-200 text-sky-900",
			"dark:bg-sky-500/10 dark:border-sky-500/20 dark:text-sky-100",
			"[&>svg]:text-sky-600 dark:[&>svg]:text-sky-400"
		],
		purple: [
			"bg-violet-50 border-violet-200 text-violet-900",
			"dark:bg-violet-500/10 dark:border-violet-500/20 dark:text-violet-100",
			"[&>svg]:text-violet-600 dark:[&>svg]:text-violet-400"
		]
	} },
	defaultVariants: { variant: "default" }
}), dt = H(["rounded-2xl px-4 py-3 max-w-[85%]", "break-words leading-relaxed"], {
	variants: {
		role: {
			user: [
				"bg-slate-900 text-white ml-auto",
				"rounded-br-sm",
				"dark:bg-sky-600 dark:text-white"
			],
			assistant: [
				"bg-white text-slate-900 mr-auto",
				"border border-slate-200 shadow-sm",
				"rounded-bl-sm",
				"dark:bg-slate-800 dark:text-slate-100 dark:border-slate-700"
			],
			system: [
				"bg-slate-50 text-slate-600 mx-auto text-center text-sm",
				"border border-slate-200 rounded-lg",
				"dark:bg-slate-900 dark:text-slate-400 dark:border-slate-800"
			]
		},
		size: {
			sm: "text-sm px-3 py-2",
			md: "text-base",
			lg: "text-lg px-5 py-4"
		}
	},
	defaultVariants: {
		role: "assistant",
		size: "md"
	}
}), ft = H([
	"inline-flex items-center whitespace-nowrap box-border gap-1 font-medium",
	"rounded-md",
	"transition-colors",
	"[&_svg]:shrink-0"
], {
	variants: {
		role: {
			owner: ["bg-amber-50 text-amber-800 border border-amber-200", "dark:bg-amber-500/10 dark:text-amber-300 dark:border-amber-500/20"],
			admin: ["bg-violet-50 text-violet-800 border border-violet-200", "dark:bg-violet-500/10 dark:text-violet-300 dark:border-violet-500/20"],
			manager: ["bg-sky-50 text-sky-800 border border-sky-200", "dark:bg-sky-500/10 dark:text-sky-300 dark:border-sky-500/20"],
			user: ["bg-slate-100 text-slate-700 border border-slate-200", "dark:bg-slate-400/10 dark:text-slate-300 dark:border-slate-400/20"],
			auditor: ["bg-emerald-50 text-emerald-800 border border-emerald-200", "dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-500/20"],
			guest: ["bg-transparent text-slate-700 border border-dashed border-slate-400", "dark:text-slate-300 dark:border-slate-500"]
		},
		emphasis: {
			default: "",
			strong: ""
		},
		size: {
			sm: "h-[var(--inline-h,24px)] px-2 text-xs leading-none",
			md: "h-[var(--inline-h,24px)] px-2.5 text-sm leading-none"
		}
	},
	compoundVariants: [
		{
			role: "owner",
			emphasis: "strong",
			className: "bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-500/15 dark:text-amber-200 dark:border-amber-500/30"
		},
		{
			role: "admin",
			emphasis: "strong",
			className: "bg-violet-100 text-violet-900 border-violet-300 dark:bg-violet-500/15 dark:text-violet-200 dark:border-violet-500/30"
		},
		{
			role: "manager",
			emphasis: "strong",
			className: "bg-sky-100 text-sky-900 border-sky-300 dark:bg-sky-500/15 dark:text-sky-200 dark:border-sky-500/30"
		},
		{
			role: "user",
			emphasis: "strong",
			className: "bg-slate-200 text-slate-800 border-slate-300 dark:bg-slate-400/15 dark:text-slate-200 dark:border-slate-400/30"
		},
		{
			role: "auditor",
			emphasis: "strong",
			className: "bg-emerald-100 text-emerald-900 border-emerald-300 dark:bg-emerald-500/15 dark:text-emerald-200 dark:border-emerald-500/30"
		},
		{
			role: "guest",
			emphasis: "strong",
			className: "text-slate-800 border-slate-500 dark:text-slate-200 dark:border-slate-400"
		}
	],
	defaultVariants: {
		role: "user",
		emphasis: "default",
		size: "sm"
	}
}), pt = H(["relative w-full overflow-hidden rounded-full", "bg-slate-200 dark:bg-slate-700"], {
	variants: { size: {
		sm: "h-1.5",
		md: "h-2.5",
		lg: "h-4"
	} },
	defaultVariants: { size: "md" }
}), mt = H(["h-full w-full flex-1 transition-all"], {
	variants: { variant: {
		default: ["bg-slate-900", "dark:bg-slate-100"],
		success: ["bg-emerald-600", "dark:bg-emerald-500"],
		warning: ["bg-amber-500", "dark:bg-amber-400"],
		error: ["bg-rose-600", "dark:bg-rose-500"]
	} },
	defaultVariants: { variant: "default" }
}), ht = H([
	"inline-flex items-center whitespace-nowrap box-border gap-1.5 font-medium",
	"border rounded-md",
	"transition-colors",
	"[&_svg]:shrink-0"
], {
	variants: {
		tier: {
			0: ["bg-rose-50 text-rose-800 border-rose-200/70", "dark:bg-rose-500/10 dark:text-rose-300 dark:border-rose-500/20"],
			1: ["bg-amber-50 text-amber-800 border-amber-200/70", "dark:bg-amber-500/10 dark:text-amber-300 dark:border-amber-500/20"],
			2: ["bg-emerald-50 text-emerald-700 border-emerald-200/70", "dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-500/20"],
			3: ["bg-green-100 text-green-900 border-green-300/80", "dark:bg-green-500/10 dark:text-green-300 dark:border-green-500/20"]
		},
		size: {
			sm: "h-[var(--inline-h,24px)] px-2 text-xs leading-none",
			md: "h-[var(--inline-h,24px)] px-2.5 text-xs leading-none",
			lg: "h-[var(--inline-h-lg,28px)] px-3 text-sm leading-none"
		}
	},
	defaultVariants: {
		tier: 2,
		size: "md"
	}
}), gt = H(["inline-flex items-center gap-2 rounded-md text-xs font-medium", "[&_svg]:shrink-0"], {
	variants: {
		status: {
			online: ["bg-emerald-50 text-emerald-800 border border-emerald-200", "dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-500/20"],
			offline: ["bg-slate-100 text-slate-600 border border-slate-200", "dark:bg-slate-400/10 dark:text-slate-400 dark:border-slate-400/20"],
			warning: ["bg-amber-50 text-amber-800 border border-amber-200", "dark:bg-amber-500/10 dark:text-amber-300 dark:border-amber-500/20"],
			error: ["bg-rose-50 text-rose-800 border border-rose-200", "dark:bg-rose-500/10 dark:text-rose-300 dark:border-rose-500/20"],
			maintenance: ["bg-sky-50 text-sky-800 border border-sky-200", "dark:bg-sky-500/10 dark:text-sky-300 dark:border-sky-500/20"],
			pending: ["bg-amber-50 text-amber-800 border border-amber-200", "dark:bg-amber-500/10 dark:text-amber-300 dark:border-amber-500/20"],
			inactive: ["bg-slate-50 text-slate-500 border border-slate-100", "dark:bg-slate-400/10 dark:text-slate-400 dark:border-slate-400/15"]
		},
		size: {
			sm: "px-2 py-0.5 text-xs",
			md: "px-2.5 py-0.5 text-xs",
			lg: "px-3 py-1 text-sm"
		}
	},
	defaultVariants: {
		status: "offline",
		size: "md"
	}
}), _t = (e) => e?.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
//#endregion
//#region ../node_modules/.pnpm/lucide-react@1.55.0_@types+react@19.3.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/utils/toLucideIconData.mjs
function vt(e, t, n = []) {
	if (t == null) throw Error("[lucide]: iconNode is required when icon name is used");
	return {
		name: _t(e),
		size: 24,
		node: t,
		...n.length > 0 ? { aliases: n } : {}
	};
}
//#endregion
//#region ../node_modules/.pnpm/lucide-react@1.55.0_@types+react@19.3.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/utils/toCamelCase.mjs
var yt = (e) => {
	let t = "", n = !1;
	for (let r of e) r === "-" || r === "_" || r <= " " ? n = t.length > 0 : (t.length === 0 ? t += r.toLowerCase() : t += n ? r.toUpperCase() : r, n = !1);
	return t;
}, bt = (e) => {
	let t = yt(e);
	return t.charAt(0).toUpperCase() + t.slice(1);
}, xt = (...e) => e.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim(), St = {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	"stroke-width": 2,
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
};
//#endregion
//#region ../node_modules/.pnpm/lucide-react@1.55.0_@types+react@19.3.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/build/buildLucideIconNode.mjs
function Ct(e) {
	return e != null;
}
function wt(e, t = {}) {
	let n = t.attributeNames ?? {}, r = (e) => n[e] ?? e, i = e.size ?? e.width ?? St.width, a = e.size ?? e.height ?? St.height, o = e.aliases?.filter((e) => typeof e == "string" && e.trim() !== "").map((e) => `lucide-${e}`) ?? [], s = [...e.name ? [`lucide-${e.name}`] : [], ...o], c = t.className?.split(" ").filter(Boolean) ?? [], l = t.includeDefaultClasses === !1 ? xt(...c) : xt("lucide", ...s, ...c), u = t.absoluteStrokeWidth ? Number(t.strokeWidth ?? St["stroke-width"]) * Number(e.size ?? e.width ?? St.width) / Number(t.size ?? t.width ?? St.width) : t.strokeWidth ?? St["stroke-width"];
	return [
		"svg",
		{
			...Object.entries(St).reduce((e, [t, n]) => (e[r(t)] = n, e), {}),
			..."color" in t && t.color && { [r("stroke")]: t.color },
			..."size" in t && Ct(t.size) && {
				[r("width")]: t.size,
				[r("height")]: t.size
			},
			..."width" in t && Ct(t.width) && { [r("width")]: t.width },
			..."height" in t && Ct(t.height) && { [r("height")]: t.height },
			[r("stroke-width")]: u,
			...l && { [r("class")]: l },
			[r("viewBox")]: `0 0 ${i} ${a}`,
			...t.hasA11yProp === !1 ? { [r("aria-hidden")]: "true" } : {},
			..."attributes" in t && t.attributes
		},
		e.node.map((e) => {
			let [n, i, a] = e, o = t.nonScalingStroke ? {
				[r("vector-effect")]: "non-scaling-stroke",
				...i
			} : i;
			return a ? [
				n,
				o,
				a
			] : [n, o];
		})
	];
}
//#endregion
//#region ../node_modules/.pnpm/lucide-react@1.55.0_@types+react@19.3.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/build/buildLucideIconForReact.mjs
function Tt(e, t = {}) {
	return wt(e, {
		...t,
		attributeNames: {
			...t.attributeNames,
			class: "className",
			"stroke-width": "strokeWidth",
			"stroke-linecap": "strokeLinecap",
			"stroke-linejoin": "strokeLinejoin",
			"vector-effect": "vectorEffect"
		}
	});
}
//#endregion
//#region ../node_modules/.pnpm/lucide-react@1.55.0_@types+react@19.3.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/utils/hasA11yProp.mjs
var Et = (e) => {
	for (let t in e) if (t.startsWith("aria-") || t === "role" || t === "title") return !0;
	return !1;
}, Dt = t({}), Ot = () => a(Dt), kt = r(({ color: e, size: t, width: r, height: i, strokeWidth: a, absoluteStrokeWidth: o, nonScalingStroke: s, className: c = "", children: l, iconNode: u = [], icon: d = {
	node: u,
	aliases: [],
	size: 24
}, ...f }, p) => {
	let { size: m = 24, strokeWidth: h = 2, absoluteStrokeWidth: g = !1, nonScalingStroke: _ = !1, color: v = "currentColor", className: y = "" } = Ot() ?? {}, b = !!l || Et(f), [x, S, C = []] = Tt(d, {
		color: e ?? v,
		width: r ?? t ?? m,
		height: i ?? t ?? m,
		strokeWidth: a ?? h,
		absoluteStrokeWidth: o ?? g,
		nonScalingStroke: s ?? _,
		className: xt(y, c),
		hasA11yProp: b,
		attributes: f
	});
	return n(x, {
		ref: p,
		...S
	}, [...C.map(([e, t]) => n(e, t)), ...Array.isArray(l) ? l : [l]]);
});
//#endregion
//#region ../node_modules/.pnpm/lucide-react@1.55.0_@types+react@19.3.0_react@19.3.0/node_modules/lucide-react/dist/esm/createLucideIcon.mjs
function U(e, t = [], i = []) {
	let a = typeof e == "string" ? vt(e, t, i) : e, o = r(({ className: e, ...t }, r) => n(kt, {
		ref: r,
		icon: a,
		className: e,
		...t
	}));
	return a.name && (o.displayName = bt(a.name)), o;
}
//#endregion
//#region ../node_modules/.pnpm/lucide-react@1.55.0_@types+react@19.3.0_react@19.3.0/node_modules/lucide-react/dist/esm/icons/app-window.mjs
var At = {
	name: "app-window",
	size: 24,
	node: [
		["rect", {
			x: "2",
			y: "4",
			width: "20",
			height: "16",
			rx: "2",
			key: "izxlao"
		}],
		["path", {
			d: "M10 4v4",
			key: "pp8u80"
		}],
		["path", {
			d: "M2 8h20",
			key: "d11cs7"
		}],
		["path", {
			d: "M6 4v4",
			key: "1svtjw"
		}]
	]
};
At.node;
var jt = U(At), Mt = {
	name: "arrow-down",
	size: 24,
	node: [["path", {
		d: "M12 5v14",
		key: "s699le"
	}], ["path", {
		d: "m19 12-7 7-7-7",
		key: "1idqje"
	}]]
};
Mt.node;
var Nt = U(Mt), Pt = {
	name: "arrow-left",
	size: 24,
	node: [["path", {
		d: "m12 19-7-7 7-7",
		key: "1l729n"
	}], ["path", {
		d: "M19 12H5",
		key: "x3x0zl"
	}]]
};
Pt.node;
var Ft = U(Pt), It = {
	name: "arrow-right",
	size: 24,
	node: [["path", {
		d: "M5 12h14",
		key: "1ays0h"
	}], ["path", {
		d: "m12 5 7 7-7 7",
		key: "xquz4c"
	}]]
};
It.node;
var Lt = U(It), Rt = {
	name: "arrow-up-down",
	size: 24,
	node: [
		["path", {
			d: "m21 16-4 4-4-4",
			key: "f6ql7i"
		}],
		["path", {
			d: "M17 20V4",
			key: "1ejh1v"
		}],
		["path", {
			d: "m3 8 4-4 4 4",
			key: "11wl7u"
		}],
		["path", {
			d: "M7 4v16",
			key: "1glfcx"
		}]
	]
};
Rt.node;
var zt = U(Rt), Bt = {
	name: "arrow-up",
	size: 24,
	node: [["path", {
		d: "m5 12 7-7 7 7",
		key: "hav0vg"
	}], ["path", {
		d: "M12 19V5",
		key: "x0mq9r"
	}]]
};
Bt.node;
var Vt = U(Bt), Ht = {
	name: "chart-column",
	size: 24,
	node: [
		["path", {
			d: "M3 3v16a2 2 0 0 0 2 2h16",
			key: "c24i48"
		}],
		["path", {
			d: "M18 17V9",
			key: "2bz60n"
		}],
		["path", {
			d: "M13 17V5",
			key: "1frdt8"
		}],
		["path", {
			d: "M8 17v-3",
			key: "17ska0"
		}]
	],
	aliases: ["bar-chart-3"]
};
Ht.node;
var Ut = U(Ht), Wt = {
	name: "check",
	size: 24,
	node: [["path", {
		d: "M20 6 9 17l-5-5",
		key: "1gmf2c"
	}]]
};
Wt.node;
var Gt = U(Wt), Kt = {
	name: "chevron-down",
	size: 24,
	node: [["path", {
		d: "m6 9 6 6 6-6",
		key: "qrunsl"
	}]]
};
Kt.node;
var qt = U(Kt), Jt = {
	name: "chevron-right",
	size: 24,
	node: [["path", {
		d: "m9 18 6-6-6-6",
		key: "mthhwq"
	}]]
};
Jt.node;
var Yt = U(Jt), Xt = {
	name: "chevron-left",
	size: 24,
	node: [["path", {
		d: "m15 18-6-6 6-6",
		key: "1wnfg3"
	}]]
};
Xt.node;
var Zt = U(Xt), Qt = {
	name: "chevron-up",
	size: 24,
	node: [["path", {
		d: "m18 15-6-6-6 6",
		key: "153udz"
	}]]
};
Qt.node;
var $t = U(Qt), en = {
	name: "chevrons-left",
	size: 24,
	node: [["path", {
		d: "m11 17-5-5 5-5",
		key: "13zhaf"
	}], ["path", {
		d: "m18 17-5-5 5-5",
		key: "h8a8et"
	}]]
};
en.node;
var tn = U(en), nn = {
	name: "chevrons-right",
	size: 24,
	node: [["path", {
		d: "m6 17 5-5-5-5",
		key: "xnjwq"
	}], ["path", {
		d: "m13 17 5-5-5-5",
		key: "17xmmf"
	}]]
};
nn.node;
var rn = U(nn), an = {
	name: "circle-alert",
	size: 24,
	node: [
		["circle", {
			cx: "12",
			cy: "12",
			r: "10",
			key: "1mglay"
		}],
		["line", {
			x1: "12",
			x2: "12",
			y1: "8",
			y2: "12",
			key: "1pkeuh"
		}],
		["line", {
			x1: "12",
			x2: "12.01",
			y1: "16",
			y2: "16",
			key: "4dfq90"
		}]
	],
	aliases: ["alert-circle"]
};
an.node;
var on = U(an), sn = {
	name: "circle-check-big",
	size: 24,
	node: [["path", {
		d: "M21.801 10A10 10 0 1 1 17 3.335",
		key: "yps3ct"
	}], ["path", {
		d: "m9 11 3 3L22 4",
		key: "1pflzl"
	}]],
	aliases: ["check-circle"]
};
sn.node;
var cn = U(sn), ln = {
	name: "circle-check",
	size: 24,
	node: [["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}], ["path", {
		d: "m16 9-5.5 5.5L8 12",
		key: "xofnsj"
	}]],
	aliases: ["check-circle-2"]
};
ln.node;
var un = U(ln), dn = {
	name: "circle",
	size: 24,
	node: [["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}]]
};
dn.node;
var fn = U(dn), pn = {
	name: "copy",
	size: 24,
	node: [["rect", {
		width: "14",
		height: "14",
		x: "8",
		y: "8",
		rx: "2",
		ry: "2",
		key: "17jyea"
	}], ["path", {
		d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
		key: "zix9uf"
	}]]
};
pn.node;
var mn = U(pn), hn = {
	name: "eye",
	size: 24,
	node: [["path", {
		d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
		key: "1nclc0"
	}], ["circle", {
		cx: "12",
		cy: "12",
		r: "3",
		key: "1v7zrd"
	}]]
};
hn.node;
var gn = U(hn), _n = {
	name: "hard-drive",
	size: 24,
	node: [
		["path", {
			d: "M10 16h.01",
			key: "1bzywj"
		}],
		["path", {
			d: "M2.212 11.577a2 2 0 0 0-.212.896V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5.527a2 2 0 0 0-.212-.896L18.55 5.11A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
			key: "18tbho"
		}],
		["path", {
			d: "M21.946 12.013H2.054",
			key: "zqlbp7"
		}],
		["path", {
			d: "M6 16h.01",
			key: "1pmjb7"
		}]
	]
};
_n.node;
var vn = U(_n), yn = {
	name: "info",
	size: 24,
	node: [
		["circle", {
			cx: "12",
			cy: "12",
			r: "10",
			key: "1mglay"
		}],
		["path", {
			d: "M12 16v-4",
			key: "1dtifu"
		}],
		["path", {
			d: "M12 8h.01",
			key: "e9boi3"
		}]
	]
};
yn.node;
var bn = U(yn), xn = {
	name: "loader-circle",
	size: 24,
	node: [["path", {
		d: "M21 12a9 9 0 1 1-6.219-8.56",
		key: "13zald"
	}]],
	aliases: ["loader-2"]
};
xn.node;
var Sn = U(xn), Cn = {
	name: "message-square",
	size: 24,
	node: [["path", {
		d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		key: "18887p"
	}]]
};
Cn.node;
var wn = U(Cn), Tn = {
	name: "pencil",
	size: 24,
	node: [["path", {
		d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
		key: "1a8usu"
	}], ["path", {
		d: "m15 5 4 4",
		key: "1mk7zo"
	}]]
};
Tn.node;
var En = U(Tn), Dn = {
	name: "search",
	size: 24,
	node: [["path", {
		d: "m21 21-4.34-4.34",
		key: "14j7rj"
	}], ["circle", {
		cx: "11",
		cy: "11",
		r: "8",
		key: "4ej97u"
	}]]
};
Dn.node;
var On = U(Dn), kn = {
	name: "shield-alert",
	size: 24,
	node: [
		["path", {
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
			key: "oel41y"
		}],
		["path", {
			d: "M12 8v4",
			key: "1got3b"
		}],
		["path", {
			d: "M12 16h.01",
			key: "1drbdi"
		}]
	]
};
kn.node;
var An = U(kn), jn = {
	name: "shield-check",
	size: 24,
	node: [["path", {
		d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		key: "oel41y"
	}], ["path", {
		d: "m9 12 2 2 4-4",
		key: "dzmm74"
	}]]
};
jn.node;
var Mn = U(jn), Nn = {
	name: "sparkles",
	size: 24,
	node: [
		["path", {
			d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
			key: "1s2grr"
		}],
		["path", {
			d: "M20 2v4",
			key: "1rf3ol"
		}],
		["path", {
			d: "M22 4h-4",
			key: "gwowj6"
		}],
		["circle", {
			cx: "4",
			cy: "20",
			r: "2",
			key: "6kqj1y"
		}]
	],
	aliases: ["stars"]
};
Nn.node;
var Pn = U(Nn), Fn = {
	name: "table-2",
	size: 24,
	node: [
		["path", {
			d: "M3 9h18",
			key: "1pudct"
		}],
		["path", {
			d: "M9 3v18",
			key: "fh3hqa"
		}],
		["rect", {
			x: "3",
			y: "3",
			width: "18",
			height: "18",
			rx: "2",
			key: "h1oib"
		}]
	]
};
Fn.node;
var In = U(Fn), Ln = {
	name: "triangle-alert",
	size: 24,
	node: [
		["path", {
			d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
			key: "wmoenq"
		}],
		["path", {
			d: "M12 9v4",
			key: "juzpu7"
		}],
		["path", {
			d: "M12 17h.01",
			key: "p32p05"
		}]
	],
	aliases: ["alert-triangle"]
};
Ln.node;
var Rn = U(Ln), zn = {
	name: "x",
	size: 24,
	node: [["path", {
		d: "M18 6 6 18",
		key: "1bl5f8"
	}], ["path", {
		d: "m6 6 12 12",
		key: "d8bk6v"
	}]]
};
zn.node;
var Bn = U(zn), Vn = H([
	"inline-flex items-center gap-1.5 font-medium",
	"border rounded-md",
	"transition-colors"
], {
	variants: {
		action: {
			allow: ["bg-emerald-50 text-emerald-800 border-emerald-200/70", "dark:bg-emerald-950/50 dark:text-emerald-300 dark:border-emerald-800/50"],
			deny: ["bg-rose-50 text-rose-800 border-rose-200/70", "dark:bg-rose-950/50 dark:text-rose-300 dark:border-rose-800/50"],
			escalate: ["bg-amber-50 text-amber-800 border-amber-200/70", "dark:bg-amber-950/50 dark:text-amber-300 dark:border-amber-800/50"],
			obfuscate: ["bg-violet-50 text-violet-800 border-violet-200/70", "dark:bg-violet-950/50 dark:text-violet-300 dark:border-violet-800/50"],
			audit: ["bg-slate-50 text-slate-800 border-slate-200/70", "dark:bg-slate-950/50 dark:text-slate-300 dark:border-slate-800/50"]
		},
		size: {
			sm: "px-2 py-0.5 text-xs",
			md: "px-2.5 py-0.5 text-xs",
			lg: "px-3 py-1 text-sm"
		}
	},
	defaultVariants: {
		action: "allow",
		size: "md"
	}
}), Hn = {
	allow: Gt,
	deny: Bn,
	escalate: Rn,
	obfuscate: gn,
	audit: gn
}, Un = {
	allow: "Allow",
	deny: "Deny",
	escalate: "Escalate",
	obfuscate: "Obfuscate",
	audit: "Audit"
}, Wn = {
	sm: "h-3 w-3",
	md: "h-3.5 w-3.5",
	lg: "h-4 w-4"
};
function Gn({ className: e, action: t, size: n = "md", showIcon: r = !0, label: i, ...a }) {
	let o = Hn[t] || Hn.allow, s = i || Un[t], c = Wn[n || "md"];
	return /* @__PURE__ */ p("span", {
		className: V(Vn({
			action: t,
			size: n
		}), e),
		...a,
		children: [r && /* @__PURE__ */ f(o, {
			className: V(c, "flex-shrink-0"),
			"aria-hidden": "true"
		}), /* @__PURE__ */ f("span", { children: s })]
	});
}
function Kn(e) {
	return Un[e];
}
function qn(e) {
	switch (e) {
		case "allow": return "success";
		case "deny": return "error";
		case "escalate": return "warning";
		case "obfuscate": return "purple";
		case "audit": return "success";
		default: return "success";
	}
}
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-context@1.2.2_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-context/dist/index.mjs
var Jn = Object.defineProperty, Yn = (e, t) => Jn(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function Xn(t, n) {
	let r = e.createContext(n);
	r.displayName = t + "Context";
	let i = /* @__PURE__ */ Yn((t) => {
		let { children: n, ...i } = t, a = e.useMemo(() => i, Object.values(i));
		return /* @__PURE__ */ f(r.Provider, {
			value: a,
			children: n
		});
	}, "Provider");
	i.displayName = t + "Provider";
	function a(i, a = {}) {
		let { optional: o = !1 } = a, s = e.useContext(r);
		if (s) return s;
		if (n !== void 0) return n;
		if (!o) throw Error(`\`${i}\` must be used within \`${t}\``);
	}
	return Yn(a, "useContext"), [i, a];
}
Yn(Xn, "createContext");
// @__NO_SIDE_EFFECTS__
function Zn(t, n = []) {
	let r = [];
	function i(n, i) {
		let a = e.createContext(i);
		a.displayName = n + "Context";
		let o = r.length;
		r = [...r, i];
		let s = /* @__PURE__ */ Yn((n) => {
			let { scope: r, children: i, ...s } = n, c = r?.[t]?.[o] || a, l = e.useMemo(() => s, Object.values(s));
			return /* @__PURE__ */ f(c.Provider, {
				value: l,
				children: i
			});
		}, "Provider");
		s.displayName = n + "Provider";
		function c(r, s, c = {}) {
			let { optional: l = !1 } = c, u = s?.[t]?.[o] || a, d = e.useContext(u);
			if (d) return d;
			if (i !== void 0) return i;
			if (!l) throw Error(`\`${r}\` must be used within \`${n}\``);
		}
		return Yn(c, "useContext"), [s, c];
	}
	Yn(i, "createContext");
	let a = /* @__PURE__ */ Yn(() => {
		let n = r.map((t) => e.createContext(t));
		return /* @__PURE__ */ Yn(function(r) {
			let i = r?.[t] || n;
			return e.useMemo(() => ({ [`__scope${t}`]: {
				...r,
				[t]: i
			} }), [r, i]);
		}, "useScope");
	}, "createScope");
	return a.scopeName = t, [i, Qn(a, ...n)];
}
Yn(Zn, "createContextScope");
function Qn(...t) {
	let n = t[0];
	if (t.length === 1) return n;
	let r = /* @__PURE__ */ Yn(() => {
		let r = t.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ Yn(function(t) {
			let i = r.reduce((e, { useScope: n, scopeName: r }) => {
				let i = n(t)[`__scope${r}`];
				return {
					...e,
					...i
				};
			}, {});
			return e.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
		}, "useComposedScopes");
	}, "createScope");
	return r.scopeName = n.scopeName, r;
}
Yn(Qn, "composeContextScopes");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-use-callback-ref@1.1.4_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var $n = Object.defineProperty, er = (e, t) => $n(e, "name", {
	value: t,
	configurable: !0
});
function tr(t) {
	let n = e.useRef(t);
	return e.useEffect(() => {
		n.current = t;
	}), e.useMemo(() => ((...e) => n.current?.(...e)), []);
}
er(tr, "useCallbackRef");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-use-layout-effect@1.1.4_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var nr = globalThis?.document ? e.useLayoutEffect : () => {}, rr = Object.defineProperty, ir = (e, t) => rr(e, "name", {
	value: t,
	configurable: !0
});
function ar(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
ir(ar, "setRef");
function or(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = ar(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : ar(e[t], null);
			}
		};
	};
}
ir(or, "composeRefs");
function W(...t) {
	return e.useCallback(or(...t), t);
}
ir(W, "useComposedRefs");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-slot@1.4.0_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-slot/dist/index.mjs
var sr = Object.defineProperty, cr = (e, t) => sr(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function lr(t) {
	let n = e.forwardRef((n, r) => {
		let { children: i, ...a } = n, o = null, s = !1, c = [];
		vr(i) && typeof Cr == "function" && (i = Cr(i._payload)), e.Children.forEach(i, (e) => {
			if (gr(e)) {
				s = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				vr(n) && typeof Cr == "function" && (n = Cr(n._payload)), o = pr(t, n), c.push(o?.props?.children);
			} else c.push(e);
		}), o ? o = e.cloneElement(o, void 0, c) : !s && e.Children.count(i) === 1 && e.isValidElement(i) && (o = i);
		let l = o ? hr(o) : void 0, u = W(r, l);
		if (!o) {
			if (i || i === 0) throw Error(s ? Sr(t) : xr(t));
			return i;
		}
		let d = mr(a, o.props ?? {});
		return o.type !== e.Fragment && (d.ref = r ? u : l), e.cloneElement(o, d);
	});
	return n.displayName = `${t}.Slot`, n;
}
cr(lr, "createSlot");
var ur = /* @__PURE__ */ lr("Slot"), dr = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function fr(e) {
	let t = /* @__PURE__ */ cr((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = dr, t;
}
cr(fr, "createSlottable");
var pr = /* @__PURE__ */ cr((t, n) => {
	if ("child" in t.props) {
		let n = t.props.child;
		return e.isValidElement(n) ? e.cloneElement(n, void 0, t.props.children(n.props.children)) : null;
	}
	return e.isValidElement(n) ? n : null;
}, "getSlottableElementFromSlottable");
function mr(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" ? n[r] = [i, a].filter(Boolean).join(" ") : r === "aria-describedby" && (n[r] = br(a, i));
	}
	return {
		...e,
		...n
	};
}
cr(mr, "mergeProps");
function hr(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
cr(hr, "getElementRef");
function gr(t) {
	return e.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === dr;
}
cr(gr, "isSlottable");
var _r = Symbol.for("react.lazy");
function vr(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === _r && "_payload" in e && yr(e._payload);
}
cr(vr, "isLazyComponent");
function yr(e) {
	return typeof e == "object" && !!e && "then" in e;
}
cr(yr, "isPromiseLike");
function br(...e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e) if (typeof n == "string") for (let e of String(n).trim().split(/\s+/)) e && t.add(e);
	return t.size > 0 ? Array.from(t).join(" ") : void 0;
}
cr(br, "concatAriaDescribedby");
var xr = /* @__PURE__ */ cr((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), Sr = /* @__PURE__ */ cr((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), Cr = e.use, wr = Object.defineProperty, Tr = (e, t) => wr(e, "name", {
	value: t,
	configurable: !0
}), G = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((t, n) => {
	let r = /* @__PURE__ */ lr(`Primitive.${n}`), i = e.forwardRef((e, t) => {
		let { asChild: i, ...a } = e, o = i ? r : n;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(o, {
			...a,
			ref: t
		});
	});
	return i.displayName = `Primitive.${n}`, {
		...t,
		[n]: i
	};
}, {});
function Er(e, t) {
	e && m.flushSync(() => e.dispatchEvent(t));
}
Tr(Er, "dispatchDiscreteCustomEvent");
//#endregion
//#region src/components/atoms/Badge/Badge.tsx
var Dr = r(({ className: e, variant: t, size: n, shape: r, ...i }, a) => /* @__PURE__ */ f("span", {
	ref: a,
	className: V(ct({
		variant: t,
		size: n,
		shape: r
	}), e),
	...i
}));
Dr.displayName = "Badge";
//#endregion
//#region src/components/atoms/Button/Button.tsx
var Or = r(({ className: e, variant: t, size: n, fullWidth: r, asChild: i = !1, isLoading: a, disabled: o, children: s, ...c }, l) => {
	let u = i ? ur : "button";
	return i ? /* @__PURE__ */ f(u, {
		ref: l,
		className: V(ot({
			variant: t,
			size: n,
			fullWidth: r
		}), e),
		disabled: o || a,
		...c,
		children: s
	}) : /* @__PURE__ */ p(u, {
		ref: l,
		className: V(ot({
			variant: t,
			size: n,
			fullWidth: r
		}), e),
		disabled: o || a,
		...c,
		children: [a ? /* @__PURE__ */ f("span", { className: "animate-spin mr-2 h-4 w-4 border-2 border-current border-t-transparent rounded-full" }) : null, s]
	});
});
Or.displayName = "Button";
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+primitive@1.1.7/node_modules/@radix-ui/primitive/dist/index.mjs
var kr = Object.defineProperty, Ar = (e, t) => kr(e, "name", {
	value: t,
	configurable: !0
}), jr = !!(typeof window < "u" && window.document && window.document.createElement);
function K(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return /* @__PURE__ */ Ar(function(r) {
		if (e?.(r), n === !1 || !r || !r.defaultPrevented) return t?.(r);
	}, "handleEvent");
}
Ar(K, "composeEventHandlers");
function Mr(e) {
	if (!jr) throw Error("Cannot access window outside of the DOM");
	return e?.ownerDocument?.defaultView ?? window;
}
Ar(Mr, "getOwnerWindow");
function Nr(e) {
	if (!jr) throw Error("Cannot access document outside of the DOM");
	return e?.ownerDocument ?? document;
}
Ar(Nr, "getOwnerDocument");
function Pr(e, t = !1) {
	let { activeElement: n } = Nr(e);
	if (!n?.nodeName) return null;
	if (Fr(n) && n.contentDocument) return Pr(n.contentDocument.body, t);
	if (t) {
		let e = n.getAttribute("aria-activedescendant");
		if (e) {
			let t = Nr(n).getElementById(e);
			if (t) return t;
		}
	}
	return n;
}
Ar(Pr, "getActiveElement");
function Fr(e) {
	return e.tagName === "IFRAME";
}
Ar(Fr, "isFrame");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-dismissable-layer@1.1.20_@types+react-dom@19.3.0_@types+react@19.3.0__@_4e89f70e986c5a91a92277a59b4de3bd/node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var Ir = Object.defineProperty, q = (e, t) => Ir(e, "name", {
	value: t,
	configurable: !0
}), Lr = "dismissableLayer.update", Rr = "dismissableLayer.pointerDownOutside", zr = "dismissableLayer.focusOutside", Br, Vr = e.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set(),
	dismissableSurfaces: /* @__PURE__ */ new Set()
}), Hr = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ q(function(t, n) {
	let { disableOutsidePointerEvents: r = !1, deferPointerDownOutside: i = !1, onEscapeKeyDown: a, onPointerDownOutside: o, onFocusOutside: s, onInteractOutside: c, onDismiss: l, ...u } = t, d = e.useContext(Vr), [p, m] = e.useState(null), h = p?.ownerDocument ?? globalThis?.document, [, g] = e.useState({}), _ = W(n, m), v = Array.from(d.layers), [y] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), b = y ? v.indexOf(y) : -1, x = p ? v.indexOf(p) : -1, S = d.layersWithOutsidePointerEventsDisabled.size > 0, C = x >= b, w = e.useRef(!1), T = Kr((e) => {
		o?.(e), c?.(e), e.defaultPrevented || l?.();
	}, {
		ownerDocument: h,
		deferPointerDownOutside: i,
		isDeferredPointerDownOutsideRef: w,
		dismissableSurfaces: d.dismissableSurfaces,
		shouldHandlePointerDownOutside: e.useCallback((e) => {
			if (!(e instanceof Node)) return !1;
			let t = [...d.branches].some((t) => t.contains(e));
			return C && !t;
		}, [d.branches, C])
	}), E = qr((e) => {
		if (i && w.current) return;
		let t = e.target;
		[...d.branches].some((e) => e.contains(t)) || (s?.(e), c?.(e), e.defaultPrevented || l?.());
	}, h), ee = p ? x === v.length - 1 : !1, D = tr((e) => {
		e.key === "Escape" && (a?.(e), !e.defaultPrevented && l && (e.preventDefault(), l()));
	});
	return e.useEffect(() => {
		if (ee) return h.addEventListener("keydown", D, { capture: !0 }), () => h.removeEventListener("keydown", D, { capture: !0 });
	}, [
		h,
		ee,
		D
	]), e.useEffect(() => {
		if (p) return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Br = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(p)), d.layers.add(p), Jr(), () => {
			r && (d.layersWithOutsidePointerEventsDisabled.delete(p), d.layersWithOutsidePointerEventsDisabled.size === 0 && (h.body.style.pointerEvents = Br));
		};
	}, [
		p,
		h,
		r,
		d
	]), e.useEffect(() => () => {
		p && (d.layers.delete(p), d.layersWithOutsidePointerEventsDisabled.delete(p), Jr());
	}, [p, d]), e.useEffect(() => {
		let e = /* @__PURE__ */ q(() => g({}), "handleUpdate");
		return document.addEventListener(Lr, e), () => document.removeEventListener(Lr, e);
	}, []), /* @__PURE__ */ f(G.div, {
		...u,
		ref: _,
		style: {
			pointerEvents: S ? C ? "auto" : "none" : void 0,
			...t.style
		},
		onFocusCapture: K(t.onFocusCapture, E.onFocusCapture),
		onBlurCapture: K(t.onBlurCapture, E.onBlurCapture),
		onPointerDownCapture: K(t.onPointerDownCapture, T.onPointerDownCapture)
	});
}, "DismissableLayer")), Ur = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ q(function(t, n) {
	let r = e.useContext(Vr), i = e.useRef(null), a = W(n, i);
	return e.useEffect(() => {
		let e = i.current;
		if (e) return r.branches.add(e), () => {
			r.branches.delete(e);
		};
	}, [r.branches]), /* @__PURE__ */ f(G.div, {
		...t,
		ref: a
	});
}, "DismissableLayerBranch"));
function Wr() {
	let t = e.useContext(Vr), [n, r] = e.useState(null);
	return e.useEffect(() => {
		if (n) return t.dismissableSurfaces.add(n), () => {
			t.dismissableSurfaces.delete(n);
		};
	}, [n, t.dismissableSurfaces]), r;
}
q(Wr, "useDismissableLayerSurface");
var Gr = /* @__PURE__ */ q(() => !0, "IS_TRUE");
function Kr(t, n) {
	let { ownerDocument: r = globalThis?.document, deferPointerDownOutside: i = !1, isDeferredPointerDownOutsideRef: a, dismissableSurfaces: o, shouldHandlePointerDownOutside: s = Gr } = n, c = tr(t), l = e.useRef(!1), u = e.useRef(!1), d = e.useRef(/* @__PURE__ */ new Map()), f = e.useRef(() => {});
	return e.useEffect(() => {
		function e() {
			u.current = !1, a.current = !1, d.current.clear();
		}
		q(e, "resetOutsideInteraction");
		function t() {
			return Array.from(d.current.values()).some(Boolean);
		}
		q(t, "isOutsideInteractionIntercepted");
		function n(e) {
			if (!u.current) return;
			let t = e.target;
			t instanceof Node && [...o].some((e) => e.contains(t)) || d.current.set(e.type, !0), e.type === "click" && window.setTimeout(() => {
				u.current && f.current();
			}, 0);
		}
		q(n, "handleInteractionCapture");
		function p(e) {
			u.current && d.current.set(e.type, !1);
		}
		q(p, "handleInteractionBubble");
		let m = /* @__PURE__ */ q((n) => {
			if (n.target && !l.current) {
				let o = function() {
					r.removeEventListener("click", f.current);
					let n = t();
					e(), n || Yr(Rr, c, p, { discrete: !0 });
				};
				if (q(o, "handleAndDispatchPointerDownOutsideEvent"), !s(n.target)) {
					r.removeEventListener("click", f.current), e(), l.current = !1;
					return;
				}
				let p = { originalEvent: n };
				u.current = !0, a.current = i && n.button === 0, d.current.clear(), !i || n.button !== 0 ? o() : (r.removeEventListener("click", f.current), f.current = o, r.addEventListener("click", f.current, { once: !0 }));
			} else r.removeEventListener("click", f.current), e();
			l.current = !1;
		}, "handlePointerDown"), h = [
			"pointerup",
			"mousedown",
			"mouseup",
			"touchstart",
			"touchend",
			"click"
		];
		for (let e of h) r.addEventListener(e, n, !0), r.addEventListener(e, p);
		let g = window.setTimeout(() => {
			r.addEventListener("pointerdown", m);
		}, 0);
		return () => {
			window.clearTimeout(g), r.removeEventListener("pointerdown", m), r.removeEventListener("click", f.current);
			for (let e of h) r.removeEventListener(e, n, !0), r.removeEventListener(e, p);
		};
	}, [
		r,
		c,
		i,
		a,
		o,
		s
	]), { onPointerDownCapture: /* @__PURE__ */ q(() => l.current = !0, "onPointerDownCapture") };
}
q(Kr, "usePointerDownOutside");
function qr(t, n = globalThis?.document) {
	let r = tr(t), i = e.useRef(!1);
	return e.useEffect(() => {
		let e = /* @__PURE__ */ q((e) => {
			e.target && !i.current && Yr(zr, r, { originalEvent: e }, { discrete: !1 });
		}, "handleFocus");
		return n.addEventListener("focusin", e), () => n.removeEventListener("focusin", e);
	}, [n, r]), {
		onFocusCapture: /* @__PURE__ */ q(() => i.current = !0, "onFocusCapture"),
		onBlurCapture: /* @__PURE__ */ q(() => i.current = !1, "onBlurCapture")
	};
}
q(qr, "useFocusOutside");
function Jr() {
	let e = new CustomEvent(Lr);
	document.dispatchEvent(e);
}
q(Jr, "dispatchUpdate");
function Yr(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? Er(i, a) : i.dispatchEvent(a);
}
q(Yr, "handleAndDispatchCustomEvent");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-focus-guards@1.1.6_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var Xr = Object.defineProperty, Zr = (e, t) => Xr(e, "name", {
	value: t,
	configurable: !0
}), Qr = 0, $r = null;
function ei(e) {
	return ti(), e.children;
}
Zr(ei, "FocusGuards");
function ti() {
	e.useEffect(() => {
		$r ||= {
			start: ni(),
			end: ni()
		};
		let { start: e, end: t } = $r;
		return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), Qr++, () => {
			Qr === 1 && ($r?.start.remove(), $r?.end.remove(), $r = null), Qr = Math.max(0, Qr - 1);
		};
	}, []);
}
Zr(ti, "useFocusGuards");
function ni() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
Zr(ni, "createFocusGuard");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-focus-scope@1.2.0_@types+react-dom@19.3.0_@types+react@19.3.0__@types+r_17bb03d71df6075c07bd134f364dcf6d/node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var ri = Object.defineProperty, J = (e, t) => ri(e, "name", {
	value: t,
	configurable: !0
}), ii = "focusScope.autoFocusOnMount", ai = "focusScope.autoFocusOnUnmount", oi = {
	bubbles: !1,
	cancelable: !0
}, si = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ J(function(t, n) {
	let { loop: r = !1, trapped: i = !1, branches: a, onMountAutoFocus: o, onUnmountAutoFocus: s, ...c } = t, [l, u] = e.useState(null), d = tr(o), p = tr(s), m = e.useRef(null), h = W(n, u), g = e.useRef(a);
	e.useEffect(() => {
		g.current = a;
	});
	let _ = e.useCallback((e) => e ? l?.contains(e) ? !0 : !!g.current?.some((t) => t.contains(e)) : !1, [l]), v = e.useRef({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	e.useEffect(() => {
		if (i) {
			let e = function(e) {
				if (v.paused || !l) return;
				let t = e.target;
				_(t) ? m.current = t : vi(m.current, { select: !0 });
			}, t = function(e) {
				if (v.paused || !l) return;
				let t = e.relatedTarget;
				t !== null && (_(t) || vi(m.current, { select: !0 }));
			}, n = function(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && vi(l);
			};
			J(e, "handleFocusIn"), J(t, "handleFocusOut"), J(n, "handleMutations"), document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return l && r.observe(l, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		i,
		l,
		v.paused,
		_
	]), e.useEffect(() => {
		if (l) {
			yi.add(v);
			let e = document.activeElement;
			if (!l.contains(e)) {
				let t = new CustomEvent(ii, oi);
				l.addEventListener(ii, d), l.dispatchEvent(t), t.defaultPrevented || (fi(Si(mi(l)), { select: !0 }), document.activeElement === e && vi(l));
			}
			return () => {
				l.removeEventListener(ii, d), setTimeout(() => {
					let t = new CustomEvent(ai, oi);
					l.addEventListener(ai, p), l.dispatchEvent(t), t.defaultPrevented || vi(e ?? document.body, { select: !0 }), l.removeEventListener(ai, p), yi.remove(v);
				}, 0);
			};
		}
	}, [
		l,
		d,
		p,
		v
	]);
	let y = e.useCallback((e) => {
		if (!r && !i || v.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, n = document.activeElement;
		if (t && n) {
			let t = e.currentTarget, [i, a] = pi(t);
			i && a ? !e.shiftKey && n === a ? (e.preventDefault(), r && vi(i, { select: !0 })) : e.shiftKey && n === i && (e.preventDefault(), r && vi(a, { select: !0 })) : n === t && e.preventDefault();
		}
	}, [
		r,
		i,
		v.paused
	]);
	return /* @__PURE__ */ f(G.div, {
		tabIndex: -1,
		...c,
		ref: h,
		onKeyDown: y
	});
}, "FocusScope")), ci = e.createContext(null);
function li({ registry: e, children: t }) {
	return e ? /* @__PURE__ */ f(ci.Provider, {
		value: e,
		children: t
	}) : t;
}
J(li, "FocusScopeBranchProvider");
function ui() {
	let [t, n] = e.useState([]);
	return {
		nodes: t,
		registry: e.useMemo(() => ({
			add: /* @__PURE__ */ J((e) => n((t) => t.includes(e) ? t : [...t, e]), "add"),
			remove: /* @__PURE__ */ J((e) => n((t) => t.filter((t) => t !== e)), "remove")
		}), [])
	};
}
J(ui, "useFocusScopeBranchRegistry");
function di(t) {
	let n = e.useContext(ci);
	e.useEffect(() => {
		if (t && n) return n.add(t), () => n.remove(t);
	}, [t, n]);
}
J(di, "useFocusScopeBranch");
function fi(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if (vi(r, { select: t }), document.activeElement !== n) return;
}
J(fi, "focusFirst");
function pi(e) {
	let t = mi(e);
	return [hi(t, e), hi(t.reverse(), e)];
}
J(pi, "getTabbableEdges");
function mi(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: /* @__PURE__ */ J((e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	}, "acceptNode") });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
J(mi, "getTabbableCandidates");
function hi(e, t) {
	let n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
	for (let r of e) if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : gi(r, { upTo: t }))) return r;
}
J(hi, "findVisible");
function gi(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
J(gi, "isHidden");
function _i(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
J(_i, "isSelectableInput");
function vi(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && _i(e) && t && e.select();
	}
}
J(vi, "focus");
var yi = bi();
function bi() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = xi(e, t), e.unshift(t);
		},
		remove(t) {
			e = xi(e, t), e[0]?.resume();
		}
	};
}
J(bi, "createFocusScopesStack");
function xi(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
J(xi, "arrayRemove");
function Si(e) {
	return e.filter((e) => e.tagName !== "A");
}
J(Si, "removeLinks");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-id@1.1.4_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-id/dist/index.mjs
var Ci = Object.defineProperty, wi = (e, t) => Ci(e, "name", {
	value: t,
	configurable: !0
}), Ti = e.useId || (() => void 0), Ei = 0;
function Y(t) {
	let [n, r] = e.useState(Ti());
	return nr(() => {
		t || r((e) => e ?? String(Ei++));
	}, [t]), t || (n ? `radix-${n}` : "");
}
wi(Y, "useId");
//#endregion
//#region ../node_modules/.pnpm/@floating-ui+utils@0.2.10/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var Di = [
	"top",
	"right",
	"bottom",
	"left"
], Oi = Math.min, ki = Math.max, Ai = Math.round, ji = Math.floor, Mi = (e) => ({
	x: e,
	y: e
}), Ni = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
}, Pi = {
	start: "end",
	end: "start"
};
function Fi(e, t, n) {
	return ki(e, Oi(t, n));
}
function Ii(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function Li(e) {
	return e.split("-")[0];
}
function Ri(e) {
	return e.split("-")[1];
}
function zi(e) {
	return e === "x" ? "y" : "x";
}
function Bi(e) {
	return e === "y" ? "height" : "width";
}
var Vi = /*#__PURE__*/ new Set(["top", "bottom"]);
function Hi(e) {
	return Vi.has(Li(e)) ? "y" : "x";
}
function Ui(e) {
	return zi(Hi(e));
}
function Wi(e, t, n) {
	n === void 0 && (n = !1);
	let r = Ri(e), i = Ui(e), a = Bi(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = $i(o)), [o, $i(o)];
}
function Gi(e) {
	let t = $i(e);
	return [
		Ki(e),
		t,
		Ki(t)
	];
}
function Ki(e) {
	return e.replace(/start|end/g, (e) => Pi[e]);
}
var qi = ["left", "right"], Ji = ["right", "left"], Yi = ["top", "bottom"], Xi = ["bottom", "top"];
function Zi(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? Ji : qi : t ? qi : Ji;
		case "left":
		case "right": return t ? Yi : Xi;
		default: return [];
	}
}
function Qi(e, t, n, r) {
	let i = Ri(e), a = Zi(Li(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(Ki)))), a;
}
function $i(e) {
	return e.replace(/left|right|bottom|top/g, (e) => Ni[e]);
}
function ea(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function ta(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : ea(e);
}
function na(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region ../node_modules/.pnpm/@floating-ui+core@1.7.3/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function ra(e, t, n) {
	let { reference: r, floating: i } = e, a = Hi(t), o = Ui(t), s = Bi(o), c = Li(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (Ri(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end": p[o] += f * (n && l ? -1 : 1);
	}
	return p;
}
var ia = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = ra(l, r, c), f = r, p = {}, m = 0;
	for (let n = 0; n < s.length; n++) {
		let { name: a, fn: h } = s[n], { x: g, y: _, data: v, reset: y } = await h({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: p,
			rects: l,
			platform: o,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = g ?? u, d = _ ?? d, p = {
			...p,
			[a]: {
				...p[a],
				...v
			}
		}, y && m <= 50 && (m++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (l = y.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : y.rects), {x: u, y: d} = ra(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: p
	};
};
async function aa(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = Ii(t, e), p = ta(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = na(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = na(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var oa = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = Ii(e, t) || {};
		if (l == null) return {};
		let d = ta(u), f = {
			x: n,
			y: r
		}, p = Ui(i), m = Bi(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = Oi(d[_], T), ee = Oi(d[v], T), D = E, te = C - h[m] - ee, O = C / 2 - h[m] / 2 + w, k = Fi(D, O, te), A = !c.arrow && Ri(i) != null && O !== k && a.reference[m] / 2 - (O < D ? E : ee) - h[m] / 2 < 0, j = A ? O < D ? O - D : O - te : 0;
		return {
			[p]: f[p] + j,
			data: {
				[p]: k,
				centerOffset: O - k - j,
				...A && { alignmentOffset: j }
			},
			reset: A
		};
	}
}), sa = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = Ii(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = Li(r), _ = Hi(o), v = Li(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [$i(o)] : Gi(o)), x = p !== "none";
			!d && x && b.push(...Qi(o, m, p, y));
			let S = [o, ...b], C = await aa(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = Wi(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (u !== "alignment" || _ === Hi(t) || T.every((e) => Hi(e.placement) !== _ || e.overflows[0] > 0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = Hi(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement": n = o;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
};
function ca(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function la(e) {
	return Di.some((t) => e[t] >= 0);
}
var ua = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n } = t, { strategy: r = "referenceHidden", ...i } = Ii(e, t);
			switch (r) {
				case "referenceHidden": {
					let e = ca(await aa(t, {
						...i,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: la(e)
					} };
				}
				case "escaped": {
					let e = ca(await aa(t, {
						...i,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: la(e)
					} };
				}
				default: return {};
			}
		}
	};
}, da = /*#__PURE__*/ new Set(["left", "top"]);
async function fa(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = Li(n), s = Ri(n), c = Hi(n) === "y", l = da.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = Ii(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var pa = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await fa(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, ma = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i } = t, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...c } = Ii(e, t), l = {
				x: n,
				y: r
			}, u = await aa(t, c), d = Hi(Li(i)), f = zi(d), p = l[f], m = l[d];
			if (a) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = p + u[e], r = p - u[t];
				p = Fi(n, p, r);
			}
			if (o) {
				let e = d === "y" ? "top" : "left", t = d === "y" ? "bottom" : "right", n = m + u[e], r = m - u[t];
				m = Fi(n, m, r);
			}
			let h = s.fn({
				...t,
				[f]: p,
				[d]: m
			});
			return {
				...h,
				data: {
					x: h.x - n,
					y: h.y - r,
					enabled: {
						[f]: a,
						[d]: o
					}
				}
			};
		}
	};
}, ha = function(e) {
	return e === void 0 && (e = {}), {
		options: e,
		fn(t) {
			let { x: n, y: r, placement: i, rects: a, middlewareData: o } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = Ii(e, t), u = {
				x: n,
				y: r
			}, d = Hi(i), f = zi(d), p = u[f], m = u[d], h = Ii(s, t), g = typeof h == "number" ? {
				mainAxis: h,
				crossAxis: 0
			} : {
				mainAxis: 0,
				crossAxis: 0,
				...h
			};
			if (c) {
				let e = f === "y" ? "height" : "width", t = a.reference[f] - a.floating[e] + g.mainAxis, n = a.reference[f] + a.reference[e] - g.mainAxis;
				p < t ? p = t : p > n && (p = n);
			}
			if (l) {
				let e = f === "y" ? "width" : "height", t = da.has(Li(i)), n = a.reference[d] - a.floating[e] + (t && o.offset?.[d] || 0) + (t ? 0 : g.crossAxis), r = a.reference[d] + a.reference[e] + (t ? 0 : o.offset?.[d] || 0) - (t ? g.crossAxis : 0);
				m < n ? m = n : m > r && (m = r);
			}
			return {
				[f]: p,
				[d]: m
			};
		}
	};
}, ga = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			var n, r;
			let { placement: i, rects: a, platform: o, elements: s } = t, { apply: c = () => {}, ...l } = Ii(e, t), u = await aa(t, l), d = Li(i), f = Ri(i), p = Hi(i) === "y", { width: m, height: h } = a.floating, g, _;
			d === "top" || d === "bottom" ? (g = d, _ = f === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (_ = d, g = f === "end" ? "top" : "bottom");
			let v = h - u.top - u.bottom, y = m - u.left - u.right, b = Oi(h - u[g], v), x = Oi(m - u[_], y), S = !t.middlewareData.shift, C = b, w = x;
			if ((n = t.middlewareData.shift) != null && n.enabled.x && (w = y), (r = t.middlewareData.shift) != null && r.enabled.y && (C = v), S && !f) {
				let e = ki(u.left, 0), t = ki(u.right, 0), n = ki(u.top, 0), r = ki(u.bottom, 0);
				p ? w = m - 2 * (e !== 0 || t !== 0 ? e + t : ki(u.left, u.right)) : C = h - 2 * (n !== 0 || r !== 0 ? n + r : ki(u.top, u.bottom));
			}
			await c({
				...t,
				availableWidth: w,
				availableHeight: C
			});
			let T = await o.getDimensions(s.floating);
			return m !== T.width || h !== T.height ? { reset: { rects: !0 } } : {};
		}
	};
};
//#endregion
//#region ../node_modules/.pnpm/@floating-ui+utils@0.2.10/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function _a() {
	return typeof window < "u";
}
function va(e) {
	return xa(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ya(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ba(e) {
	return ((xa(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function xa(e) {
	return _a() ? e instanceof Node || e instanceof ya(e).Node : !1;
}
function Sa(e) {
	return _a() ? e instanceof Element || e instanceof ya(e).Element : !1;
}
function Ca(e) {
	return _a() ? e instanceof HTMLElement || e instanceof ya(e).HTMLElement : !1;
}
function wa(e) {
	return !_a() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ya(e).ShadowRoot;
}
var Ta = /*#__PURE__*/ new Set(["inline", "contents"]);
function Ea(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = za(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Ta.has(i);
}
var Da = /*#__PURE__*/ new Set([
	"table",
	"td",
	"th"
]);
function Oa(e) {
	return Da.has(va(e));
}
var ka = [":popover-open", ":modal"];
function Aa(e) {
	return ka.some((t) => {
		try {
			return e.matches(t);
		} catch {
			return !1;
		}
	});
}
var ja = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective"
], Ma = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective",
	"filter"
], Na = [
	"paint",
	"layout",
	"strict",
	"content"
];
function Pa(e) {
	let t = Ia(), n = Sa(e) ? za(e) : e;
	return ja.some((e) => n[e] ? n[e] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Ma.some((e) => (n.willChange || "").includes(e)) || Na.some((e) => (n.contain || "").includes(e));
}
function Fa(e) {
	let t = Va(e);
	for (; Ca(t) && !Ra(t);) {
		if (Pa(t)) return t;
		if (Aa(t)) return null;
		t = Va(t);
	}
	return null;
}
function Ia() {
	return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
var La = /*#__PURE__*/ new Set([
	"html",
	"body",
	"#document"
]);
function Ra(e) {
	return La.has(va(e));
}
function za(e) {
	return ya(e).getComputedStyle(e);
}
function Ba(e) {
	return Sa(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function Va(e) {
	if (va(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || wa(e) && e.host || ba(e);
	return wa(t) ? t.host : t;
}
function Ha(e) {
	let t = Va(e);
	return Ra(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ca(t) && Ea(t) ? t : Ha(t);
}
function Ua(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = Ha(e), i = r === e.ownerDocument?.body, a = ya(r);
	if (i) {
		let e = Wa(a);
		return t.concat(a, a.visualViewport || [], Ea(r) ? r : [], e && n ? Ua(e) : []);
	}
	return t.concat(r, Ua(r, [], n));
}
function Wa(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region ../node_modules/.pnpm/@floating-ui+dom@1.7.4/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function Ga(e) {
	let t = za(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = Ca(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = Ai(n) !== a || Ai(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function Ka(e) {
	return Sa(e) ? e : e.contextElement;
}
function qa(e) {
	let t = Ka(e);
	if (!Ca(t)) return Mi(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = Ga(t), o = (a ? Ai(n.width) : n.width) / r, s = (a ? Ai(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var Ja = /*#__PURE__*/ Mi(0);
function Ya(e) {
	let t = ya(e);
	return !Ia() || !t.visualViewport ? Ja : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function Xa(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== ya(e) ? !1 : t;
}
function Za(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = Ka(e), o = Mi(1);
	t && (r ? Sa(r) && (o = qa(r)) : o = qa(e));
	let s = Xa(a, n, r) ? Ya(a) : Mi(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = ya(a), t = r && Sa(r) ? ya(r) : r, n = e, i = Wa(n);
		for (; i && r && t !== n;) {
			let e = qa(i), t = i.getBoundingClientRect(), r = za(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = ya(i), i = Wa(n);
		}
	}
	return na({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function Qa(e, t) {
	let n = Ba(e).scrollLeft;
	return t ? t.left + n : Za(ba(e)).left + n;
}
function $a(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - Qa(e, n),
		y: n.top + t.scrollTop
	};
}
function eo(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = ba(r), s = t ? Aa(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = Mi(1), u = Mi(0), d = Ca(r);
	if ((d || !d && !a) && ((va(r) !== "body" || Ea(o)) && (c = Ba(r)), Ca(r))) {
		let e = Za(r);
		l = qa(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? $a(o, c) : Mi(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function to(e) {
	return Array.from(e.getClientRects());
}
function no(e) {
	let t = ba(e), n = Ba(e), r = e.ownerDocument.body, i = ki(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = ki(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + Qa(e), s = -n.scrollTop;
	return za(r).direction === "rtl" && (o += ki(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
var ro = 25;
function io(e, t) {
	let n = ya(e), r = ba(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = Ia();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	let l = Qa(r);
	if (l <= 0) {
		let e = r.ownerDocument, t = e.body, n = getComputedStyle(t), i = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, o = Math.abs(r.clientWidth - t.clientWidth - i);
		o <= ro && (a -= o);
	} else l <= ro && (a += l);
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
var ao = /*#__PURE__*/ new Set(["absolute", "fixed"]);
function oo(e, t) {
	let n = Za(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Ca(e) ? qa(e) : Mi(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function so(e, t, n) {
	let r;
	if (t === "viewport") r = io(e, n);
	else if (t === "document") r = no(ba(e));
	else if (Sa(t)) r = oo(t, n);
	else {
		let n = Ya(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return na(r);
}
function co(e, t) {
	let n = Va(e);
	return n === t || !Sa(n) || Ra(n) ? !1 : za(n).position === "fixed" || co(n, t);
}
function lo(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = Ua(e, [], !1).filter((e) => Sa(e) && va(e) !== "body"), i = null, a = za(e).position === "fixed", o = a ? Va(e) : e;
	for (; Sa(o) && !Ra(o);) {
		let t = za(o), n = Pa(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && ao.has(i.position) || Ea(o) && !n && co(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = Va(o);
	}
	return t.set(e, r), r;
}
function uo(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Aa(t) ? [] : lo(t, this._c) : [].concat(n), r], o = a[0], s = a.reduce((e, n) => {
		let r = so(t, n, i);
		return e.top = ki(r.top, e.top), e.right = Oi(r.right, e.right), e.bottom = Oi(r.bottom, e.bottom), e.left = ki(r.left, e.left), e;
	}, so(t, o, i));
	return {
		width: s.right - s.left,
		height: s.bottom - s.top,
		x: s.left,
		y: s.top
	};
}
function fo(e) {
	let { width: t, height: n } = Ga(e);
	return {
		width: t,
		height: n
	};
}
function po(e, t, n) {
	let r = Ca(t), i = ba(t), a = n === "fixed", o = Za(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = Mi(0);
	function l() {
		c.x = Qa(i);
	}
	if (r || !r && !a) {
		if ((va(t) !== "body" || Ea(i)) && (s = Ba(t)), r) {
			let e = Za(t, !0, a, t);
			c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
		} else i && l();
	}
	a && !r && i && l();
	let u = i && !r && !a ? $a(i, s) : Mi(0);
	return {
		x: o.left + s.scrollLeft - c.x - u.x,
		y: o.top + s.scrollTop - c.y - u.y,
		width: o.width,
		height: o.height
	};
}
function mo(e) {
	return za(e).position === "static";
}
function ho(e, t) {
	if (!Ca(e) || za(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return ba(e) === n && (n = n.ownerDocument.body), n;
}
function go(e, t) {
	let n = ya(e);
	if (Aa(e)) return n;
	if (!Ca(e)) {
		let t = Va(e);
		for (; t && !Ra(t);) {
			if (Sa(t) && !mo(t)) return t;
			t = Va(t);
		}
		return n;
	}
	let r = ho(e, t);
	for (; r && Oa(r) && mo(r);) r = ho(r, t);
	return r && Ra(r) && mo(r) && !Pa(r) ? n : r || Fa(e) || n;
}
var _o = async function(e) {
	let t = this.getOffsetParent || go, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: po(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function vo(e) {
	return za(e).direction === "rtl";
}
var yo = {
	convertOffsetParentRelativeRectToViewportRelativeRect: eo,
	getDocumentElement: ba,
	getClippingRect: uo,
	getOffsetParent: go,
	getElementRects: _o,
	getClientRects: to,
	getDimensions: fo,
	getScale: qa,
	isElement: Sa,
	isRTL: vo
};
function bo(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function xo(e, t) {
	let n = null, r, i = ba(e);
	function a() {
		var e;
		clearTimeout(r), (e = n) == null || e.disconnect(), n = null;
	}
	function o(s, c) {
		s === void 0 && (s = !1), c === void 0 && (c = 1), a();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (s || t(), !f || !p) return;
		let m = ji(d), h = ji(i.clientWidth - (u + f)), g = ji(i.clientHeight - (d + p)), _ = ji(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: ki(0, Oi(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (n !== c) {
				if (!y) return o();
				n ? o(!1, n) : r = setTimeout(() => {
					o(!1, 1e-7);
				}, 1e3);
			}
			n === 1 && !bo(l, e.getBoundingClientRect()) && o(), y = !1;
		}
		try {
			n = new IntersectionObserver(b, {
				...v,
				root: i.ownerDocument
			});
		} catch {
			n = new IntersectionObserver(b, v);
		}
		n.observe(e);
	}
	return o(!0), a;
}
function So(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = Ka(e), u = i || a ? [...l ? Ua(l) : [], ...Ua(t)] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n, { passive: !0 }), a && e.addEventListener("resize", n);
	});
	let d = l && s ? xo(l, n) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), p.observe(t));
	let m, h = c ? Za(e) : null;
	c && g();
	function g() {
		let t = Za(e);
		h && !bo(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var Co = pa, wo = ma, To = sa, Eo = ga, Do = ua, Oo = oa, ko = ha, Ao = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: yo,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return ia(e, t, {
		...i,
		platform: a
	});
}, jo = typeof document < "u" ? c : function() {};
function Mo(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n !== t.length) return !1;
			for (r = n; r-- !== 0;) if (!Mo(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !Mo(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function No(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Po(e, t) {
	let n = No(e);
	return Math.round(t * n) / n;
}
function Fo(t) {
	let n = e.useRef(t);
	return jo(() => {
		n.current = t;
	}), n;
}
function Io(t) {
	t === void 0 && (t = {});
	let { placement: n = "bottom", strategy: r = "absolute", middleware: i = [], platform: a, elements: { reference: o, floating: s } = {}, transform: c = !0, whileElementsMounted: l, open: u } = t, [d, f] = e.useState({
		x: 0,
		y: 0,
		strategy: r,
		placement: n,
		middlewareData: {},
		isPositioned: !1
	}), [p, h] = e.useState(i);
	Mo(p, i) || h(i);
	let [g, _] = e.useState(null), [v, y] = e.useState(null), b = e.useCallback((e) => {
		e !== w.current && (w.current = e, _(e));
	}, []), x = e.useCallback((e) => {
		e !== T.current && (T.current = e, y(e));
	}, []), S = o || g, C = s || v, w = e.useRef(null), T = e.useRef(null), E = e.useRef(d), ee = l != null, D = Fo(l), te = Fo(a), O = Fo(u), k = e.useCallback(() => {
		if (!w.current || !T.current) return;
		let e = {
			placement: n,
			strategy: r,
			middleware: p
		};
		te.current && (e.platform = te.current), Ao(w.current, T.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: O.current !== !1
			};
			A.current && !Mo(E.current, t) && (E.current = t, m.flushSync(() => {
				f(t);
			}));
		});
	}, [
		p,
		n,
		r,
		te,
		O
	]);
	jo(() => {
		u === !1 && E.current.isPositioned && (E.current.isPositioned = !1, f((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [u]);
	let A = e.useRef(!1);
	jo(() => (A.current = !0, () => {
		A.current = !1;
	}), []), jo(() => {
		if (S && (w.current = S), C && (T.current = C), S && C) {
			if (D.current) return D.current(S, C, k);
			k();
		}
	}, [
		S,
		C,
		k,
		D,
		ee
	]);
	let j = e.useMemo(() => ({
		reference: w,
		floating: T,
		setReference: b,
		setFloating: x
	}), [b, x]), M = e.useMemo(() => ({
		reference: S,
		floating: C
	}), [S, C]), ne = e.useMemo(() => {
		let e = {
			position: r,
			left: 0,
			top: 0
		};
		if (!M.floating) return e;
		let t = Po(M.floating, d.x), n = Po(M.floating, d.y);
		return c ? {
			...e,
			transform: "translate(" + t + "px, " + n + "px)",
			...No(M.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: r,
			left: t,
			top: n
		};
	}, [
		r,
		c,
		M.floating,
		d.x,
		d.y
	]);
	return e.useMemo(() => ({
		...d,
		update: k,
		refs: j,
		elements: M,
		floatingStyles: ne
	}), [
		d,
		k,
		j,
		M,
		ne
	]);
}
var Lo = (e) => {
	function t(e) {
		return {}.hasOwnProperty.call(e, "current");
	}
	return {
		name: "arrow",
		options: e,
		fn(n) {
			let { element: r, padding: i } = typeof e == "function" ? e(n) : e;
			return r && t(r) ? r.current == null ? {} : Oo({
				element: r.current,
				padding: i
			}).fn(n) : r ? Oo({
				element: r,
				padding: i
			}).fn(n) : {};
		}
	};
}, Ro = (e, t) => ({
	...Co(e),
	options: [e, t]
}), zo = (e, t) => ({
	...wo(e),
	options: [e, t]
}), Bo = (e, t) => ({
	...ko(e),
	options: [e, t]
}), Vo = (e, t) => ({
	...To(e),
	options: [e, t]
}), Ho = (e, t) => ({
	...Eo(e),
	options: [e, t]
}), Uo = (e, t) => ({
	...Do(e),
	options: [e, t]
}), Wo = (e, t) => ({
	...Lo(e),
	options: [e, t]
}), Go = Object.defineProperty, Ko = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ((e, t) => Go(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	let { children: n, width: r = 10, height: i = 5, ...a } = e;
	return /* @__PURE__ */ f(G.svg, {
		...a,
		ref: t,
		width: r,
		height: i,
		viewBox: "0 0 30 10",
		preserveAspectRatio: "none",
		children: e.asChild ? n : /* @__PURE__ */ f("polygon", { points: "0,0 30,0 15,10" })
	});
}, "Arrow")), qo = Object.defineProperty, Jo = (e, t) => qo(e, "name", {
	value: t,
	configurable: !0
});
function Yo(t) {
	let [n, r] = e.useState(void 0);
	return nr(() => {
		if (t) {
			r({
				width: t.offsetWidth,
				height: t.offsetHeight
			});
			let e = 0, n = new ResizeObserver((n) => {
				if (!Array.isArray(n) || !n.length) return;
				let i = n[0];
				window.cancelAnimationFrame(e), e = window.requestAnimationFrame(() => {
					let e, n;
					if ("borderBoxSize" in i) {
						let t = i.borderBoxSize, r = Array.isArray(t) ? t[0] : t;
						e = r.inlineSize, n = r.blockSize;
					} else e = t.offsetWidth, n = t.offsetHeight;
					r({
						width: e,
						height: n
					});
				});
			});
			return n.observe(t, { box: "border-box" }), () => {
				window.cancelAnimationFrame(e), n.unobserve(t);
			};
		}
		r(void 0);
	}, [t]), n;
}
Jo(Yo, "useSize");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-popper@1.3.8_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@_04b331dcddb9198baac431c3d7633ae9/node_modules/@radix-ui/react-popper/dist/index.mjs
var Xo = Object.defineProperty, Zo = (e, t) => Xo(e, "name", {
	value: t,
	configurable: !0
}), Qo = {
	Partial: "partial",
	Always: "always"
}, $o = {
	Optimized: "optimized",
	Always: "always"
}, es = "Popper", [ts, ns] = /* @__PURE__ */ Zn(es), [rs, is] = ts(es), as = /* @__PURE__ */ Zo((t) => {
	let { __scopePopper: n, children: r } = t, [i, a] = e.useState(null), [o, s] = e.useState(void 0);
	return /* @__PURE__ */ f(rs, {
		scope: n,
		anchor: i,
		onAnchorChange: a,
		placementState: o,
		setPlacementState: s,
		children: r
	});
}, "Popper"), os = "PopperAnchor", ss = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Zo(function(t, n) {
	let { __scopePopper: r, virtualRef: i, ...a } = t, o = is(os, r), s = e.useRef(null), c = o.onAnchorChange, l = W(n, e.useCallback((e) => {
		s.current = e, e && c(e);
	}, [c])), u = e.useRef(null);
	e.useEffect(() => {
		if (!i) return;
		let e = u.current;
		u.current = i.current, e !== u.current && c(u.current);
	});
	let d = o.placementState && _s(o.placementState), p = d?.[0], m = d?.[1];
	return i ? null : /* @__PURE__ */ f(G.div, {
		"data-radix-popper-side": p,
		"data-radix-popper-align": m,
		...a,
		ref: l
	});
}, "PopperAnchor")), cs = "PopperContent", [ls, us] = ts(cs), ds = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Zo(function(t, n) {
	let { __scopePopper: r, side: i = "bottom", sideOffset: a = 0, align: o = "center", alignOffset: s = 0, arrowPadding: c = 0, avoidCollisions: l = !0, collisionBoundary: u = [], collisionPadding: d = 0, sticky: p = Qo.Partial, hideWhenDetached: m = !1, updatePositionStrategy: h = $o.Optimized, onPlaced: g, ..._ } = t, v = is(cs, r), [y, b] = e.useState(null), x = W(n, b), [S, C] = e.useState(null), w = Yo(S), T = w?.width ?? 0, E = w?.height ?? 0, ee = i + (o === "center" ? "" : "-" + o), D = typeof d == "number" ? d : {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...d
	}, te = Array.isArray(u) ? u : [u], O = te.length > 0, k = {
		padding: D,
		boundary: te.filter(hs),
		altBoundary: O
	}, { refs: A, floatingStyles: j, placement: M, isPositioned: ne, middlewareData: N } = Io({
		strategy: "fixed",
		placement: ee,
		whileElementsMounted: /* @__PURE__ */ Zo((...e) => So(...e, { animationFrame: h === $o.Always }), "whileElementsMounted"),
		elements: { reference: v.anchor },
		middleware: [
			Ro({
				mainAxis: a + E,
				alignmentAxis: s
			}),
			l && zo({
				mainAxis: !0,
				crossAxis: !1,
				limiter: p === Qo.Partial ? Bo() : void 0,
				...k
			}),
			l && Vo({ ...k }),
			Ho({
				...k,
				apply: /* @__PURE__ */ Zo(({ elements: e, rects: t, availableWidth: n, availableHeight: r }) => {
					let { width: i, height: a } = t.reference, o = e.floating.style;
					o.setProperty("--radix-popper-available-width", `${n}px`), o.setProperty("--radix-popper-available-height", `${r}px`), o.setProperty("--radix-popper-anchor-width", `${i}px`), o.setProperty("--radix-popper-anchor-height", `${a}px`);
				}, "apply")
			}),
			S && Wo({
				element: S,
				padding: c
			}),
			gs({
				arrowWidth: T,
				arrowHeight: E
			}),
			m && Uo({
				strategy: "referenceHidden",
				...k,
				boundary: O ? k.boundary : void 0
			})
		]
	}), re = v.setPlacementState;
	nr(() => (re(M), () => {
		re(void 0);
	}), [M, re]);
	let [ie, ae] = _s(M), oe = tr(g);
	nr(() => {
		ne && oe?.();
	}, [ne, oe]);
	let P = N.arrow?.x, F = N.arrow?.y, se = N.arrow?.centerOffset !== 0, [ce, I] = e.useState();
	return nr(() => {
		y && I(window.getComputedStyle(y).zIndex);
	}, [y]), /* @__PURE__ */ f("div", {
		ref: A.setFloating,
		"data-radix-popper-content-wrapper": "",
		style: {
			...j,
			transform: ne ? j.transform : "translate(0, -200%)",
			minWidth: "max-content",
			zIndex: ce,
			"--radix-popper-transform-origin": [N.transformOrigin?.x, N.transformOrigin?.y].join(" "),
			...N.hide?.referenceHidden && {
				visibility: "hidden",
				pointerEvents: "none"
			}
		},
		dir: t.dir,
		children: /* @__PURE__ */ f(ls, {
			scope: r,
			placedSide: ie,
			placedAlign: ae,
			onArrowChange: C,
			arrowX: P,
			arrowY: F,
			shouldHideArrow: se,
			children: /* @__PURE__ */ f(G.div, {
				"data-side": ie,
				"data-align": ae,
				..._,
				ref: x,
				style: {
					..._.style,
					animation: ne ? _.style?.animation : "none"
				}
			})
		})
	});
}, "PopperContent")), fs = "PopperArrow", ps = {
	top: "bottom",
	right: "left",
	bottom: "top",
	left: "right"
}, ms = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Zo(function(e, t) {
	let { __scopePopper: n, ...r } = e, i = us(fs, n), a = ps[i.placedSide];
	return /* @__PURE__ */ f("span", {
		ref: i.onArrowChange,
		style: {
			position: "absolute",
			left: i.arrowX,
			top: i.arrowY,
			[a]: 0,
			transformOrigin: {
				top: "",
				right: "0 0",
				bottom: "center 0",
				left: "100% 0"
			}[i.placedSide],
			transform: {
				top: "translateY(100%)",
				right: "translateY(50%) rotate(90deg) translateX(-50%)",
				bottom: "rotate(180deg)",
				left: "translateY(50%) rotate(-90deg) translateX(50%)"
			}[i.placedSide],
			visibility: i.shouldHideArrow ? "hidden" : void 0
		},
		children: /* @__PURE__ */ f(Ko, {
			...r,
			ref: t,
			style: {
				...r.style,
				display: "block"
			}
		})
	});
}, "PopperArrow"));
function hs(e) {
	return e !== null;
}
Zo(hs, "isNotNull");
var gs = /* @__PURE__ */ Zo((e) => ({
	name: "transformOrigin",
	options: e,
	fn(t) {
		let { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [c, l] = _s(n), u = {
			start: "0%",
			center: "50%",
			end: "100%"
		}[l], d = (i.arrow?.x ?? 0) + o / 2, f = (i.arrow?.y ?? 0) + s / 2, p = "", m = "";
		return c === "bottom" ? (p = a ? u : `${d}px`, m = `${-s}px`) : c === "top" ? (p = a ? u : `${d}px`, m = `${r.floating.height + s}px`) : c === "right" ? (p = `${-s}px`, m = a ? u : `${f}px`) : c === "left" && (p = `${r.floating.width + s}px`, m = a ? u : `${f}px`), { data: {
			x: p,
			y: m
		} };
	}
}), "transformOrigin");
function _s(e) {
	let [t, n = "center"] = e.split("-");
	return [t, n];
}
Zo(_s, "getSideAndAlignFromPlacement");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-portal@1.1.18_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react_8071c404ead3ecd57efdf7c5517d13a4/node_modules/@radix-ui/react-portal/dist/index.mjs
var vs = Object.defineProperty, ys = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ((e, t) => vs(e, "name", {
	value: t,
	configurable: !0
}))(function(t, n) {
	let { container: r, ...i } = t, [a, o] = e.useState(!1);
	nr(() => o(!0), []);
	let s = r || a && globalThis?.document?.body;
	return s ? m.createPortal(/* @__PURE__ */ f(G.div, {
		...i,
		ref: n
	}), s) : null;
}, "Portal")), bs = Object.defineProperty, xs = (e, t) => bs(e, "name", {
	value: t,
	configurable: !0
});
function Ss(t, n) {
	return e.useReducer((e, t) => n[e][t] ?? e, t);
}
xs(Ss, "useStateMachine");
var Cs = /* @__PURE__ */ xs((t) => {
	let { present: n, children: r } = t, i = ws(n), a = typeof r == "function" ? r({ present: i.isPresent }) : e.Children.only(r), o = Es(i.ref, Os(a));
	return typeof r == "function" || i.isPresent ? e.cloneElement(a, { ref: o }) : null;
}, "Presence");
function ws(t) {
	let [n, r] = e.useState(), i = e.useRef(null), a = e.useRef(t), o = e.useRef("none"), s = e.useRef(void 0), [c, l] = Ss(t ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return e.useEffect(() => {
		c === "mounted" ? (o.current = s.current ?? Ds(i.current), s.current = void 0) : o.current = "none";
	}, [c]), nr(() => {
		let e = i.current, n = a.current;
		if (n !== t) {
			let r = o.current, i = Ds(e);
			t ? (s.current = i, l("MOUNT")) : i === "none" || e?.display === "none" ? l("UNMOUNT") : l(n && r !== i ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
		}
	}, [t, l]), nr(() => {
		if (n) {
			let e, t = n.ownerDocument.defaultView ?? window, r = /* @__PURE__ */ xs((r) => {
				let o = Ds(i.current).includes(CSS.escape(r.animationName));
				if (r.target === n && o && (l("ANIMATION_END"), !a.current)) {
					let r = n.style.animationFillMode;
					n.style.animationFillMode = "forwards", e = t.setTimeout(() => {
						n.style.animationFillMode === "forwards" && (n.style.animationFillMode = r);
					});
				}
			}, "handleAnimationEnd"), s = /* @__PURE__ */ xs((e) => {
				e.target === n && (o.current = Ds(i.current));
			}, "handleAnimationStart");
			return n.addEventListener("animationstart", s), n.addEventListener("animationcancel", r), n.addEventListener("animationend", r), () => {
				t.clearTimeout(e), n.removeEventListener("animationstart", s), n.removeEventListener("animationcancel", r), n.removeEventListener("animationend", r);
			};
		}
		l("ANIMATION_END");
	}, [n, l]), {
		isPresent: ["mounted", "unmountSuspended"].includes(c),
		ref: e.useCallback((e) => {
			if (e) {
				let t = getComputedStyle(e);
				i.current = t, s.current = Ds(t);
			} else i.current = null;
			r(e);
		}, [])
	};
}
xs(ws, "usePresence");
function Ts(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
xs(Ts, "setRef");
function Es(...t) {
	let n = e.useRef(t);
	return n.current = t, e.useCallback((e) => {
		let t = n.current, r = !1, i = t.map((t) => {
			let n = Ts(t, e);
			return !r && typeof n == "function" && (r = !0), n;
		});
		if (r) return () => {
			for (let e = 0; e < i.length; e++) {
				let n = i[e];
				typeof n == "function" ? n() : Ts(t[e], null);
			}
		};
	}, []);
}
xs(Es, "useStableComposedRefs");
function Ds(e) {
	return e?.animationName || "none";
}
xs(Ds, "getAnimationName");
function Os(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
xs(Os, "getElementRef");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-use-effect-event@0.0.5_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-use-effect-event/dist/index.mjs
var ks = Object.defineProperty, As = (e, t) => ks(e, "name", {
	value: t,
	configurable: !0
}), js = e.useEffectEvent, Ms = e.useInsertionEffect;
function Ns(t) {
	if (typeof js == "function") return js(t);
	let n = e.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof Ms == "function" ? Ms(() => {
		n.current = t;
	}) : nr(() => {
		n.current = t;
	}), e.useMemo(() => ((...e) => n.current?.(...e)), []);
}
As(Ns, "useEffectEvent");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-use-controllable-state@1.2.6_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var Ps = Object.defineProperty, Fs = (e, t) => Ps(e, "name", {
	value: t,
	configurable: !0
}), Is = e.useInsertionEffect || nr;
function Ls({ prop: t, defaultProp: n, onChange: r = /* @__PURE__ */ Fs(() => {}, "onChange"), caller: i }) {
	let [a, o, s] = Rs({
		defaultProp: n,
		onChange: r
	}), c = t !== void 0;
	return [c ? t : a, e.useCallback((e) => {
		if (c) {
			let n = zs(e) ? e(t) : e;
			n !== t && s.current?.(n);
		} else o(e);
	}, [
		c,
		t,
		o,
		s
	])];
}
Fs(Ls, "useControllableState");
function Rs({ defaultProp: t, onChange: n }) {
	let [r, i] = e.useState(t), a = e.useRef(r), o = e.useRef(n);
	return Is(() => {
		o.current = n;
	}, [n]), e.useEffect(() => {
		a.current !== r && (o.current?.(r), a.current = r);
	}, [r, a]), [
		r,
		i,
		o
	];
}
Fs(Rs, "useUncontrolledState");
function zs(e) {
	return typeof e == "function";
}
Fs(zs, "isFunction");
var Bs = Symbol("RADIX:SYNC_STATE");
function Vs(t, n, r, i) {
	let { prop: a, defaultProp: o, onChange: s, caller: c } = n, l = a !== void 0, u = Ns(s), d = [{
		...r,
		state: o
	}];
	i && d.push(i);
	let [f, p] = e.useReducer((e, n) => {
		if (n.type === Bs) return {
			...e,
			state: n.state
		};
		let r = t(e, n);
		return l && !Object.is(r.state, e.state) && u(r.state), r;
	}, ...d), m = f.state, h = e.useRef(m);
	e.useEffect(() => {
		h.current !== m && (h.current = m, l || u(m));
	}, [
		m,
		h,
		l
	]);
	let g = e.useMemo(() => a === void 0 ? f : {
		...f,
		state: a
	}, [f, a]);
	return e.useEffect(() => {
		l && !Object.is(a, f.state) && p({
			type: Bs,
			state: a
		});
	}, [
		a,
		f.state,
		l
	]), [g, p];
}
Fs(Vs, "useControllableStateReducer");
//#endregion
//#region ../node_modules/.pnpm/aria-hidden@1.2.6/node_modules/aria-hidden/dist/es2015/index.js
var Hs = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, Us = /* @__PURE__ */ new WeakMap(), Ws = /* @__PURE__ */ new WeakMap(), Gs = {}, Ks = 0, qs = function(e) {
	return e && (e.host || qs(e.parentNode));
}, Js = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = qs(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, Ys = function(e, t, n, r) {
	var i = Js(t, Array.isArray(e) ? e : [e]);
	Gs[n] || (Gs[n] = /* @__PURE__ */ new WeakMap());
	var a = Gs[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		e && !s.has(e) && (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		e && !c.has(e) && Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (Us.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				Us.set(e, c), a.set(e, l), o.push(e), c === 1 && i && Ws.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), Ks++, function() {
		o.forEach(function(e) {
			var t = Us.get(e) - 1, i = a.get(e) - 1;
			Us.set(e, t), a.set(e, i), t || (Ws.has(e) || e.removeAttribute(r), Ws.delete(e)), i || e.removeAttribute(n);
		}), Ks--, Ks || (Us = /* @__PURE__ */ new WeakMap(), Us = /* @__PURE__ */ new WeakMap(), Ws = /* @__PURE__ */ new WeakMap(), Gs = {});
	};
}, Xs = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || Hs(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), Ys(r, i, n, "aria-hidden")) : function() {
		return null;
	};
}, Zs = function() {
	return Zs = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, Zs.apply(this, arguments);
};
function Qs(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function $s(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
//#endregion
//#region ../node_modules/.pnpm/react-remove-scroll-bar@2.3.8_@types+react@19.3.0_react@19.3.0/node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var ec = "right-scroll-bar-position", tc = "width-before-scroll-bar", nc = "with-scroll-bars-hidden", rc = "--removed-body-scroll-bar-size";
//#endregion
//#region ../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.3.0_react@19.3.0/node_modules/use-callback-ref/dist/es2015/assignRef.js
function ic(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
//#endregion
//#region ../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.3.0_react@19.3.0/node_modules/use-callback-ref/dist/es2015/useRef.js
function ac(e, t) {
	var n = u(function() {
		return {
			value: e,
			callback: t,
			facade: {
				get current() {
					return n.value;
				},
				set current(e) {
					var t = n.value;
					t !== e && (n.value = e, n.callback(e, t));
				}
			}
		};
	})[0];
	return n.callback = t, n.facade;
}
//#endregion
//#region ../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.3.0_react@19.3.0/node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var oc = typeof window < "u" ? e.useLayoutEffect : e.useEffect, sc = /* @__PURE__ */ new WeakMap();
function cc(e, t) {
	var n = ac(t || null, function(t) {
		return e.forEach(function(e) {
			return ic(e, t);
		});
	});
	return oc(function() {
		var t = sc.get(n);
		if (t) {
			var r = new Set(t), i = new Set(e), a = n.current;
			r.forEach(function(e) {
				i.has(e) || ic(e, null);
			}), i.forEach(function(e) {
				r.has(e) || ic(e, a);
			});
		}
		sc.set(n, e);
	}, [e]), n;
}
//#endregion
//#region ../node_modules/.pnpm/use-sidecar@1.1.3_@types+react@19.3.0_react@19.3.0/node_modules/use-sidecar/dist/es2015/medium.js
function lc(e) {
	return e;
}
function uc(e, t) {
	t === void 0 && (t = lc);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function dc(e) {
	e === void 0 && (e = {});
	var t = uc(null);
	return t.options = Zs({
		async: !0,
		ssr: !1
	}, e), t;
}
//#endregion
//#region ../node_modules/.pnpm/use-sidecar@1.1.3_@types+react@19.3.0_react@19.3.0/node_modules/use-sidecar/dist/es2015/exports.js
var fc = function(t) {
	var n = t.sideCar, r = Qs(t, ["sideCar"]);
	if (!n) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var i = n.read();
	if (!i) throw Error("Sidecar medium not found");
	return e.createElement(i, Zs({}, r));
};
fc.isSideCarExport = !0;
function pc(e, t) {
	return e.useMedium(t), fc;
}
//#endregion
//#region ../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.3.0_react@19.3.0/node_modules/react-remove-scroll/dist/es2015/medium.js
var mc = dc(), hc = function() {}, gc = e.forwardRef(function(t, n) {
	var r = e.useRef(null), i = e.useState({
		onScrollCapture: hc,
		onWheelCapture: hc,
		onTouchMoveCapture: hc
	}), a = i[0], o = i[1], s = t.forwardProps, c = t.children, l = t.className, u = t.removeScrollBar, d = t.enabled, f = t.shards, p = t.sideCar, m = t.noRelative, h = t.noIsolation, g = t.inert, _ = t.allowPinchZoom, v = t.as, y = v === void 0 ? "div" : v, b = t.gapMode, x = Qs(t, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noRelative",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as",
		"gapMode"
	]), S = p, C = cc([r, n]), w = Zs(Zs({}, x), a);
	return e.createElement(e.Fragment, null, d && e.createElement(S, {
		sideCar: mc,
		removeScrollBar: u,
		shards: f,
		noRelative: m,
		noIsolation: h,
		inert: g,
		setCallbacks: o,
		allowPinchZoom: !!_,
		lockRef: r,
		gapMode: b
	}), s ? e.cloneElement(e.Children.only(c), Zs(Zs({}, w), { ref: C })) : e.createElement(y, Zs({}, w, {
		className: l,
		ref: C
	}), c));
});
gc.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, gc.classNames = {
	fullWidth: tc,
	zeroRight: ec
};
//#endregion
//#region ../node_modules/.pnpm/get-nonce@1.0.1/node_modules/get-nonce/dist/es2015/index.js
var _c = function() {
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
//#endregion
//#region ../node_modules/.pnpm/react-style-singleton@2.2.3_@types+react@19.3.0_react@19.3.0/node_modules/react-style-singleton/dist/es2015/singleton.js
function vc() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = _c();
	return t && e.setAttribute("nonce", t), e;
}
function yc(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function bc(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var xc = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = vc()) && (yc(t, n), bc(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, Sc = function() {
	var t = xc();
	return function(n, r) {
		e.useEffect(function() {
			return t.add(n), function() {
				t.remove();
			};
		}, [n && r]);
	};
}, Cc = function() {
	var e = Sc();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, wc = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, Tc = function(e) {
	return parseInt(e || "", 10) || 0;
}, Ec = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		Tc(n),
		Tc(r),
		Tc(i)
	];
}, Dc = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return wc;
	var t = Ec(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, Oc = Cc(), kc = "data-scroll-locked", Ac = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${nc} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body[${kc}] {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${ec} {
    right: ${s}px ${r};
  }
  
  .${tc} {
    margin-right: ${s}px ${r};
  }
  
  .${ec} .${ec} {
    right: 0 ${r};
  }
  
  .${tc} .${tc} {
    margin-right: 0 ${r};
  }
  
  body[${kc}] {
    ${rc}: ${s}px;
  }
`;
}, jc = function() {
	var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
	return isFinite(e) ? e : 0;
}, Mc = function() {
	e.useEffect(function() {
		return document.body.setAttribute(kc, (jc() + 1).toString()), function() {
			var e = jc() - 1;
			e <= 0 ? document.body.removeAttribute(kc) : document.body.setAttribute(kc, e.toString());
		};
	}, []);
}, Nc = function(t) {
	var n = t.noRelative, r = t.noImportant, i = t.gapMode, a = i === void 0 ? "margin" : i;
	Mc();
	var o = e.useMemo(function() {
		return Dc(a);
	}, [a]);
	return e.createElement(Oc, { styles: Ac(o, !n, a, r ? "" : "!important") });
}, Pc = !1;
if (typeof window < "u") try {
	var Fc = Object.defineProperty({}, "passive", { get: function() {
		return Pc = !0, !0;
	} });
	window.addEventListener("test", Fc, Fc), window.removeEventListener("test", Fc, Fc);
} catch {
	Pc = !1;
}
var Ic = Pc ? { passive: !1 } : !1, Lc = function(e) {
	return e.tagName === "TEXTAREA";
}, Rc = function(e, t) {
	if (!(e instanceof Element)) return !1;
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !Lc(e) && n[t] === "visible");
}, zc = function(e) {
	return Rc(e, "overflowY");
}, Bc = function(e) {
	return Rc(e, "overflowX");
}, Vc = function(e, t) {
	var n = t.ownerDocument, r = t;
	do {
		if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), Wc(e, r)) {
			var i = Gc(e, r);
			if (i[1] > i[2]) return !0;
		}
		r = r.parentNode;
	} while (r && r !== n.body);
	return !1;
}, Hc = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, Uc = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, Wc = function(e, t) {
	return e === "v" ? zc(t) : Bc(t);
}, Gc = function(e, t) {
	return e === "v" ? Hc(t) : Uc(t);
}, Kc = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, qc = function(e, t, n, r, i) {
	var a = Kc(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		if (!s) break;
		var p = Gc(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && Wc(e, s) && (d += h, f += m);
		var g = s.parentNode;
		s = g && g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? g.host : g;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && Math.abs(d) < 1 || !i && o > d) || !u && (i && Math.abs(f) < 1 || !i && -o > f)) && (l = !0), l;
}, Jc = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Yc = function(e) {
	return [e.deltaX, e.deltaY];
}, Xc = function(e) {
	return e && "current" in e ? e.current : e;
}, Zc = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, Qc = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, $c = 0, el = [];
function tl(t) {
	var n = e.useRef([]), r = e.useRef([0, 0]), i = e.useRef(), a = e.useState($c++)[0], o = e.useState(Cc)[0], s = e.useRef(t);
	e.useEffect(function() {
		s.current = t;
	}, [t]), e.useEffect(function() {
		if (t.inert) {
			document.body.classList.add(`block-interactivity-${a}`);
			var e = $s([t.lockRef.current], (t.shards || []).map(Xc), !0).filter(Boolean);
			return e.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${a}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${a}`), e.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${a}`);
				});
			};
		}
	}, [
		t.inert,
		t.lockRef.current,
		t.shards
	]);
	var c = e.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !s.current.allowPinchZoom;
		var n = Jc(e), a = r.current, o = "deltaX" in e ? e.deltaX : a[0] - n[0], c = "deltaY" in e ? e.deltaY : a[1] - n[1], l, u = e.target, d = Math.abs(o) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = window.getSelection(), p = f && f.anchorNode;
		if (p && (p === u || p.contains(u))) return !1;
		var m = Vc(d, u);
		if (!m) return !0;
		if (m ? l = d : (l = d === "v" ? "h" : "v", m = Vc(d, u)), !m) return !1;
		if (!i.current && "changedTouches" in e && (o || c) && (i.current = l), !l) return !0;
		var h = i.current || l;
		return qc(h, t, e, h === "h" ? o : c, !0);
	}, []), l = e.useCallback(function(e) {
		var t = e;
		if (el.length && el[el.length - 1] === o) {
			var r = "deltaY" in t ? Yc(t) : Jc(t), i = n.current.filter(function(e) {
				return e.name === t.type && (e.target === t.target || t.target === e.shadowParent) && Zc(e.delta, r);
			})[0];
			if (i && i.should) t.cancelable && t.preventDefault();
			else if (!i) {
				var a = (s.current.shards || []).map(Xc).filter(Boolean).filter(function(e) {
					return e.contains(t.target);
				});
				(a.length > 0 ? c(t, a[0]) : !s.current.noIsolation) && t.cancelable && t.preventDefault();
			}
		}
	}, []), u = e.useCallback(function(e, t, r, i) {
		var a = {
			name: e,
			delta: t,
			target: r,
			should: i,
			shadowParent: nl(r)
		};
		n.current.push(a), setTimeout(function() {
			n.current = n.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), d = e.useCallback(function(e) {
		r.current = Jc(e), i.current = void 0;
	}, []), f = e.useCallback(function(e) {
		u(e.type, Yc(e), e.target, c(e, t.lockRef.current));
	}, []), p = e.useCallback(function(e) {
		u(e.type, Jc(e), e.target, c(e, t.lockRef.current));
	}, []);
	e.useEffect(function() {
		return el.push(o), t.setCallbacks({
			onScrollCapture: f,
			onWheelCapture: f,
			onTouchMoveCapture: p
		}), document.addEventListener("wheel", l, Ic), document.addEventListener("touchmove", l, Ic), document.addEventListener("touchstart", d, Ic), function() {
			el = el.filter(function(e) {
				return e !== o;
			}), document.removeEventListener("wheel", l, Ic), document.removeEventListener("touchmove", l, Ic), document.removeEventListener("touchstart", d, Ic);
		};
	}, []);
	var m = t.removeScrollBar, h = t.inert;
	return e.createElement(e.Fragment, null, h ? e.createElement(o, { styles: Qc(a) }) : null, m ? e.createElement(Nc, {
		noRelative: t.noRelative,
		gapMode: t.gapMode
	}) : null);
}
function nl(e) {
	for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
	return t;
}
//#endregion
//#region ../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.3.0_react@19.3.0/node_modules/react-remove-scroll/dist/es2015/sidecar.js
var rl = pc(mc, tl), il = e.forwardRef(function(t, n) {
	return e.createElement(gc, Zs({}, t, {
		ref: n,
		sideCar: rl
	}));
});
il.classNames = gc.classNames;
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-popover@1.2.0_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react_a8ff70808089aae633d13b9a606299ae/node_modules/@radix-ui/react-popover/dist/index.mjs
var al = Object.defineProperty, ol = (e, t) => al(e, "name", {
	value: t,
	configurable: !0
}), sl = "Popover", [cl, ll] = /* @__PURE__ */ Zn(sl, [ns]), ul = ns(), [dl, fl] = cl(sl), pl = /* @__PURE__ */ ol((t) => {
	let { __scopePopover: n, children: r, open: i, defaultOpen: a, onOpenChange: o, modal: s = !1 } = t, c = ul(n), l = e.useRef(null), [u, d] = e.useState(!1), [p, m] = e.useState(0), [h, g] = e.useState(0), [_, v] = Ls({
		prop: i,
		defaultProp: a ?? !1,
		onChange: o,
		caller: sl
	});
	return /* @__PURE__ */ f(as, {
		...c,
		children: /* @__PURE__ */ f(dl, {
			scope: n,
			contentId: Y(),
			titleId: Y(),
			descriptionId: Y(),
			titlePresent: p > 0,
			descriptionPresent: h > 0,
			setTitleCount: m,
			setDescriptionCount: g,
			triggerRef: l,
			open: _,
			onOpenChange: v,
			onOpenToggle: e.useCallback(() => v((e) => !e), [v]),
			hasCustomAnchor: u,
			onCustomAnchorAdd: e.useCallback(() => d(!0), []),
			onCustomAnchorRemove: e.useCallback(() => d(!1), []),
			modal: s,
			children: r
		})
	});
}, "Popover"), ml = "PopoverAnchor", hl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ol(function(t, n) {
	let { __scopePopover: r, ...i } = t, a = fl(ml, r), o = ul(r), { onCustomAnchorAdd: s, onCustomAnchorRemove: c } = a;
	return e.useEffect(() => (s(), () => c()), [s, c]), /* @__PURE__ */ f(ss, {
		...o,
		...i,
		ref: n
	});
}, "PopoverAnchor")), gl = "PopoverTrigger", _l = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ol(function(e, t) {
	let { __scopePopover: n, ...r } = e, i = fl(gl, n), a = ul(n), o = W(t, i.triggerRef), s = /* @__PURE__ */ f(G.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": i.open,
		"aria-controls": i.open ? i.contentId : void 0,
		"data-state": jl(i.open),
		...r,
		ref: o,
		onClick: K(e.onClick, i.onOpenToggle)
	});
	return i.hasCustomAnchor ? s : /* @__PURE__ */ f(ss, {
		asChild: !0,
		...a,
		children: s
	});
}, "PopoverTrigger")), vl = "PopoverPortal", [yl, bl] = cl(vl, { forceMount: void 0 }), xl = /* @__PURE__ */ ol((e) => {
	let { __scopePopover: t, forceMount: n, children: r, container: i } = e, a = fl(vl, t);
	return /* @__PURE__ */ f(yl, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ f(Cs, {
			present: n || a.open,
			children: /* @__PURE__ */ f(ys, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "PopoverPortal"), Sl = "PopoverContent", Cl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ol(function(e, t) {
	let n = bl(Sl, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, a = fl(Sl, e.__scopePopover);
	return /* @__PURE__ */ f(Cs, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ f(Tl, {
			...i,
			ref: t
		}) : /* @__PURE__ */ f(El, {
			...i,
			ref: t
		})
	});
}, "PopoverContent")), wl = /* @__PURE__ */ lr("PopoverContent.RemoveScroll"), Tl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ol(function(t, n) {
	let r = fl(Sl, t.__scopePopover), i = e.useRef(null), a = W(n, i), o = e.useRef(!1), { nodes: s, registry: c } = ui();
	return e.useEffect(() => {
		let e = i.current;
		if (e) return Xs(e);
	}, []), /* @__PURE__ */ f(il, {
		as: wl,
		allowPinchZoom: !0,
		shards: e.useMemo(() => [i, ...s.map((e) => ({ current: e }))], [i, s]),
		children: /* @__PURE__ */ f(Dl, {
			...t,
			ref: a,
			branchNodes: s,
			branchRegistry: c,
			trapFocus: r.open,
			disableOutsidePointerEvents: !0,
			onCloseAutoFocus: K(t.onCloseAutoFocus, (e) => {
				e.preventDefault(), o.current || r.triggerRef.current?.focus();
			}),
			onPointerDownOutside: K(t.onPointerDownOutside, (e) => {
				let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, r = t.button === 2 || n;
				o.current = r;
			}, { checkForDefaultPrevented: !1 }),
			onFocusOutside: K(t.onFocusOutside, (e) => e.preventDefault(), { checkForDefaultPrevented: !1 })
		})
	});
}, "PopoverContentModal")), El = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ol(function(t, n) {
	let r = fl(Sl, t.__scopePopover), i = e.useRef(!1), a = e.useRef(!1);
	return /* @__PURE__ */ f(Dl, {
		...t,
		ref: n,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (e) => {
			t.onCloseAutoFocus?.(e), e.defaultPrevented || (i.current || r.triggerRef.current?.focus(), e.preventDefault()), i.current = !1, a.current = !1;
		},
		onInteractOutside: (e) => {
			t.onInteractOutside?.(e), e.defaultPrevented || (i.current = !0, e.detail.originalEvent.type === "pointerdown" && (a.current = !0));
			let n = e.target;
			r.triggerRef.current?.contains(n) && e.preventDefault(), e.detail.originalEvent.type === "focusin" && a.current && e.preventDefault();
		}
	});
}, "PopoverContentNonModal")), Dl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ol(function(t, n) {
	let { __scopePopover: r, trapFocus: i, onOpenAutoFocus: a, onCloseAutoFocus: o, disableOutsidePointerEvents: s, onEscapeKeyDown: c, onPointerDownOutside: l, onFocusOutside: u, onInteractOutside: d, "aria-describedby": p, branchNodes: m, branchRegistry: h, ...g } = t, _ = fl(Sl, r), v = ul(r), [y, b] = e.useState(null), x = W(n, b);
	return di(y), ti(), /* @__PURE__ */ f(li, {
		registry: h,
		children: /* @__PURE__ */ f(si, {
			asChild: !0,
			loop: !0,
			trapped: i,
			branches: m,
			onMountAutoFocus: a,
			onUnmountAutoFocus: o,
			children: /* @__PURE__ */ f(Hr, {
				asChild: !0,
				disableOutsidePointerEvents: s,
				onInteractOutside: d,
				onEscapeKeyDown: c,
				onPointerDownOutside: l,
				onFocusOutside: u,
				onDismiss: () => _.onOpenChange(!1),
				deferPointerDownOutside: !0,
				children: /* @__PURE__ */ f(ds, {
					"data-state": jl(_.open),
					role: "dialog",
					id: _.contentId,
					"aria-labelledby": _.titlePresent ? _.titleId : void 0,
					"aria-describedby": _.descriptionPresent ? Ml(p, _.descriptionId) : p,
					...v,
					...g,
					ref: x,
					style: {
						...g.style,
						"--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
						"--radix-popover-content-available-width": "var(--radix-popper-available-width)",
						"--radix-popover-content-available-height": "var(--radix-popper-available-height)",
						"--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
						"--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
					}
				})
			})
		})
	});
}, "PopoverContentImpl")), Ol = "PopoverClose", kl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ol(function(e, t) {
	let { __scopePopover: n, ...r } = e, i = fl(Ol, n);
	return /* @__PURE__ */ f(G.button, {
		type: "button",
		...r,
		ref: t,
		onClick: K(e.onClick, () => i.onOpenChange(!1))
	});
}, "PopoverClose")), Al = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ol(function(e, t) {
	let { __scopePopover: n, ...r } = e, i = ul(n);
	return /* @__PURE__ */ f(ms, {
		...i,
		...r,
		ref: t
	});
}, "PopoverArrow"));
function jl(e) {
	return e ? "open" : "closed";
}
ol(jl, "getState");
function Ml(...e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e) if (typeof n == "string") for (let e of String(n).trim().split(/\s+/)) e && t.add(e);
	return t.size > 0 ? Array.from(t).join(" ") : void 0;
}
ol(Ml, "concatAriaDescribedby");
//#endregion
//#region src/components/atoms/Popover/Popover.tsx
var Nl = pl, Pl = _l, Fl = hl, Il = kl, Ll = r(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, i) => /* @__PURE__ */ f(xl, { children: /* @__PURE__ */ f(Cl, {
	ref: i,
	align: t,
	sideOffset: n,
	className: V("z-50 w-72 rounded-md border p-4 shadow-md outline-none", "border-slate-200 bg-white text-slate-950", "dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50", "data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95", "data-[side=bottom]:slide-in-from-top-2", "data-[side=left]:slide-in-from-right-2", "data-[side=right]:slide-in-from-left-2", "data-[side=top]:slide-in-from-bottom-2", e),
	...r
}) }));
Ll.displayName = "PopoverContent";
var Rl = r(({ className: e, ...t }, n) => /* @__PURE__ */ f(Al, {
	ref: n,
	className: V("fill-white dark:fill-slate-950", e),
	...t
}));
Rl.displayName = "PopoverArrow";
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-checkbox@1.3.12_@types+react-dom@19.3.0_@types+react@19.3.0__@types+rea_8e7decfe55428655a0dd8868fe7c2c70/node_modules/@radix-ui/react-checkbox/dist/index.mjs
var zl = Object.defineProperty, Bl = (e, t) => zl(e, "name", {
	value: t,
	configurable: !0
}), Vl = "Checkbox", [Hl, Ul] = /* @__PURE__ */ Zn(Vl), [Wl, Gl] = Hl(Vl);
function Kl(t) {
	let { __scopeCheckbox: n, checked: r, children: i, defaultChecked: a, disabled: o, form: s, name: c, onCheckedChange: l, required: u, value: d = "on", internal_do_not_use_render: p } = t, [m, h] = Ls({
		prop: r,
		defaultProp: a ?? !1,
		onChange: l,
		caller: Vl
	}), [g, _] = e.useState(null), [v, y] = e.useState(null), b = e.useRef(!1), [x, S] = e.useReducer((e) => e + 1, 0), C = !g || !!s || !!g.closest("form"), w = {
		checked: m,
		disabled: o,
		setChecked: h,
		control: g,
		setControl: _,
		name: c,
		form: s,
		value: d,
		hasConsumerStoppedPropagationRef: b,
		userInteractionCount: x,
		onUserInteraction: S,
		required: u,
		defaultChecked: !tu(a) && a,
		isFormControl: C,
		bubbleInput: v,
		setBubbleInput: y
	};
	return /* @__PURE__ */ f(Wl, {
		scope: n,
		...w,
		children: eu(p) ? p(w) : i
	});
}
Bl(Kl, "CheckboxProvider");
var ql = "CheckboxTrigger", Jl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Bl(function({ __scopeCheckbox: t, onKeyDown: n, onClick: r, ...i }, a) {
	let { control: o, value: s, disabled: c, checked: l, required: u, setControl: d, setChecked: p, hasConsumerStoppedPropagationRef: m, onUserInteraction: h, isFormControl: g, bubbleInput: _ } = Gl(ql, t), v = W(a, d), y = e.useRef(l);
	return e.useEffect(() => {
		let e = o?.form;
		if (e) {
			let t = /* @__PURE__ */ Bl(() => p(y.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [o, p]), /* @__PURE__ */ f(G.button, {
		type: "button",
		role: "checkbox",
		"aria-checked": tu(l) ? "mixed" : l,
		"aria-required": u,
		"data-state": nu(l),
		"data-disabled": c ? "" : void 0,
		disabled: c,
		value: s,
		...i,
		ref: v,
		onKeyDown: K(n, (e) => {
			e.key === "Enter" && e.preventDefault();
		}),
		onClick: K(r, (e) => {
			h(), p((e) => tu(e) ? !0 : !e), _ && g && (m.current = e.isPropagationStopped(), m.current || e.stopPropagation());
		})
	});
}, "CheckboxTrigger")), Yl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Bl(function(e, t) {
	let { __scopeCheckbox: n, name: r, checked: i, defaultChecked: a, required: o, disabled: s, value: c, onCheckedChange: l, form: u, ...m } = e;
	return /* @__PURE__ */ f(Kl, {
		__scopeCheckbox: n,
		checked: i,
		defaultChecked: a,
		disabled: s,
		required: o,
		onCheckedChange: l,
		name: r,
		form: u,
		value: c,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ p(d, { children: [/* @__PURE__ */ f(Jl, {
			...m,
			ref: t,
			__scopeCheckbox: n
		}), e && /* @__PURE__ */ f($l, { __scopeCheckbox: n })] })
	});
}, "Checkbox")), Xl = "CheckboxIndicator", Zl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Bl(function(e, t) {
	let { __scopeCheckbox: n, forceMount: r, ...i } = e, a = Gl(Xl, n);
	return /* @__PURE__ */ f(Cs, {
		present: r || tu(a.checked) || a.checked === !0,
		children: /* @__PURE__ */ f(G.span, {
			"data-state": nu(a.checked),
			"data-disabled": a.disabled ? "" : void 0,
			...i,
			ref: t,
			style: {
				pointerEvents: "none",
				...e.style
			}
		})
	});
}, "CheckboxIndicator")), Ql = "CheckboxBubbleInput", $l = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Bl(function({ __scopeCheckbox: t, onClick: n, ...r }, i) {
	let { control: a, hasConsumerStoppedPropagationRef: o, userInteractionCount: s, checked: c, defaultChecked: l, required: u, disabled: d, name: p, value: m, form: h, bubbleInput: g, setBubbleInput: _ } = Gl(Ql, t), v = W(i, _), y = Yo(a), b = e.useRef(!1), x = e.useRef(c), S = e.useRef(s);
	e.useEffect(() => {
		let e = g;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "checked").set, r = s !== S.current;
		S.current = s;
		let i = x.current !== c;
		x.current = c;
		let a = !(r && o.current);
		if (i && n) {
			b.current = !r;
			let t = new Event("click", { bubbles: a });
			e.indeterminate = tu(c), n.call(e, !tu(c) && c), e.dispatchEvent(t), b.current = !1;
		}
	}, [
		g,
		c,
		o,
		s
	]);
	let C = e.useRef(!tu(c) && c);
	return /* @__PURE__ */ f(G.input, {
		type: "checkbox",
		"aria-hidden": !0,
		defaultChecked: l ?? C.current,
		required: u,
		disabled: d,
		name: p,
		value: m,
		form: h,
		...r,
		tabIndex: -1,
		ref: v,
		onClick: K(n, (e) => {
			b.current && e.stopPropagation();
		}),
		style: {
			...r.style,
			...y,
			position: "absolute",
			pointerEvents: "none",
			opacity: 0,
			margin: 0,
			transform: "translateX(-100%)"
		}
	});
}, "CheckboxBubbleInput"));
function eu(e) {
	return typeof e == "function";
}
Bl(eu, "isFunction");
function tu(e) {
	return e === "indeterminate";
}
Bl(tu, "isIndeterminate");
function nu(e) {
	return tu(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
Bl(nu, "getState");
//#endregion
//#region src/components/atoms/Checkbox/Checkbox.tsx
var ru = r(({ className: e, label: t, id: n, ...r }, i) => {
	let a = n || t?.toLowerCase().replace(/\s+/g, "-");
	return /* @__PURE__ */ p("div", {
		className: "flex items-center gap-2",
		children: [/* @__PURE__ */ f(Yl, {
			ref: i,
			id: a,
			className: V("h-5 w-5 shrink-0 rounded border border-border-hover", "bg-[var(--field-bg)]", "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[color:var(--ring-color)] focus-visible:ring-offset-1 focus-visible:ring-offset-surface", "disabled:cursor-not-allowed disabled:opacity-50", "data-[state=checked]:bg-[var(--action-primary)] data-[state=checked]:border-[var(--action-primary)]", "transition-colors", e),
			...r,
			children: /* @__PURE__ */ f(Zl, {
				className: "flex items-center justify-center text-[var(--action-primary-fg)]",
				children: /* @__PURE__ */ f(Gt, { className: "h-4 w-4" })
			})
		}), t && /* @__PURE__ */ f("label", {
			htmlFor: a,
			className: "text-sm text-text-secondary cursor-pointer",
			children: t
		})]
	});
});
ru.displayName = "Checkbox";
//#endregion
//#region src/components/atoms/Input/Input.tsx
var iu = r(({ className: e, variant: t, size: n, hasError: r, hasIcon: i, type: a = "text", error: o, label: s, id: c, ...l }, u) => {
	let d = c || s?.toLowerCase().replace(/\s+/g, "-"), m = /* @__PURE__ */ f("input", {
		ref: u,
		id: d,
		type: a,
		className: V(st({
			variant: t,
			size: n,
			hasError: r || !!o,
			hasIcon: i
		}), e),
		"aria-invalid": r || !!o,
		"aria-describedby": o ? `${d}-error` : void 0,
		...l
	});
	return t === "inline" ? m : /* @__PURE__ */ p("div", {
		className: "w-full",
		children: [
			s && /* @__PURE__ */ f("label", {
				htmlFor: d,
				className: "block text-sm font-medium text-text-secondary mb-1.5",
				children: s
			}),
			m,
			o && /* @__PURE__ */ f("p", {
				id: `${d}-error`,
				className: "mt-1.5 text-sm text-error-600",
				children: o
			})
		]
	});
});
iu.displayName = "Input";
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-collection@1.1.16_@types+react-dom@19.3.0_@types+react@19.3.0__@types+r_b1d6247ab86485bab1740806d97e8d38/node_modules/@radix-ui/react-collection/dist/index.mjs
var au = Object.defineProperty, X = (e, t) => au(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function ou(t) {
	let n = t + "CollectionProvider", [r, i] = /* @__PURE__ */ Zn(n), [a, o] = r(n, {
		collectionRef: { current: null },
		itemMap: /* @__PURE__ */ new Map()
	}), s = /* @__PURE__ */ X((t) => {
		let { scope: n, children: r } = t, i = e.useRef(null), o = e.useRef(/* @__PURE__ */ new Map()).current;
		return /* @__PURE__ */ f(a, {
			scope: n,
			itemMap: o,
			collectionRef: i,
			children: r
		});
	}, "CollectionProvider");
	s.displayName = n;
	let c = t + "CollectionSlot", l = /* @__PURE__ */ lr(c), u = e.forwardRef((e, t) => {
		let { scope: n, children: r } = e, i = W(t, o(c, n).collectionRef);
		return /* @__PURE__ */ f(l, {
			ref: i,
			children: r
		});
	});
	u.displayName = c;
	let d = t + "CollectionItemSlot", p = "data-radix-collection-item", m = /* @__PURE__ */ lr(d), h = e.forwardRef((t, n) => {
		let { scope: r, children: i, ...a } = t, s = e.useRef(null), c = W(n, s), l = o(d, r);
		return e.useEffect(() => (l.itemMap.set(s, {
			ref: s,
			...a
		}), () => void l.itemMap.delete(s))), /* @__PURE__ */ f(m, {
			[p]: "",
			ref: c,
			children: i
		});
	});
	h.displayName = d;
	function g(n) {
		let r = o(t + "CollectionConsumer", n);
		return e.useCallback(() => {
			let e = r.collectionRef.current;
			if (!e) return [];
			let t = Array.from(e.querySelectorAll(`[${p}]`));
			return Array.from(r.itemMap.values()).sort((e, n) => t.indexOf(e.ref.current) - t.indexOf(n.ref.current));
		}, [r.collectionRef, r.itemMap]);
	}
	return X(g, "useCollection"), [
		{
			Provider: s,
			Slot: u,
			ItemSlot: h
		},
		g,
		i
	];
}
X(ou, "createCollection");
var su = /* @__PURE__ */ new WeakMap(), cu = class e extends Map {
	static {
		X(this, "OrderedDict");
	}
	#e;
	constructor(e) {
		super(e), this.#e = [...super.keys()], su.set(this, !0);
	}
	set(e, t) {
		return su.get(this) && (this.has(e) ? this.#e[this.#e.indexOf(e)] = e : this.#e.push(e)), super.set(e, t), this;
	}
	insert(e, t, n) {
		let r = this.has(t), i = this.#e.length, a = du(e), o = a >= 0 ? a : i + a, s = o < 0 || o >= i ? -1 : o;
		if (s === this.size || r && s === this.size - 1 || s === -1) return this.set(t, n), this;
		let c = this.size + +!r;
		a < 0 && o++;
		let l = [...this.#e], u, d = !1;
		for (let e = o; e < c; e++) if (o === e) {
			let i = l[e];
			l[e] === t && (i = l[e + 1]), r && this.delete(t), u = this.get(i), this.set(t, n);
		} else {
			!d && l[e - 1] === t && (d = !0);
			let n = l[d ? e : e - 1], r = u;
			u = this.get(n), this.delete(n), this.set(n, r);
		}
		return this;
	}
	with(t, n, r) {
		let i = new e(this);
		return i.insert(t, n, r), i;
	}
	before(e) {
		let t = this.#e.indexOf(e) - 1;
		if (!(t < 0)) return this.entryAt(t);
	}
	setBefore(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r, t, n);
	}
	after(e) {
		let t = this.#e.indexOf(e);
		if (t = t === -1 || t === this.size - 1 ? -1 : t + 1, t !== -1) return this.entryAt(t);
	}
	setAfter(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r + 1, t, n);
	}
	first() {
		return this.entryAt(0);
	}
	last() {
		return this.entryAt(-1);
	}
	clear() {
		return this.#e = [], super.clear();
	}
	delete(e) {
		let t = super.delete(e);
		return t && this.#e.splice(this.#e.indexOf(e), 1), t;
	}
	deleteAt(e) {
		let t = this.keyAt(e);
		return t !== void 0 && this.delete(t);
	}
	at(e) {
		let t = lu(this.#e, e);
		if (t !== void 0) return this.get(t);
	}
	entryAt(e) {
		let t = lu(this.#e, e);
		if (t !== void 0) return [t, this.get(t)];
	}
	indexOf(e) {
		return this.#e.indexOf(e);
	}
	keyAt(e) {
		return lu(this.#e, e);
	}
	from(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.at(r);
	}
	keyFrom(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.keyAt(r);
	}
	find(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return r;
			n++;
		}
	}
	findIndex(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return n;
			n++;
		}
		return -1;
	}
	filter(t, n) {
		let r = [], i = 0;
		for (let e of this) Reflect.apply(t, n, [
			e,
			i,
			this
		]) && r.push(e), i++;
		return new e(r);
	}
	map(t, n) {
		let r = [], i = 0;
		for (let e of this) r.push([e[0], Reflect.apply(t, n, [
			e,
			i,
			this
		])]), i++;
		return new e(r);
	}
	reduce(...e) {
		let [t, n] = e, r = 0, i = n ?? this.at(0);
		for (let n of this) i = r === 0 && e.length === 1 ? n : Reflect.apply(t, this, [
			i,
			n,
			r,
			this
		]), r++;
		return i;
	}
	reduceRight(...e) {
		let [t, n] = e, r = n ?? this.at(-1);
		for (let n = this.size - 1; n >= 0; n--) {
			let i = this.at(n);
			r = n === this.size - 1 && e.length === 1 ? i : Reflect.apply(t, this, [
				r,
				i,
				n,
				this
			]);
		}
		return r;
	}
	toSorted(t) {
		let n = [...this.entries()].sort(t);
		return new e(n);
	}
	toReversed() {
		let t = new e();
		for (let e = this.size - 1; e >= 0; e--) {
			let n = this.keyAt(e), r = this.get(n);
			t.set(n, r);
		}
		return t;
	}
	toSpliced(...t) {
		let n = [...this.entries()];
		return n.splice(...t), new e(n);
	}
	slice(t, n) {
		let r = new e(), i = this.size - 1;
		if (t === void 0) return r;
		t < 0 && (t += this.size), n !== void 0 && n > 0 && (i = n - 1);
		for (let e = t; e <= i; e++) {
			let t = this.keyAt(e), n = this.get(t);
			r.set(t, n);
		}
		return r;
	}
	every(e, t) {
		let n = 0;
		for (let r of this) {
			if (!Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !1;
			n++;
		}
		return !0;
	}
	some(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !0;
			n++;
		}
		return !1;
	}
};
function lu(e, t) {
	if ("at" in Array.prototype) return Array.prototype.at.call(e, t);
	let n = uu(e, t);
	return n === -1 ? void 0 : e[n];
}
X(lu, "at");
function uu(e, t) {
	let n = e.length, r = du(t), i = r >= 0 ? r : n + r;
	return i < 0 || i >= n ? -1 : i;
}
X(uu, "toSafeIndex");
function du(e) {
	return e !== e || e === 0 ? 0 : Math.trunc(e);
}
X(du, "toSafeInteger");
// @__NO_SIDE_EFFECTS__
function fu(t) {
	let n = t + "CollectionProvider", [r, i] = /* @__PURE__ */ Zn(n), [a, o] = r(n, {
		collectionElement: null,
		collectionRef: { current: null },
		collectionRefObject: { current: null },
		itemMap: new cu(),
		setItemMap: /* @__PURE__ */ X(() => void 0, "setItemMap")
	}), s = /* @__PURE__ */ X(({ state: e, ...t }) => e ? /* @__PURE__ */ f(l, {
		...t,
		state: e
	}) : /* @__PURE__ */ f(c, { ...t }), "CollectionProvider");
	s.displayName = n;
	let c = /* @__PURE__ */ X((e) => {
		let t = _();
		return /* @__PURE__ */ f(l, {
			...e,
			state: t
		});
	}, "CollectionInit");
	c.displayName = n + "Init";
	let l = /* @__PURE__ */ X((t) => {
		let { scope: n, children: r, state: i } = t, o = e.useRef(null), [s, c] = e.useState(null), l = W(o, c), [u, d] = i;
		return e.useEffect(() => {
			if (!s) return;
			let e = gu(() => {});
			return e.observe(s, {
				childList: !0,
				subtree: !0
			}), () => {
				e.disconnect();
			};
		}, [s]), /* @__PURE__ */ f(a, {
			scope: n,
			itemMap: u,
			setItemMap: d,
			collectionRef: l,
			collectionRefObject: o,
			collectionElement: s,
			children: r
		});
	}, "CollectionProviderImpl");
	l.displayName = n + "Impl";
	let u = t + "CollectionSlot", d = /* @__PURE__ */ lr(u), p = e.forwardRef((e, t) => {
		let { scope: n, children: r } = e, i = W(t, o(u, n).collectionRef);
		return /* @__PURE__ */ f(d, {
			ref: i,
			children: r
		});
	});
	p.displayName = u;
	let m = t + "CollectionItemSlot", h = /* @__PURE__ */ lr(m), g = e.forwardRef((t, n) => {
		let { scope: r, children: i, ...a } = t, s = e.useRef(null), [c, l] = e.useState(null), u = W(n, s, l), { setItemMap: d } = o(m, r), p = e.useRef(a);
		pu(p.current, a) || (p.current = a);
		let g = p.current;
		return e.useEffect(() => {
			let e = g;
			return d((t) => c ? t.has(c) ? t.set(c, {
				...e,
				element: c
			}).toSorted(hu) : (t.set(c, {
				...e,
				element: c
			}), t.toSorted(hu)) : t), () => {
				d((e) => !c || !e.has(c) ? e : (e.delete(c), new cu(e)));
			};
		}, [
			c,
			g,
			d
		]), /* @__PURE__ */ f(h, {
			"data-radix-collection-item": "",
			ref: u,
			children: i
		});
	});
	g.displayName = m;
	function _() {
		return e.useState(new cu());
	}
	X(_, "useInitCollection");
	function v(e) {
		let { itemMap: n } = o(t + "CollectionConsumer", e);
		return n;
	}
	return X(v, "useCollection"), [{
		Provider: s,
		Slot: p,
		ItemSlot: g
	}, {
		createCollectionScope: i,
		useCollection: v,
		useInitCollection: _
	}];
}
X(fu, "createCollection");
function pu(e, t) {
	if (e === t) return !0;
	if (typeof e != "object" || typeof t != "object" || e == null || t == null) return !1;
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let r of n) if (!Object.prototype.hasOwnProperty.call(t, r) || e[r] !== t[r]) return !1;
	return !0;
}
X(pu, "shallowEqual");
function mu(e, t) {
	return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
X(mu, "isElementPreceding");
function hu(e, t) {
	return !e[1].element || !t[1].element ? 0 : mu(e[1].element, t[1].element) ? -1 : 1;
}
X(hu, "sortByDocumentPosition");
function gu(e) {
	return new MutationObserver((t) => {
		for (let n of t) if (n.type === "childList") {
			e();
			return;
		}
	});
}
X(gu, "getChildListObserver");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-direction@1.1.5_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-direction/dist/index.mjs
var _u = Object.defineProperty, vu = (e, t) => _u(e, "name", {
	value: t,
	configurable: !0
}), yu = {
	LTR: "ltr",
	RTL: "rtl"
}, bu = e.createContext(void 0);
function xu(t) {
	let n = e.useContext(bu);
	return t || n || yu.LTR;
}
vu(xu, "useDirection");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-use-is-hydrated@0.1.3_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-use-is-hydrated/dist/index.mjs
var Su = Object.defineProperty, Cu = (e, t) => Su(e, "name", {
	value: t,
	configurable: !0
}), wu = !1;
function Tu() {
	let [t, n] = e.useState(wu);
	return e.useEffect(() => {
		wu || (wu = !0, n(!0));
	}, []), t;
}
Cu(Tu, "useIsHydrated");
var Eu = e.useSyncExternalStore;
function Du() {
	return () => {};
}
Cu(Du, "subscribe");
function Ou() {
	return Eu(Du, () => !0, () => !1);
}
Cu(Ou, "useIsHydratedModern");
var ku = typeof Eu == "function" ? Ou : Tu, Au = Object.defineProperty, ju = (e, t) => Au(e, "name", {
	value: t,
	configurable: !0
}), Mu = "rovingFocusGroup.onEntryFocus", Nu = {
	bubbles: !1,
	cancelable: !0
}, Pu = "RovingFocusGroup", [Fu, Iu, Lu] = /* @__PURE__ */ ou(Pu), [Ru, zu] = /* @__PURE__ */ Zn(Pu, [Lu]), Bu = {
	Vertical: "vertical",
	Horizontal: "horizontal"
}, Vu = {
	LTR: "ltr",
	RTL: "rtl"
}, [Hu, Uu] = Ru(Pu), Wu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ju(function(e, t) {
	return /* @__PURE__ */ f(Fu.Provider, {
		scope: e.__scopeRovingFocusGroup,
		children: /* @__PURE__ */ f(Fu.Slot, {
			scope: e.__scopeRovingFocusGroup,
			children: /* @__PURE__ */ f(Gu, {
				...e,
				ref: t
			})
		})
	});
}, "RovingFocusGroup")), Gu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ju(function(t, n) {
	let { __scopeRovingFocusGroup: r, orientation: i, loop: a = !1, dir: o, currentTabStopId: s, defaultCurrentTabStopId: c, onCurrentTabStopIdChange: l, onEntryFocus: u, preventScrollOnEntryFocus: d = !1, ...p } = t, m = e.useRef(null), h = W(n, m), g = xu(o), [_, v] = Ls({
		prop: s,
		defaultProp: c ?? null,
		onChange: l,
		caller: Pu
	}), [y, b] = e.useState(!1), x = tr(u), S = Iu(r), C = e.useRef(!1), [w, T] = e.useState(0);
	return e.useEffect(() => {
		let e = m.current;
		if (e) return e.addEventListener(Mu, x), () => e.removeEventListener(Mu, x);
	}, [x]), /* @__PURE__ */ f(Hu, {
		scope: r,
		orientation: i,
		dir: g,
		loop: a,
		currentTabStopId: _,
		onItemFocus: e.useCallback((e) => v(e), [v]),
		onItemShiftTab: e.useCallback(() => b(!0), []),
		onFocusableItemAdd: e.useCallback(() => T((e) => e + 1), []),
		onFocusableItemRemove: e.useCallback(() => T((e) => e - 1), []),
		children: /* @__PURE__ */ f(G.div, {
			tabIndex: y || w === 0 ? -1 : 0,
			"data-orientation": i,
			...p,
			ref: h,
			style: {
				outline: "none",
				...t.style
			},
			onMouseDown: K(t.onMouseDown, () => {
				C.current = !0;
			}),
			onFocus: K(t.onFocus, (e) => {
				let t = !C.current;
				if (e.target === e.currentTarget && t && !y) {
					let t = new CustomEvent(Mu, Nu);
					if (e.currentTarget.dispatchEvent(t), !t.defaultPrevented) {
						let e = S().filter((e) => e.focusable);
						Zu([
							e.find((e) => e.active),
							e.find((e) => e.id === _),
							...e
						].filter(Boolean).map((e) => e.ref.current), d);
					}
				}
				C.current = !1;
			}),
			onBlur: K(t.onBlur, () => b(!1))
		})
	});
}, "RovingFocusGroupImpl")), Ku = "RovingFocusGroupItem", qu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ju(function(t, n) {
	let { __scopeRovingFocusGroup: r, focusable: i = !0, active: a = !1, tabStopId: o, children: s, ...c } = t, l = Y(), u = o || l, d = Uu(Ku, r), p = d.currentTabStopId === u, m = Iu(r), { onFocusableItemAdd: h, onFocusableItemRemove: g, currentTabStopId: _ } = d, v = ku();
	return nr(() => {
		if (v && i) return h(), () => g();
	}, [
		v,
		i,
		h,
		g
	]), e.useEffect(() => {
		if (!v && i) return h(), () => g();
	}, [
		v,
		i,
		h,
		g
	]), /* @__PURE__ */ f(Fu.ItemSlot, {
		scope: r,
		id: u,
		focusable: i,
		active: a,
		children: /* @__PURE__ */ f(G.span, {
			tabIndex: p ? 0 : -1,
			"data-orientation": d.orientation,
			...c,
			ref: n,
			onMouseDown: K(t.onMouseDown, (e) => {
				i ? d.onItemFocus(u) : e.preventDefault();
			}),
			onFocus: K(t.onFocus, () => d.onItemFocus(u)),
			onKeyDown: K(t.onKeyDown, (e) => {
				if (e.key === "Tab" && e.shiftKey) {
					d.onItemShiftTab();
					return;
				}
				if (e.target !== e.currentTarget) return;
				let t = Xu(e, d.orientation, d.dir);
				if (t !== void 0) {
					if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
					e.preventDefault();
					let n = m().filter((e) => e.focusable).map((e) => e.ref.current);
					if (t === "last") n.reverse();
					else if (t === "prev" || t === "next") {
						t === "prev" && n.reverse();
						let r = n.indexOf(e.currentTarget);
						n = d.loop ? Qu(n, r + 1) : n.slice(r + 1);
					}
					setTimeout(() => Zu(n));
				}
			}),
			children: typeof s == "function" ? s({
				isCurrentTabStop: p,
				hasTabStop: _ != null
			}) : s
		})
	});
}, "RovingFocusGroupItem")), Ju = {
	ArrowLeft: "prev",
	ArrowUp: "prev",
	ArrowRight: "next",
	ArrowDown: "next",
	PageUp: "first",
	Home: "first",
	PageDown: "last",
	End: "last"
};
function Yu(e, t) {
	return t === Vu.RTL ? e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e : e;
}
ju(Yu, "getDirectionAwareKey");
function Xu(e, t, n) {
	let r = Yu(e.key, n);
	if (!(t === Bu.Vertical && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === Bu.Horizontal && ["ArrowUp", "ArrowDown"].includes(r))) return Ju[r];
}
ju(Xu, "getFocusIntent");
function Zu(e, t = !1) {
	let n = document.activeElement;
	for (let r of e) if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
ju(Zu, "focusFirst");
function Qu(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
ju(Qu, "wrapArray");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-visually-hidden@1.2.12_@types+react-dom@19.3.0_@types+react@19.3.0__@ty_ad57af71b4efe6276d0723047030f1e5/node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
var $u = Object.defineProperty, ed = (e, t) => $u(e, "name", {
	value: t,
	configurable: !0
}), td = Object.freeze({
	position: "absolute",
	border: 0,
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: "hidden",
	clip: "rect(0, 0, 0, 0)",
	whiteSpace: "nowrap",
	wordWrap: "normal"
}), nd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ed(function(e, t) {
	return /* @__PURE__ */ f(G.span, {
		...e,
		ref: t,
		style: {
			...td,
			...e.style
		}
	});
}, "VisuallyHidden")), rd = Object.defineProperty, id = (e, t) => rd(e, "name", {
	value: t,
	configurable: !0
}), ad = "Switch", [od, sd] = /* @__PURE__ */ Zn(ad), [cd, ld] = od(ad);
function ud(t) {
	let { __scopeSwitch: n, checked: r, children: i, defaultChecked: a, disabled: o, form: s, name: c, onCheckedChange: l, required: u, value: d = "on", internal_do_not_use_render: p } = t, [m, h] = Ls({
		prop: r,
		defaultProp: a ?? !1,
		onChange: l,
		caller: ad
	}), [g, _] = e.useState(null), [v, y] = e.useState(null), b = e.useRef(!1), [x, S] = e.useReducer((e) => e + 1, 0), C = {
		checked: m,
		setChecked: h,
		disabled: o,
		control: g,
		setControl: _,
		name: c,
		form: s,
		value: d,
		hasConsumerStoppedPropagationRef: b,
		userInteractionCount: x,
		onUserInteraction: S,
		required: u,
		defaultChecked: a,
		isFormControl: !g || !!s || !!g.closest("form"),
		bubbleInput: v,
		setBubbleInput: y
	};
	return /* @__PURE__ */ f(cd, {
		scope: n,
		...C,
		children: vd(p) ? p(C) : i
	});
}
id(ud, "SwitchProvider");
var dd = "SwitchTrigger", fd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ id(function({ __scopeSwitch: t, onClick: n, ...r }, i) {
	let { control: a, form: o, value: s, disabled: c, checked: l, required: u, setControl: d, setChecked: p, hasConsumerStoppedPropagationRef: m, onUserInteraction: h, isFormControl: g, bubbleInput: _ } = ld(dd, t), v = W(i, d), y = e.useRef(l);
	return e.useEffect(() => {
		let e = o ? a?.ownerDocument.getElementById(o) : a?.form;
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ id(() => p(y.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		a,
		o,
		p
	]), /* @__PURE__ */ f(G.button, {
		type: "button",
		role: "switch",
		"aria-checked": l,
		"aria-required": u,
		"data-state": yd(l),
		"data-disabled": c ? "" : void 0,
		disabled: c,
		value: s,
		...r,
		ref: v,
		onClick: K(n, (e) => {
			h(), p((e) => !e), _ && g && (m.current = e.isPropagationStopped(), m.current || e.stopPropagation());
		})
	});
}, "SwitchTrigger")), pd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ id(function(e, t) {
	let { __scopeSwitch: n, name: r, checked: i, defaultChecked: a, required: o, disabled: s, value: c, onCheckedChange: l, form: u, ...m } = e;
	return /* @__PURE__ */ f(ud, {
		__scopeSwitch: n,
		checked: i,
		defaultChecked: a,
		disabled: s,
		required: o,
		onCheckedChange: l,
		name: r,
		form: u,
		value: c,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ p(d, { children: [/* @__PURE__ */ f(fd, {
			...m,
			ref: t,
			__scopeSwitch: n
		}), e && /* @__PURE__ */ f(_d, { __scopeSwitch: n })] })
	});
}, "Switch")), md = "SwitchThumb", hd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ id(function(e, t) {
	let { __scopeSwitch: n, ...r } = e, i = ld(md, n);
	return /* @__PURE__ */ f(G.span, {
		"data-state": yd(i.checked),
		"data-disabled": i.disabled ? "" : void 0,
		...r,
		ref: t
	});
}, "SwitchThumb")), gd = "SwitchBubbleInput", _d = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ id(function({ __scopeSwitch: t, onClick: n, ...r }, i) {
	let { control: a, hasConsumerStoppedPropagationRef: o, userInteractionCount: s, checked: c, defaultChecked: l, required: u, disabled: d, name: p, value: m, form: h, bubbleInput: g, setBubbleInput: _ } = ld(gd, t), v = W(i, _), y = Yo(a), b = e.useRef(!1), x = e.useRef(c), S = e.useRef(s);
	e.useEffect(() => {
		let e = g;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "checked").set, r = s !== S.current;
		S.current = s;
		let i = x.current !== c;
		x.current = c;
		let a = !(r && o.current);
		if (i && n) {
			b.current = !r;
			let t = new Event("click", { bubbles: a });
			n.call(e, c), e.dispatchEvent(t), b.current = !1;
		}
	}, [
		g,
		c,
		o,
		s
	]);
	let C = e.useRef(c);
	return /* @__PURE__ */ f(G.input, {
		type: "checkbox",
		"aria-hidden": !0,
		defaultChecked: l ?? C.current,
		required: u,
		disabled: d,
		name: p,
		value: m,
		form: h,
		...r,
		tabIndex: -1,
		ref: v,
		onClick: K(n, (e) => {
			b.current && e.stopPropagation();
		}),
		style: {
			...r.style,
			...y,
			position: "absolute",
			pointerEvents: "none",
			opacity: 0,
			margin: 0,
			transform: "translateX(-100%)"
		}
	});
}, "SwitchBubbleInput"));
function vd(e) {
	return typeof e == "function";
}
id(vd, "isFunction");
function yd(e) {
	return e ? "checked" : "unchecked";
}
id(yd, "getState");
//#endregion
//#region src/components/atoms/Switch/Switch.tsx
var bd = {
	sm: {
		root: "h-4 w-7",
		thumb: "h-3 w-3 data-[state=checked]:translate-x-3"
	},
	md: {
		root: "h-5 w-9",
		thumb: "h-4 w-4 data-[state=checked]:translate-x-4"
	},
	lg: {
		root: "h-6 w-11",
		thumb: "h-5 w-5 data-[state=checked]:translate-x-5"
	}
}, xd = r(({ className: e, label: t, description: n, size: r = "md", id: i, ...a }, o) => {
	let s = i || t?.toLowerCase().replace(/\s+/g, "-"), c = bd[r], l = /* @__PURE__ */ f(pd, {
		ref: o,
		id: s,
		className: V("agn-switch peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent", "transition-colors", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--ring-color)] focus-visible:ring-offset-2 focus-visible:ring-offset-surface", "disabled:cursor-not-allowed disabled:opacity-50", "data-[state=checked]:bg-[var(--action-primary)] data-[state=unchecked]:bg-[var(--input)]", c.root, e),
		...a,
		children: /* @__PURE__ */ f(hd, { className: V("agn-switch-thumb pointer-events-none block rounded-full shadow-lg ring-0 transition-transform", "bg-[var(--action-primary-fg)]", "data-[state=unchecked]:translate-x-0", c.thumb) })
	});
	return !t && !n ? l : /* @__PURE__ */ p("div", {
		className: "flex items-start gap-3",
		children: [l, /* @__PURE__ */ p("div", {
			className: "flex flex-col",
			children: [t && /* @__PURE__ */ f("label", {
				htmlFor: s,
				className: "text-sm font-medium text-text-primary cursor-pointer leading-none",
				children: t
			}), n && /* @__PURE__ */ f("p", {
				className: "text-sm text-muted-foreground mt-1",
				children: n
			})]
		})]
	});
});
xd.displayName = "Switch";
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-tooltip@1.3.0_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react_6549bd62ea6eb106a6aeca49ee3b8cb9/node_modules/@radix-ui/react-tooltip/dist/index.mjs
var Sd = Object.defineProperty, Z = (e, t) => Sd(e, "name", {
	value: t,
	configurable: !0
}), [Cd, wd] = /* @__PURE__ */ Zn("Tooltip", [ns]), Td = ns(), Ed = "TooltipProvider", Dd = 700, Od = "tooltip.open", [kd, Ad] = Cd(Ed), jd = /* @__PURE__ */ Z((t) => {
	let { __scopeTooltip: n, delayDuration: r = Dd, skipDelayDuration: i = 300, disableHoverableContent: a = !1, children: o } = t, s = e.useRef(!0), c = e.useRef(!1), l = e.useRef(0);
	return e.useEffect(() => {
		let e = l.current;
		return () => window.clearTimeout(e);
	}, []), /* @__PURE__ */ f(kd, {
		scope: n,
		isOpenDelayedRef: s,
		delayDuration: r,
		onOpen: e.useCallback(() => {
			i <= 0 || (window.clearTimeout(l.current), s.current = !1);
		}, [i]),
		onClose: e.useCallback(() => {
			i <= 0 || (window.clearTimeout(l.current), l.current = window.setTimeout(() => s.current = !0, i));
		}, [i]),
		isPointerInTransitRef: c,
		onPointerInTransitChange: e.useCallback((e) => {
			c.current = e;
		}, []),
		disableHoverableContent: a,
		children: o
	});
}, "TooltipProvider"), Md = "Tooltip", [Nd, Pd] = Cd(Md), Fd = /* @__PURE__ */ Z((t) => {
	let { __scopeTooltip: n, children: r, open: i, defaultOpen: a, onOpenChange: o, disableHoverableContent: s, delayDuration: c } = t, l = Ad(Md, t.__scopeTooltip), u = Td(n), [d, p] = e.useState(null), [m, h] = e.useState(void 0), g = Y(), _ = e.useRef(0), v = s ?? l.disableHoverableContent, y = c ?? l.delayDuration, b = e.useRef(!1), [x, S] = Ls({
		prop: i,
		defaultProp: a ?? !1,
		onChange: /* @__PURE__ */ Z((e) => {
			e ? (l.onOpen(), document.dispatchEvent(new CustomEvent(Od))) : l.onClose(), o?.(e);
		}, "onChange"),
		caller: Md
	}), C = e.useMemo(() => x ? b.current ? "delayed-open" : "instant-open" : "closed", [x]), w = e.useCallback(() => {
		window.clearTimeout(_.current), _.current = 0, b.current = !1, S(!0);
	}, [S]), T = e.useCallback(() => {
		window.clearTimeout(_.current), _.current = 0, S(!1);
	}, [S]), E = e.useCallback(() => {
		window.clearTimeout(_.current), _.current = window.setTimeout(() => {
			b.current = !0, S(!0), _.current = 0;
		}, y);
	}, [y, S]);
	e.useEffect(() => () => {
		_.current &&= (window.clearTimeout(_.current), 0);
	}, []);
	let ee = m ?? g;
	return /* @__PURE__ */ f(as, {
		...u,
		children: /* @__PURE__ */ f(Nd, {
			scope: n,
			contentId: ee,
			setContentId: h,
			open: x,
			stateAttribute: C,
			trigger: d,
			onTriggerChange: p,
			onTriggerEnter: e.useCallback(() => {
				l.isOpenDelayedRef.current ? E() : w();
			}, [
				l.isOpenDelayedRef,
				E,
				w
			]),
			onTriggerLeave: e.useCallback(() => {
				v ? T() : (window.clearTimeout(_.current), _.current = 0);
			}, [T, v]),
			onOpen: w,
			onClose: T,
			disableHoverableContent: v,
			children: r
		})
	});
}, "Tooltip"), Id = "TooltipTrigger", Ld = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(t, n) {
	let { __scopeTooltip: r, "aria-describedby": i, ...a } = t, o = Pd(Id, r), s = Ad(Id, r), c = Td(r), l = W(n, e.useRef(null), o.onTriggerChange), u = e.useRef(!1), d = e.useRef(!1), p = e.useCallback(() => u.current = !1, []);
	return e.useEffect(() => () => document.removeEventListener("pointerup", p), [p]), /* @__PURE__ */ f(ss, {
		asChild: !0,
		...c,
		children: /* @__PURE__ */ f(G.button, {
			"aria-describedby": o.open ? ef(i, o.contentId) : i,
			"data-state": o.stateAttribute,
			...a,
			ref: l,
			onPointerMove: K(t.onPointerMove, (e) => {
				e.pointerType !== "touch" && !d.current && !s.isPointerInTransitRef.current && (o.onTriggerEnter(), d.current = !0);
			}),
			onPointerLeave: K(t.onPointerLeave, () => {
				o.onTriggerLeave(), d.current = !1;
			}),
			onPointerDown: K(t.onPointerDown, () => {
				o.open && o.onClose(), u.current = !0, document.addEventListener("pointerup", p, { once: !0 });
			}),
			onFocus: K(t.onFocus, () => {
				u.current || o.onOpen();
			}),
			onBlur: K(t.onBlur, o.onClose),
			onClick: K(t.onClick, o.onClose)
		})
	});
}, "TooltipTrigger")), Rd = "TooltipPortal", [zd, Bd] = Cd(Rd, { forceMount: void 0 }), Vd = /* @__PURE__ */ Z((e) => {
	let { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, a = Pd(Rd, t);
	return /* @__PURE__ */ f(zd, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ f(Cs, {
			present: n || a.open,
			children: /* @__PURE__ */ f(ys, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "TooltipPortal"), Hd = "TooltipContent", Ud = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(e, t) {
	let n = Bd(Hd, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...a } = e, o = Pd(Hd, e.__scopeTooltip);
	return /* @__PURE__ */ f(Cs, {
		present: r || o.open,
		children: o.disableHoverableContent ? /* @__PURE__ */ f(Kd, {
			side: i,
			...a,
			ref: t
		}) : /* @__PURE__ */ f(Wd, {
			side: i,
			...a,
			ref: t
		})
	});
}, "TooltipContent")), Wd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(t, n) {
	let r = Pd(Hd, t.__scopeTooltip), i = Ad(Hd, t.__scopeTooltip), a = e.useRef(null), o = W(n, a), [s, c] = e.useState(null), { trigger: l, onClose: u } = r, d = a.current, { onPointerInTransitChange: p } = i, m = e.useCallback(() => {
		c(null), p(!1);
	}, [p]), h = e.useCallback((e, t) => {
		let n = e.currentTarget, r = {
			x: e.clientX,
			y: e.clientY
		}, i = Yd(r, Jd(r, n.getBoundingClientRect())), a = Xd(t.getBoundingClientRect()), o = Qd([...i, ...a]);
		c(o), p(!0);
	}, [p]);
	return e.useEffect(() => () => m(), [m]), e.useEffect(() => {
		if (l && d) {
			let e = /* @__PURE__ */ Z((e) => h(e, d), "handleTriggerLeave"), t = /* @__PURE__ */ Z((e) => h(e, l), "handleContentLeave");
			return l.addEventListener("pointerleave", e), d.addEventListener("pointerleave", t), () => {
				l.removeEventListener("pointerleave", e), d.removeEventListener("pointerleave", t);
			};
		}
	}, [
		l,
		d,
		h,
		m
	]), e.useEffect(() => {
		if (s) {
			let e = /* @__PURE__ */ Z((e) => {
				let t = e.target, n = {
					x: e.clientX,
					y: e.clientY
				}, r = l?.contains(t) || d?.contains(t), i = !Zd(n, s);
				r ? m() : i && (m(), u());
			}, "handleTrackPointerGrace");
			return document.addEventListener("pointermove", e), () => document.removeEventListener("pointermove", e);
		}
	}, [
		l,
		d,
		s,
		u,
		m
	]), /* @__PURE__ */ f(Kd, {
		...t,
		ref: o
	});
}, "TooltipContentHoverable")), Gd = /* @__PURE__ */ fr("TooltipContent"), Kd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(t, n) {
	let { __scopeTooltip: r, children: i, "aria-label": a, id: o, onEscapeKeyDown: s, onPointerDownOutside: c, ...l } = t, u = Pd(Hd, r), d = Td(r), { onClose: m } = u;
	e.useEffect(() => (document.addEventListener(Od, m), () => document.removeEventListener(Od, m)), [m]), e.useEffect(() => {
		if (u.trigger) {
			let e = /* @__PURE__ */ Z((e) => {
				e.target instanceof Node && e.target.contains(u.trigger) && m();
			}, "handleScroll");
			return window.addEventListener("scroll", e, { capture: !0 }), () => window.removeEventListener("scroll", e, { capture: !0 });
		}
	}, [u.trigger, m]);
	let { setContentId: h } = u;
	return nr(() => (h(o), () => {
		h(void 0);
	}), [o, h]), /* @__PURE__ */ f(Hr, {
		asChild: !0,
		disableOutsidePointerEvents: !1,
		onEscapeKeyDown: s,
		onPointerDownOutside: c,
		onFocusOutside: (e) => e.preventDefault(),
		onDismiss: m,
		children: /* @__PURE__ */ p(ds, {
			"data-state": u.stateAttribute,
			role: a ? void 0 : "tooltip",
			id: a ? void 0 : u.contentId,
			...d,
			...l,
			ref: n,
			style: {
				...l.style,
				"--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
				"--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
				"--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
				"--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
				"--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
			},
			children: [/* @__PURE__ */ f(Gd, { children: i }), a ? /* @__PURE__ */ f(nd, {
				id: u.contentId,
				role: "tooltip",
				children: a
			}) : null]
		})
	});
}, "TooltipContentImpl")), qd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(e, t) {
	let { __scopeTooltip: n, ...r } = e, i = Td(n);
	return /* @__PURE__ */ f(ms, {
		...i,
		...r,
		ref: t
	});
}, "TooltipArrow"));
function Jd(e, t) {
	let n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
	switch (Math.min(n, r, i, a)) {
		case a: return "left";
		case i: return "right";
		case n: return "top";
		case r: return "bottom";
		default: throw Error("unreachable");
	}
}
Z(Jd, "getExitSideFromRect");
function Yd(e, t, n = 5) {
	let r = [];
	switch (t) {
		case "top":
			r.push({
				x: e.x - n,
				y: e.y + n
			}, {
				x: e.x + n,
				y: e.y + n
			});
			break;
		case "bottom":
			r.push({
				x: e.x - n,
				y: e.y - n
			}, {
				x: e.x + n,
				y: e.y - n
			});
			break;
		case "left":
			r.push({
				x: e.x + n,
				y: e.y - n
			}, {
				x: e.x + n,
				y: e.y + n
			});
			break;
		case "right": r.push({
			x: e.x - n,
			y: e.y - n
		}, {
			x: e.x - n,
			y: e.y + n
		});
	}
	return r;
}
Z(Yd, "getPaddedExitPoints");
function Xd(e) {
	let { top: t, right: n, bottom: r, left: i } = e;
	return [
		{
			x: i,
			y: t
		},
		{
			x: n,
			y: t
		},
		{
			x: n,
			y: r
		},
		{
			x: i,
			y: r
		}
	];
}
Z(Xd, "getPointsFromRect");
function Zd(e, t) {
	let { x: n, y: r } = e, i = !1;
	for (let e = 0, a = t.length - 1; e < t.length; a = e++) {
		let o = t[e], s = t[a], c = o.x, l = o.y, u = s.x, d = s.y;
		l > r != d > r && n < (u - c) * (r - l) / (d - l) + c && (i = !i);
	}
	return i;
}
Z(Zd, "isPointInPolygon");
function Qd(e) {
	let t = e.slice();
	return t.sort((e, t) => e.x < t.x ? -1 : e.x > t.x ? 1 : e.y < t.y ? -1 : +(e.y > t.y)), $d(t);
}
Z(Qd, "getHull");
function $d(e) {
	if (e.length <= 1) return e.slice();
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (; t.length >= 2;) {
			let e = t[t.length - 1], n = t[t.length - 2];
			if ((e.x - n.x) * (r.y - n.y) >= (e.y - n.y) * (r.x - n.x)) t.pop();
			else break;
		}
		t.push(r);
	}
	t.pop();
	let n = [];
	for (let t = e.length - 1; t >= 0; t--) {
		let r = e[t];
		for (; n.length >= 2;) {
			let e = n[n.length - 1], t = n[n.length - 2];
			if ((e.x - t.x) * (r.y - t.y) >= (e.y - t.y) * (r.x - t.x)) n.pop();
			else break;
		}
		n.push(r);
	}
	return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
Z($d, "getHullPresorted");
function ef(...e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e) if (typeof n == "string") for (let e of String(n).trim().split(/\s+/)) e && t.add(e);
	return t.size > 0 ? Array.from(t).join(" ") : void 0;
}
Z(ef, "concatAriaDescribedby");
//#endregion
//#region src/components/atoms/Tooltip/Tooltip.tsx
var tf = jd, nf = Fd, rf = Ld, af = r(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ f(Vd, { children: /* @__PURE__ */ f(Ud, {
	ref: r,
	sideOffset: t,
	className: V("z-50 overflow-hidden rounded-md px-3 py-1.5 text-sm", "bg-[var(--action-primary)] text-[var(--action-primary-fg)]", "animate-in fade-in-0 zoom-in-95", "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95", "data-[side=bottom]:slide-in-from-top-2", "data-[side=left]:slide-in-from-right-2", "data-[side=right]:slide-in-from-left-2", "data-[side=top]:slide-in-from-bottom-2", e),
	...n
}) }));
af.displayName = "TooltipContent";
var of = r(({ className: e, ...t }, n) => /* @__PURE__ */ f(qd, {
	ref: n,
	className: V("fill-[var(--action-primary)]", e),
	...t
}));
of.displayName = "TooltipArrow";
var sf = ({ content: e, children: t, side: n = "top", align: r = "center", delayDuration: i = 200, showArrow: a = !1 }) => /* @__PURE__ */ f(tf, {
	delayDuration: i,
	children: /* @__PURE__ */ p(nf, { children: [/* @__PURE__ */ f(rf, {
		asChild: !0,
		children: t
	}), /* @__PURE__ */ p(af, {
		side: n,
		align: r,
		children: [e, a && /* @__PURE__ */ f(of, {})]
	})] })
});
sf.displayName = "SimpleTooltip";
//#endregion
//#region src/next/TrustBadge/TrustBadge.tsx
var cf = (e, t, n) => `var(--agn-trust-${e}-${t}, ${n})`, lf = {
	0: {
		bg: cf(0, "bg", "var(--color-error-50)"),
		fg: cf(0, "fg", "var(--color-error-800, #9f1239)"),
		bd: cf(0, "bd", "color-mix(in srgb, var(--color-error-600) 35%, transparent)"),
		label: "Restricted"
	},
	1: {
		bg: cf(1, "bg", "var(--color-warning-50)"),
		fg: cf(1, "fg", "var(--color-brand-800)"),
		bd: cf(1, "bd", "color-mix(in srgb, var(--color-warning-600) 40%, transparent)"),
		label: "Limited"
	},
	2: {
		bg: cf(2, "bg", "var(--color-success-50)"),
		fg: cf(2, "fg", "var(--color-success-700)"),
		bd: cf(2, "bd", "color-mix(in srgb, var(--color-success-600) 40%, transparent)"),
		label: "Standard"
	},
	3: {
		bg: cf(3, "bg", "color-mix(in srgb, var(--color-success-700) 22%, transparent)"),
		fg: cf(3, "fg", "var(--color-success-800, #065f46)"),
		bd: cf(3, "bd", "color-mix(in srgb, var(--color-success-700) 45%, transparent)"),
		label: "Elevated"
	}
}, uf = {
	sm: {
		h: "var(--inline-h, 24px)",
		p: "0 9px",
		i: 14
	},
	md: {
		h: "var(--inline-h, 24px)",
		p: "0 10px",
		i: 14
	},
	lg: {
		h: "var(--inline-h-lg, 28px)",
		p: "0 12px",
		i: 16
	}
};
function df(e) {
	return e === 0 || e === 1 || e === 2 || e === 3;
}
function ff(e) {
	return typeof e == "number" && Number.isFinite(e) ? `Tier ${e}?` : "Tier ?";
}
function pf(e) {
	return df(e) ? lf[e].label : ff(e);
}
var mf = /* @__PURE__ */ new Set();
function hf(e) {
	df(e) || mf.has(e) || (mf.add(e), console.warn(`[TrustBadge] tier ${String(e)} is out of range. TrustTiers is 0-3 (Restricted/Limited/Standard/Elevated). Rendering an explicit unknown state rather than defaulting to Standard, which would read as a valid ceiling.`));
}
function gf() {
	mf.clear();
}
function _f({ tier: e, size: t = 14, style: n }) {
	return /* @__PURE__ */ p("svg", {
		"aria-hidden": "true",
		width: t,
		height: t,
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: {
			flex: "none",
			...n
		},
		children: [/* @__PURE__ */ f("path", { d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" }), e === 3 && /* @__PURE__ */ f("path", { d: "m9 12 2 2 4-4" })]
	});
}
function vf({ tier: e, size: t = "md", showLabel: n = !0, showIcon: r = !0, label: i, className: a, style: o, ...s }) {
	let c = df(e);
	c || hf(e);
	let l = c ? lf[e] : {
		bg: "var(--muted)",
		fg: "var(--text-muted)",
		bd: "var(--border)",
		label: ff(e)
	}, u = uf[t] ?? uf.md;
	return /* @__PURE__ */ p("span", {
		"data-trust-tier": c ? e : "unknown",
		className: V("inline-flex flex-none items-center justify-center whitespace-nowrap", a),
		style: {
			gap: 5,
			height: u.h,
			padding: u.p,
			boxSizing: "border-box",
			fontFamily: "var(--font-body)",
			fontWeight: 500,
			fontSize: "min(1em, var(--text-sm, 0.875rem))",
			lineHeight: 1,
			background: l.bg,
			color: l.fg,
			border: `1px solid ${l.bd}`,
			borderRadius: "var(--radius-md)",
			...o
		},
		...s,
		children: [r && c && e >= 2 && /* @__PURE__ */ f(_f, {
			tier: e,
			size: u.i
		}), n && /* @__PURE__ */ f("span", { children: i || l.label })]
	});
}
//#endregion
//#region src/components/atoms/Typography/Typography.tsx
var yf = H("font-semibold tracking-tight", {
	variants: {
		level: {
			h1: "text-3xl font-bold",
			h2: "text-2xl font-semibold",
			h3: "text-xl font-semibold",
			h4: "text-lg font-medium",
			h5: "text-base font-medium",
			h6: "text-sm font-medium"
		},
		color: {
			default: "text-text-primary",
			muted: "text-text-muted",
			brand: "text-brand-800",
			success: "text-success-700",
			warning: "text-warning-700",
			error: "text-error-700",
			info: "text-info-700"
		}
	},
	defaultVariants: {
		level: "h2",
		color: "default"
	}
}), bf = r(({ level: e = "h2", color: t, as: n, className: r, children: i, ...a }, o) => /* @__PURE__ */ f(n || e || "h2", {
	ref: o,
	className: V(yf({
		level: e,
		color: t
	}), r),
	...a,
	children: i
}));
bf.displayName = "Heading";
var xf = H("", {
	variants: {
		size: {
			xs: "text-xs",
			sm: "text-sm",
			base: "text-base",
			lg: "text-lg",
			xl: "text-xl"
		},
		weight: {
			normal: "font-normal",
			medium: "font-medium",
			semibold: "font-semibold",
			bold: "font-bold"
		},
		color: {
			default: "text-text-primary",
			secondary: "text-text-secondary",
			muted: "text-text-muted",
			subtle: "text-text-muted",
			brand: "text-brand-800",
			success: "text-success-700",
			warning: "text-warning-700",
			error: "text-error-700",
			info: "text-info-700",
			link: "text-text-primary hover:text-text-muted"
		},
		leading: {
			tight: "leading-tight",
			snug: "leading-snug",
			normal: "leading-normal",
			relaxed: "leading-relaxed",
			loose: "leading-loose"
		}
	},
	defaultVariants: {
		size: "sm",
		weight: "normal",
		color: "default",
		leading: "normal"
	}
}), Sf = r(({ size: e, weight: t, color: n, leading: r, as: i = "p", className: a, children: o, ...s }, c) => /* @__PURE__ */ f(i, {
	ref: c,
	className: V(xf({
		size: e,
		weight: t,
		color: n,
		leading: r
	}), a),
	...s,
	children: o
}));
Sf.displayName = "Text";
var Cf = H("text-xs", {
	variants: { color: {
		default: "text-text-muted",
		muted: "text-text-muted",
		error: "text-error-600",
		success: "text-success-600",
		warning: "text-warning-600",
		info: "text-info-600"
	} },
	defaultVariants: { color: "default" }
}), wf = r(({ color: e, className: t, children: n, ...r }, i) => /* @__PURE__ */ f("span", {
	ref: i,
	className: V(Cf({ color: e }), t),
	...r,
	children: n
}));
wf.displayName = "Caption";
var Tf = H("font-mono", {
	variants: {
		size: {
			xs: "text-xs",
			sm: "text-sm",
			base: "text-base"
		},
		variant: {
			inline: "px-1.5 py-0.5 rounded bg-muted text-text-primary",
			block: "block p-4 rounded-lg bg-background text-text-primary overflow-x-auto",
			plain: "text-text-secondary"
		}
	},
	defaultVariants: {
		size: "sm",
		variant: "inline"
	}
}), Ef = r(({ size: e, variant: t, className: n, children: r, ...i }, a) => /* @__PURE__ */ f(t === "block" ? "pre" : "code", {
	ref: a,
	className: V(Tf({
		size: e,
		variant: t
	}), n),
	...i,
	children: r
}));
Ef.displayName = "Code";
var Df = H("transition-colors duration-150 cursor-pointer", {
	variants: {
		variant: {
			default: [
				"text-text-primary font-medium",
				"hover:text-text-muted",
				"underline-offset-4 hover:underline"
			],
			muted: [
				"text-text-muted font-medium",
				"hover:text-text-primary",
				"underline-offset-4 hover:underline"
			],
			subtle: ["text-text-muted", "hover:text-text-primary"],
			brand: [
				"text-brand-700 font-medium",
				"hover:text-brand-800",
				"underline-offset-4 hover:underline"
			]
		},
		size: {
			xs: "text-xs",
			sm: "text-sm",
			base: "text-base",
			lg: "text-lg"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "sm"
	}
}), Of = r(({ variant: e, size: t, className: n, children: r, ...i }, a) => /* @__PURE__ */ f("a", {
	ref: a,
	className: V(Df({
		variant: e,
		size: t
	}), n),
	...i,
	children: r
}));
Of.displayName = "TextLink";
var kf = r((e, t) => /* @__PURE__ */ f(bf, {
	ref: t,
	level: "h1",
	as: "h1",
	...e
}));
kf.displayName = "PageTitle";
var Af = r((e, t) => /* @__PURE__ */ f(Sf, {
	ref: t,
	size: "sm",
	color: "secondary",
	...e
}));
Af.displayName = "PageDescription";
var jf = r((e, t) => /* @__PURE__ */ f(bf, {
	ref: t,
	level: "h2",
	as: "h2",
	...e
}));
jf.displayName = "SectionTitle";
var Mf = r((e, t) => /* @__PURE__ */ f(Sf, {
	ref: t,
	size: "sm",
	color: "muted",
	...e
}));
Mf.displayName = "SectionDescription";
var Nf = r((e, t) => /* @__PURE__ */ f(Sf, {
	ref: t,
	size: "sm",
	weight: "medium",
	color: "default",
	as: "span",
	...e
}));
Nf.displayName = "TableCellPrimary";
var Pf = r((e, t) => /* @__PURE__ */ f(Sf, {
	ref: t,
	size: "sm",
	color: "muted",
	as: "span",
	...e
}));
Pf.displayName = "TableCellSecondary";
var Ff = r((e, t) => /* @__PURE__ */ f(wf, {
	ref: t,
	color: "default",
	...e
}));
Ff.displayName = "HelperText";
var If = r((e, t) => /* @__PURE__ */ f(wf, {
	ref: t,
	color: "error",
	...e
}));
If.displayName = "ErrorText";
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-dialog@1.2.0_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@_c1edb718822a6de77ff35d62c5110ee0/node_modules/@radix-ui/react-dialog/dist/index.mjs
var Lf = Object.defineProperty, Rf = (e, t) => Lf(e, "name", {
	value: t,
	configurable: !0
}), zf = "Dialog", [Bf, Vf] = /* @__PURE__ */ Zn(zf), [Hf, Uf] = Bf(zf), Wf = /* @__PURE__ */ Rf((t) => {
	let { __scopeDialog: n, children: r, open: i, defaultOpen: a, onOpenChange: o, modal: s = !0 } = t, c = e.useRef(null), l = e.useRef(null), { nodes: u, registry: d } = ui(), [p, m] = Ls({
		prop: i,
		defaultProp: a ?? !1,
		onChange: o,
		caller: zf
	}), [h, g] = e.useState(0), [_, v] = e.useState(0);
	return /* @__PURE__ */ f(Hf, {
		scope: n,
		triggerRef: c,
		contentRef: l,
		contentId: Y(),
		titleId: Y(),
		descriptionId: Y(),
		titlePresent: h > 0,
		descriptionPresent: _ > 0,
		setTitleCount: g,
		setDescriptionCount: v,
		open: p,
		onOpenChange: m,
		onOpenToggle: e.useCallback(() => m((e) => !e), [m]),
		modal: s,
		branchNodes: u,
		branchRegistry: d,
		children: r
	});
}, "Dialog"), Gf = "DialogTrigger", Kf = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rf(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Uf(Gf, n), a = W(t, i.triggerRef);
	return /* @__PURE__ */ f(G.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": i.open,
		"aria-controls": i.open ? i.contentId : void 0,
		"data-state": dp(i.open),
		...r,
		ref: a,
		onClick: K(e.onClick, i.onOpenToggle)
	});
}, "DialogTrigger")), qf = "DialogPortal", [Jf, Yf] = Bf(qf, { forceMount: void 0 }), Xf = /* @__PURE__ */ Rf((t) => {
	let { __scopeDialog: n, forceMount: r, children: i, container: a } = t, o = Uf(qf, n);
	return /* @__PURE__ */ f(Jf, {
		scope: n,
		forceMount: r,
		children: e.Children.map(i, (e) => /* @__PURE__ */ f(Cs, {
			present: r || o.open,
			children: /* @__PURE__ */ f(ys, {
				asChild: !0,
				container: a,
				children: e
			})
		}))
	});
}, "DialogPortal"), Zf = "DialogOverlay", Qf = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rf(function(e, t) {
	let n = Yf(Zf, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = Uf(Zf, e.__scopeDialog);
	return a.modal ? /* @__PURE__ */ f(Cs, {
		present: r || a.open,
		children: /* @__PURE__ */ f(ep, {
			...i,
			ref: t
		})
	}) : null;
}, "DialogOverlay")), $f = /* @__PURE__ */ lr("DialogOverlay.RemoveScroll"), ep = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rf(function(t, n) {
	let { __scopeDialog: r, ...i } = t, a = Uf(Zf, r), o = W(n, Wr());
	return /* @__PURE__ */ f(il, {
		as: $f,
		allowPinchZoom: !0,
		shards: e.useMemo(() => [a.contentRef, ...a.branchNodes.map((e) => ({ current: e }))], [a.contentRef, a.branchNodes]),
		children: /* @__PURE__ */ f(G.div, {
			"data-state": dp(a.open),
			...i,
			ref: o,
			style: {
				pointerEvents: "auto",
				...i.style
			}
		})
	});
}, "DialogOverlayImpl")), tp = "DialogContent", np = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rf(function(e, t) {
	let n = Yf(tp, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = Uf(tp, e.__scopeDialog);
	return /* @__PURE__ */ f(Cs, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ f(rp, {
			...i,
			ref: t
		}) : /* @__PURE__ */ f(ip, {
			...i,
			ref: t
		})
	});
}, "DialogContent")), rp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rf(function(t, n) {
	let r = Uf(tp, t.__scopeDialog), i = e.useRef(null), a = W(n, r.contentRef, i);
	return e.useEffect(() => {
		let e = i.current;
		if (e) return Xs(e);
	}, []), /* @__PURE__ */ f(ap, {
		...t,
		ref: a,
		trapFocus: r.open,
		disableOutsidePointerEvents: r.open,
		onCloseAutoFocus: K(t.onCloseAutoFocus, (e) => {
			e.preventDefault(), r.triggerRef.current?.focus();
		}),
		onPointerDownOutside: K(t.onPointerDownOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0;
			(t.button === 2 || n) && e.preventDefault();
		}),
		onFocusOutside: K(t.onFocusOutside, (e) => e.preventDefault())
	});
}, "DialogContentModal")), ip = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rf(function(t, n) {
	let r = Uf(tp, t.__scopeDialog), i = e.useRef(!1), a = e.useRef(!1);
	return /* @__PURE__ */ f(ap, {
		...t,
		ref: n,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (e) => {
			t.onCloseAutoFocus?.(e), e.defaultPrevented || (i.current || r.triggerRef.current?.focus(), e.preventDefault()), i.current = !1, a.current = !1;
		},
		onInteractOutside: (e) => {
			t.onInteractOutside?.(e), e.defaultPrevented || (i.current = !0, e.detail.originalEvent.type === "pointerdown" && (a.current = !0));
			let n = e.target;
			r.triggerRef.current?.contains(n) && e.preventDefault(), e.detail.originalEvent.type === "focusin" && a.current && e.preventDefault();
		}
	});
}, "DialogContentNonModal")), ap = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rf(function(e, t) {
	let { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, "aria-describedby": o, children: s, ...c } = e, l = Uf(tp, n);
	return ti(), /* @__PURE__ */ f(li, {
		registry: l.branchRegistry,
		children: /* @__PURE__ */ f(si, {
			asChild: !0,
			loop: !0,
			trapped: r,
			branches: l.branchNodes,
			onMountAutoFocus: i,
			onUnmountAutoFocus: a,
			children: /* @__PURE__ */ f(Hr, {
				role: "dialog",
				id: l.contentId,
				"aria-labelledby": l.titlePresent ? l.titleId : void 0,
				"aria-describedby": l.descriptionPresent ? up(o, l.descriptionId) : o,
				"data-state": dp(l.open),
				...c,
				ref: t,
				deferPointerDownOutside: !0,
				onDismiss: () => l.onOpenChange(!1),
				children: s
			})
		})
	});
}, "DialogContentImpl")), op = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rf(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Uf("DialogTitle", n), { setTitleCount: a } = i;
	return nr(() => (a((e) => e + 1), () => a((e) => e - 1)), [a]), /* @__PURE__ */ f(G.h2, {
		id: i.titleId,
		...r,
		ref: t
	});
}, "DialogTitle")), sp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rf(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Uf("DialogDescription", n), { setDescriptionCount: a } = i;
	return nr(() => (a((e) => e + 1), () => a((e) => e - 1)), [a]), /* @__PURE__ */ f(G.p, {
		id: i.descriptionId,
		...r,
		ref: t
	});
}, "DialogDescription")), cp = "DialogClose", lp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rf(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Uf(cp, n);
	return /* @__PURE__ */ f(G.button, {
		type: "button",
		...r,
		ref: t,
		onClick: K(e.onClick, () => i.onOpenChange(!1))
	});
}, "DialogClose"));
function up(...e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e) if (typeof n == "string") for (let e of String(n).trim().split(/\s+/)) e && t.add(e);
	return t.size > 0 ? Array.from(t).join(" ") : void 0;
}
Rf(up, "concatAriaDescribedby");
function dp(e) {
	return e ? "open" : "closed";
}
Rf(dp, "getState");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-menu@2.1.25_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@1_3ae13a8b8abaffcff00d77dee41e2df0/node_modules/@radix-ui/react-menu/dist/index.mjs
var fp = Object.defineProperty, Q = (e, t) => fp(e, "name", {
	value: t,
	configurable: !0
}), pp = {
	LTR: "ltr",
	RTL: "rtl"
}, mp = ["Enter", " "], hp = [
	"ArrowDown",
	"PageUp",
	"Home"
], gp = [
	"ArrowUp",
	"PageDown",
	"End"
], _p = [...hp, ...gp], vp = {
	ltr: [...mp, "ArrowRight"],
	rtl: [...mp, "ArrowLeft"]
}, yp = {
	ltr: ["ArrowLeft"],
	rtl: ["ArrowRight"]
}, bp = "Menu", [xp, Sp, Cp] = /* @__PURE__ */ ou(bp), [wp, Tp] = /* @__PURE__ */ Zn(bp, [
	Cp,
	ns,
	zu
]), Ep = ns(), Dp = zu(), [Op, kp] = wp(bp), [Ap, jp] = wp(bp), Mp = /* @__PURE__ */ Q((t) => {
	let { __scopeMenu: n, open: r = !1, children: i, dir: a, onOpenChange: o, modal: s = !0 } = t, c = Ep(n), [l, u] = e.useState(null), d = e.useRef(!1), p = tr(o), m = xu(a);
	return e.useEffect(() => {
		let e = /* @__PURE__ */ Q(() => {
			d.current = !0, document.addEventListener("pointerdown", t, {
				capture: !0,
				once: !0
			}), document.addEventListener("pointermove", t, {
				capture: !0,
				once: !0
			});
		}, "handleKeyDown"), t = /* @__PURE__ */ Q(() => d.current = !1, "handlePointer");
		return document.addEventListener("keydown", e, { capture: !0 }), () => {
			document.removeEventListener("keydown", e, { capture: !0 }), document.removeEventListener("pointerdown", t, { capture: !0 }), document.removeEventListener("pointermove", t, { capture: !0 });
		};
	}, []), e.useEffect(() => {
		if (!r) return;
		let e = /* @__PURE__ */ Q(() => p(!1), "handleBlur");
		return window.addEventListener("blur", e), () => window.removeEventListener("blur", e);
	}, [r, p]), /* @__PURE__ */ f(as, {
		...c,
		children: /* @__PURE__ */ f(Op, {
			scope: n,
			open: r,
			onOpenChange: p,
			content: l,
			onContentChange: u,
			children: /* @__PURE__ */ f(Ap, {
				scope: n,
				onClose: e.useCallback(() => p(!1), [p]),
				isUsingKeyboardRef: d,
				dir: m,
				modal: s,
				children: i
			})
		})
	});
}, "Menu"), Np = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeMenu: n, ...r } = e, i = Ep(n);
	return /* @__PURE__ */ f(ss, {
		...i,
		...r,
		ref: t
	});
}, "MenuAnchor")), Pp = "MenuPortal", [Fp, Ip] = wp(Pp, { forceMount: void 0 }), Lp = /* @__PURE__ */ Q((e) => {
	let { __scopeMenu: t, forceMount: n, children: r, container: i } = e, a = kp(Pp, t);
	return /* @__PURE__ */ f(Fp, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ f(Cs, {
			present: n || a.open,
			children: /* @__PURE__ */ f(ys, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "MenuPortal"), Rp = "MenuContent", [zp, Bp] = wp(Rp), Vp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let n = Ip(Rp, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, a = kp(Rp, e.__scopeMenu), o = jp(Rp, e.__scopeMenu);
	return /* @__PURE__ */ f(xp.Provider, {
		scope: e.__scopeMenu,
		children: /* @__PURE__ */ f(Cs, {
			present: r || a.open,
			children: /* @__PURE__ */ f(xp.Slot, {
				scope: e.__scopeMenu,
				children: o.modal ? /* @__PURE__ */ f(Hp, {
					...i,
					ref: t
				}) : /* @__PURE__ */ f(Up, {
					...i,
					ref: t
				})
			})
		})
	});
}, "MenuContent")), Hp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(t, n) {
	let r = kp(Rp, t.__scopeMenu), i = e.useRef(null), a = W(n, i);
	return e.useEffect(() => {
		let e = i.current;
		if (e) return Xs(e);
	}, []), /* @__PURE__ */ f(Gp, {
		...t,
		ref: a,
		trapFocus: r.open,
		disableOutsidePointerEvents: r.open,
		disableOutsideScroll: !0,
		onFocusOutside: K(t.onFocusOutside, (e) => e.preventDefault(), { checkForDefaultPrevented: !1 }),
		onDismiss: () => r.onOpenChange(!1)
	});
}, "MenuRootContentModal")), Up = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let n = kp(Rp, e.__scopeMenu);
	return /* @__PURE__ */ f(Gp, {
		...e,
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		disableOutsideScroll: !1,
		onDismiss: () => n.onOpenChange(!1)
	});
}, "MenuRootContentNonModal")), Wp = /* @__PURE__ */ lr("MenuContent.ScrollLock"), Gp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(t, n) {
	let { __scopeMenu: r, loop: i = !1, trapFocus: a, onOpenAutoFocus: o, onCloseAutoFocus: s, disableOutsidePointerEvents: c, onEntryFocus: l, onEscapeKeyDown: u, onPointerDownOutside: d, onFocusOutside: p, onInteractOutside: m, onDismiss: h, disableOutsideScroll: g, ..._ } = t, v = kp(Rp, r), y = jp(Rp, r), b = Ep(r), x = Dp(r), S = Sp(r), [C, w] = e.useState(null), T = e.useRef(null), [E, ee] = e.useState(null);
	di(E);
	let { nodes: D, registry: te } = ui(), O = !!(a || g), k = W(n, T, v.onContentChange, ee), A = e.useRef(0), j = e.useRef(""), M = e.useRef(0), ne = e.useRef(null), N = e.useRef("right"), re = e.useRef(0), ie = e.useMemo(() => g ? [T, ...D.map((e) => ({ current: e }))] : [], [
		T,
		D,
		g
	]), ae = g ? il : e.Fragment, oe = g ? {
		as: Wp,
		allowPinchZoom: !0,
		shards: ie
	} : void 0, P = /* @__PURE__ */ Q((e) => {
		let t = j.current + e, n = S().filter((e) => !e.disabled), r = document.activeElement, i = n.find((e) => e.ref.current === r)?.textValue, a = Sm(n.map((e) => e.textValue), t, i), o = n.find((e) => e.textValue === a)?.ref.current;
		(/* @__PURE__ */ Q((function e(t) {
			j.current = t, window.clearTimeout(A.current), t !== "" && (A.current = window.setTimeout(() => e(""), 1e3));
		}), "updateSearch"))(t), o && setTimeout(() => o.focus());
	}, "handleTypeaheadSearch");
	e.useEffect(() => () => window.clearTimeout(A.current), []), ti();
	let F = e.useCallback((e) => N.current === ne.current?.side && wm(e, ne.current?.area), []);
	return /* @__PURE__ */ f(zp, {
		scope: r,
		searchRef: j,
		onItemEnter: e.useCallback((e) => {
			F(e) && e.preventDefault();
		}, [F]),
		onItemLeave: e.useCallback((e) => {
			F(e) || (T.current?.focus(), w(null));
		}, [F]),
		onTriggerLeave: e.useCallback((e) => {
			F(e) && e.preventDefault();
		}, [F]),
		pointerGraceTimerRef: M,
		onPointerGraceIntentChange: e.useCallback((e) => {
			ne.current = e;
		}, []),
		children: /* @__PURE__ */ f(li, {
			registry: O ? te : null,
			children: /* @__PURE__ */ f(ae, {
				...oe,
				children: /* @__PURE__ */ f(si, {
					asChild: !0,
					trapped: a,
					branches: D,
					onMountAutoFocus: K(o, (e) => {
						e.preventDefault(), T.current?.focus({ preventScroll: !0 });
					}),
					onUnmountAutoFocus: s,
					children: /* @__PURE__ */ f(Hr, {
						asChild: !0,
						disableOutsidePointerEvents: c,
						onEscapeKeyDown: u,
						onPointerDownOutside: d,
						onFocusOutside: p,
						onInteractOutside: m,
						onDismiss: h,
						children: /* @__PURE__ */ f(Wu, {
							asChild: !0,
							...x,
							dir: y.dir,
							orientation: "vertical",
							loop: i,
							currentTabStopId: C,
							onCurrentTabStopIdChange: w,
							onEntryFocus: K(l, (e) => {
								y.isUsingKeyboardRef.current || e.preventDefault();
							}),
							preventScrollOnEntryFocus: !0,
							children: /* @__PURE__ */ f(ds, {
								role: "menu",
								"aria-orientation": "vertical",
								"data-state": _m(v.open),
								"data-radix-menu-content": "",
								dir: y.dir,
								...b,
								..._,
								ref: k,
								style: {
									outline: "none",
									..._.style
								},
								onKeyDown: K(_.onKeyDown, (e) => {
									let t = e.target.closest("[data-radix-menu-content]") === e.currentTarget, n = e.ctrlKey || e.altKey || e.metaKey, r = e.key.length === 1;
									t && (e.key === "Tab" && e.preventDefault(), !n && r && P(e.key));
									let i = T.current;
									if (e.target !== i || !_p.includes(e.key)) return;
									e.preventDefault();
									let a = S().filter((e) => !e.disabled).map((e) => e.ref.current);
									gp.includes(e.key) && a.reverse(), bm(a);
								}),
								onBlur: K(t.onBlur, (e) => {
									e.currentTarget.contains(e.target) || (window.clearTimeout(A.current), j.current = "");
								}),
								onPointerMove: K(t.onPointerMove, Tm((e) => {
									let t = e.target, n = re.current !== e.clientX;
									if (e.currentTarget.contains(t) && n) {
										let t = e.clientX > re.current ? "right" : "left";
										N.current = t, re.current = e.clientX;
									}
								}))
							})
						})
					})
				})
			})
		})
	});
}, "MenuContentImpl")), Kp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ f(G.div, {
		role: "group",
		...r,
		ref: t
	});
}, "MenuGroup")), qp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ f(G.div, {
		...r,
		ref: t
	});
}, "MenuLabel")), Jp = "MenuItem", Yp = "menu.itemSelect", Xp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(t, n) {
	let { disabled: r = !1, onSelect: i, ...a } = t, o = e.useRef(null), s = jp(Jp, t.__scopeMenu), c = Bp(Jp, t.__scopeMenu), l = W(n, o), u = e.useRef(!1), d = /* @__PURE__ */ Q(() => {
		let e = o.current;
		if (!r && e) {
			let t = new CustomEvent(Yp, {
				bubbles: !0,
				cancelable: !0
			});
			e.addEventListener(Yp, (e) => i?.(e), { once: !0 }), Er(e, t), t.defaultPrevented ? u.current = !1 : s.onClose();
		}
	}, "handleSelect");
	return /* @__PURE__ */ f(Zp, {
		...a,
		ref: l,
		disabled: r,
		onClick: K(t.onClick, d),
		onPointerDown: (e) => {
			t.onPointerDown?.(e), u.current = !0;
		},
		onPointerUp: K(t.onPointerUp, (e) => {
			u.current || e.currentTarget?.click();
		}),
		onKeyDown: K(t.onKeyDown, (e) => {
			r || e.target !== e.currentTarget || (c.searchRef.current === "" || e.key !== " ") && mp.includes(e.key) && (e.currentTarget.click(), e.preventDefault());
		})
	});
}, "MenuItem")), Zp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(t, n) {
	let { __scopeMenu: r, disabled: i = !1, textValue: a, ...o } = t, s = Bp(Jp, r), c = Dp(r), l = e.useRef(null), u = W(n, l), [d, p] = e.useState(!1), [m, h] = e.useState("");
	return e.useEffect(() => {
		let e = l.current;
		e && h((e.textContent ?? "").trim());
	}, [o.children]), /* @__PURE__ */ f(xp.ItemSlot, {
		scope: r,
		disabled: i,
		textValue: a ?? m,
		children: /* @__PURE__ */ f(qu, {
			asChild: !0,
			...c,
			focusable: !i,
			children: /* @__PURE__ */ f(G.div, {
				role: "menuitem",
				"data-highlighted": d ? "" : void 0,
				"aria-disabled": i || void 0,
				"data-disabled": i ? "" : void 0,
				...o,
				ref: u,
				onPointerMove: K(t.onPointerMove, Tm((e) => {
					i ? s.onItemLeave(e) : (s.onItemEnter(e), e.defaultPrevented || e.currentTarget.focus({ preventScroll: !0 }));
				})),
				onPointerLeave: K(t.onPointerLeave, Tm((e) => s.onItemLeave(e))),
				onFocus: K(t.onFocus, () => p(!0)),
				onBlur: K(t.onBlur, () => p(!1))
			})
		})
	});
}, "MenuItemImpl")), Qp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { checked: n = !1, onCheckedChange: r, ...i } = e;
	return /* @__PURE__ */ f(am, {
		scope: e.__scopeMenu,
		checked: n,
		children: /* @__PURE__ */ f(Xp, {
			role: "menuitemcheckbox",
			"aria-checked": vm(n) ? "mixed" : n,
			...i,
			ref: t,
			"data-state": ym(n),
			onSelect: K(i.onSelect, () => r?.(vm(n) ? !0 : !n), { checkForDefaultPrevented: !1 })
		})
	});
}, "MenuCheckboxItem")), [$p, em] = wp("MenuRadioGroup", {
	value: void 0,
	onValueChange: /* @__PURE__ */ Q(() => {}, "onValueChange")
}), tm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { value: n, onValueChange: r, ...i } = e, a = tr(r);
	return /* @__PURE__ */ f($p, {
		scope: e.__scopeMenu,
		value: n,
		onValueChange: a,
		children: /* @__PURE__ */ f(Kp, {
			...i,
			ref: t
		})
	});
}, "MenuRadioGroup")), nm = "MenuRadioItem", rm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { value: n, ...r } = e, i = em(nm, e.__scopeMenu), a = n === i.value;
	return /* @__PURE__ */ f(am, {
		scope: e.__scopeMenu,
		checked: a,
		children: /* @__PURE__ */ f(Xp, {
			role: "menuitemradio",
			"aria-checked": a,
			...r,
			ref: t,
			"data-state": ym(a),
			onSelect: K(r.onSelect, () => i.onValueChange?.(n), { checkForDefaultPrevented: !1 })
		})
	});
}, "MenuRadioItem")), im = "MenuItemIndicator", [am, om] = wp(im, { checked: !1 }), sm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeMenu: n, forceMount: r, ...i } = e, a = om(im, n);
	return /* @__PURE__ */ f(Cs, {
		present: r || vm(a.checked) || a.checked === !0,
		children: /* @__PURE__ */ f(G.span, {
			...i,
			ref: t,
			"data-state": ym(a.checked)
		})
	});
}, "MenuItemIndicator")), cm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ f(G.div, {
		role: "separator",
		"aria-orientation": "horizontal",
		...r,
		ref: t
	});
}, "MenuSeparator")), lm = "MenuSub", [um, dm] = wp(lm), fm = /* @__PURE__ */ Q((t) => {
	let { __scopeMenu: n, children: r, open: i = !1, onOpenChange: a } = t, o = kp(lm, n), s = Ep(n), [c, l] = e.useState(null), [u, d] = e.useState(null), p = tr(a);
	return e.useEffect(() => (o.open === !1 && p(!1), () => p(!1)), [o.open, p]), /* @__PURE__ */ f(as, {
		...s,
		children: /* @__PURE__ */ f(Op, {
			scope: n,
			open: i,
			onOpenChange: p,
			content: u,
			onContentChange: d,
			children: /* @__PURE__ */ f(um, {
				scope: n,
				contentId: Y(),
				triggerId: Y(),
				trigger: c,
				onTriggerChange: l,
				children: r
			})
		})
	});
}, "MenuSub"), pm = "MenuSubTrigger", mm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(t, n) {
	let r = kp(pm, t.__scopeMenu), i = jp(pm, t.__scopeMenu), a = dm(pm, t.__scopeMenu), o = Bp(pm, t.__scopeMenu), s = e.useRef(null), { pointerGraceTimerRef: c, onPointerGraceIntentChange: l } = o, u = { __scopeMenu: t.__scopeMenu }, d = e.useCallback(() => {
		s.current && window.clearTimeout(s.current), s.current = null;
	}, []);
	e.useEffect(() => d, [d]), e.useEffect(() => {
		let e = c.current;
		return () => {
			window.clearTimeout(e), l(null);
		};
	}, [c, l]);
	let p = W(n, a.onTriggerChange);
	return /* @__PURE__ */ f(Np, {
		asChild: !0,
		...u,
		children: /* @__PURE__ */ f(Zp, {
			id: a.triggerId,
			"aria-haspopup": "menu",
			"aria-expanded": r.open,
			"aria-controls": r.open ? a.contentId : void 0,
			"data-state": _m(r.open),
			...t,
			ref: p,
			onClick: (e) => {
				t.onClick?.(e), !(t.disabled || e.defaultPrevented) && (e.currentTarget.focus(), r.open || r.onOpenChange(!0));
			},
			onPointerMove: K(t.onPointerMove, Tm((e) => {
				o.onItemEnter(e), !e.defaultPrevented && !t.disabled && !r.open && !s.current && (o.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
					r.onOpenChange(!0), d();
				}, 100));
			})),
			onPointerLeave: K(t.onPointerLeave, Tm((e) => {
				d();
				let t = r.content?.getBoundingClientRect();
				if (t) {
					let n = r.content?.dataset.side, i = n === "right", a = i ? -5 : 5, s = t[i ? "left" : "right"], l = t[i ? "right" : "left"];
					o.onPointerGraceIntentChange({
						area: [
							{
								x: e.clientX + a,
								y: e.clientY
							},
							{
								x: s,
								y: t.top
							},
							{
								x: l,
								y: t.top
							},
							{
								x: l,
								y: t.bottom
							},
							{
								x: s,
								y: t.bottom
							}
						],
						side: n
					}), window.clearTimeout(c.current), c.current = window.setTimeout(() => o.onPointerGraceIntentChange(null), 300);
				} else {
					if (o.onTriggerLeave(e), e.defaultPrevented) return;
					o.onPointerGraceIntentChange(null);
				}
			})),
			onKeyDown: K(t.onKeyDown, (e) => {
				t.disabled || e.target !== e.currentTarget || (o.searchRef.current === "" || e.key !== " ") && vp[i.dir].includes(e.key) && (r.onOpenChange(!0), r.content?.focus(), e.preventDefault());
			})
		})
	});
}, "MenuSubTrigger")), hm = "MenuSubContent", gm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(t, n) {
	let r = Ip(Rp, t.__scopeMenu), { forceMount: i = r.forceMount, align: a = "start", ...o } = t, s = kp(Rp, t.__scopeMenu), c = jp(Rp, t.__scopeMenu), l = dm(hm, t.__scopeMenu), u = e.useRef(null), d = W(n, u);
	return /* @__PURE__ */ f(xp.Provider, {
		scope: t.__scopeMenu,
		children: /* @__PURE__ */ f(Cs, {
			present: i || s.open,
			children: /* @__PURE__ */ f(xp.Slot, {
				scope: t.__scopeMenu,
				children: /* @__PURE__ */ f(Gp, {
					id: l.contentId,
					"aria-labelledby": l.triggerId,
					...o,
					ref: d,
					align: a,
					side: c.dir === pp.RTL ? "left" : "right",
					disableOutsidePointerEvents: !1,
					disableOutsideScroll: !1,
					trapFocus: !1,
					onOpenAutoFocus: (e) => {
						c.isUsingKeyboardRef.current && u.current?.focus(), e.preventDefault();
					},
					onCloseAutoFocus: (e) => e.preventDefault(),
					onFocusOutside: K(t.onFocusOutside, (e) => {
						e.target !== l.trigger && s.onOpenChange(!1);
					}),
					onEscapeKeyDown: K(t.onEscapeKeyDown, (e) => {
						c.onClose(), e.preventDefault();
					}),
					onKeyDown: K(t.onKeyDown, (e) => {
						let t = e.currentTarget.contains(e.target), n = yp[c.dir].includes(e.key);
						t && n && (s.onOpenChange(!1), l.trigger?.focus(), e.preventDefault());
					})
				})
			})
		})
	});
}, "MenuSubContent"));
function _m(e) {
	return e ? "open" : "closed";
}
Q(_m, "getOpenState");
function vm(e) {
	return e === "indeterminate";
}
Q(vm, "isIndeterminate");
function ym(e) {
	return vm(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
Q(ym, "getCheckedState");
function bm(e) {
	let t = document.activeElement;
	for (let n of e) if (n === t || (n.focus(), document.activeElement !== t)) return;
}
Q(bm, "focusFirst");
function xm(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
Q(xm, "wrapArray");
function Sm(e, t, n) {
	let r = t.length > 1 && Array.from(t).every((e) => e === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1, a = xm(e, Math.max(i, 0));
	r.length === 1 && (a = a.filter((e) => e !== n));
	let o = a.find((e) => e.toLowerCase().startsWith(r.toLowerCase()));
	return o === n ? void 0 : o;
}
Q(Sm, "getNextMatch");
function Cm(e, t) {
	let { x: n, y: r } = e, i = !1;
	for (let e = 0, a = t.length - 1; e < t.length; a = e++) {
		let o = t[e], s = t[a], c = o.x, l = o.y, u = s.x, d = s.y;
		l > r != d > r && n < (u - c) * (r - l) / (d - l) + c && (i = !i);
	}
	return i;
}
Q(Cm, "isPointInPolygon");
function wm(e, t) {
	return t ? Cm({
		x: e.clientX,
		y: e.clientY
	}, t) : !1;
}
Q(wm, "isPointerInGraceArea");
function Tm(e) {
	return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
Q(Tm, "whenMouse");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-dropdown-menu@2.1.25_@types+react-dom@19.3.0_@types+react@19.3.0__@type_629a5a4a562bce11ef9cf18d771c29ae/node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs
var Em = Object.defineProperty, $ = (e, t) => Em(e, "name", {
	value: t,
	configurable: !0
}), Dm = "DropdownMenu", [Om, km] = /* @__PURE__ */ Zn(Dm, [Tp]), Am = Tp(), [jm, Mm] = Om(Dm), Nm = /* @__PURE__ */ $((t) => {
	let { __scopeDropdownMenu: n, children: r, dir: i, open: a, defaultOpen: o, onOpenChange: s, modal: c = !0 } = t, l = Am(n), u = e.useRef(null), [d, p] = Ls({
		prop: a,
		defaultProp: o ?? !1,
		onChange: s,
		caller: Dm
	});
	return /* @__PURE__ */ f(jm, {
		scope: n,
		triggerId: Y(),
		triggerRef: u,
		contentId: Y(),
		open: d,
		onOpenChange: p,
		onOpenToggle: e.useCallback(() => p((e) => !e), [p]),
		modal: c,
		children: /* @__PURE__ */ f(Mp, {
			...l,
			open: d,
			onOpenChange: p,
			dir: i,
			modal: c,
			children: r
		})
	});
}, "DropdownMenu"), Pm = "DropdownMenuTrigger", Fm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeDropdownMenu: n, disabled: r = !1, ...i } = e, a = Mm(Pm, n), o = Am(n), s = W(t, a.triggerRef);
	return /* @__PURE__ */ f(Np, {
		asChild: !0,
		...o,
		children: /* @__PURE__ */ f(G.button, {
			type: "button",
			id: a.triggerId,
			"aria-haspopup": "menu",
			"aria-expanded": a.open,
			"aria-controls": a.open ? a.contentId : void 0,
			"data-state": a.open ? "open" : "closed",
			"data-disabled": r ? "" : void 0,
			disabled: r,
			...i,
			ref: s,
			onPointerDown: K(e.onPointerDown, (e) => {
				!r && e.button === 0 && e.ctrlKey === !1 && (a.onOpenToggle(), a.open || e.preventDefault());
			}),
			onKeyDown: K(e.onKeyDown, (e) => {
				r || (["Enter", " "].includes(e.key) && a.onOpenToggle(), e.key === "ArrowDown" && a.onOpenChange(!0), [
					"Enter",
					" ",
					"ArrowDown"
				].includes(e.key) && e.preventDefault());
			})
		})
	});
}, "DropdownMenuTrigger")), Im = /* @__PURE__ */ $((e) => {
	let { __scopeDropdownMenu: t, ...n } = e, r = Am(t);
	return /* @__PURE__ */ f(Lp, {
		...r,
		...n
	});
}, "DropdownMenuPortal"), Lm = "DropdownMenuContent", Rm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ $(function(t, n) {
	let { __scopeDropdownMenu: r, ...i } = t, a = Mm(Lm, r), o = Am(r), s = e.useRef(!1);
	return /* @__PURE__ */ f(Vp, {
		id: a.contentId,
		"aria-labelledby": a.triggerId,
		...o,
		...i,
		ref: n,
		onCloseAutoFocus: K(t.onCloseAutoFocus, (e) => {
			s.current || a.triggerRef.current?.focus(), s.current = !1, e.preventDefault();
		}),
		onInteractOutside: K(t.onInteractOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, r = t.button === 2 || n;
			(!a.modal || r) && (s.current = !0);
		}),
		style: {
			...t.style,
			"--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
			"--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
			"--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
		}
	});
}, "DropdownMenuContent")), zm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Am(n);
	return /* @__PURE__ */ f(Kp, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuGroup")), Bm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Am(n);
	return /* @__PURE__ */ f(qp, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuLabel")), Vm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Am(n);
	return /* @__PURE__ */ f(Xp, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuItem")), Hm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Am(n);
	return /* @__PURE__ */ f(Qp, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuCheckboxItem")), Um = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Am(n);
	return /* @__PURE__ */ f(tm, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuRadioGroup")), Wm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Am(n);
	return /* @__PURE__ */ f(rm, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuRadioItem")), Gm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Am(n);
	return /* @__PURE__ */ f(sm, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuItemIndicator")), Km = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Am(n);
	return /* @__PURE__ */ f(cm, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuSeparator")), qm = /* @__PURE__ */ $((e) => {
	let { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: i, defaultOpen: a } = e, o = Am(t), [s, c] = Ls({
		prop: r,
		defaultProp: a ?? !1,
		onChange: i,
		caller: "DropdownMenuSub"
	});
	return /* @__PURE__ */ f(fm, {
		...o,
		open: s,
		onOpenChange: c,
		children: n
	});
}, "DropdownMenuSub"), Jm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Am(n);
	return /* @__PURE__ */ f(mm, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuSubTrigger")), Ym = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Am(n);
	return /* @__PURE__ */ f(gm, {
		...i,
		...r,
		ref: t,
		style: {
			...e.style,
			"--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
			"--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
			"--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
		}
	});
}, "DropdownMenuSubContent")), Xm = Nm, Zm = Fm, Qm = zm, $m = Im, eh = qm, th = Um, nh = r(({ className: e, inset: t, children: n, ...r }, i) => /* @__PURE__ */ p(Jm, {
	ref: i,
	className: V("agn-menu-item flex cursor-default select-none items-center rounded-md px-2 py-2 text-sm", "outline-none ring-0 border-none", "focus:bg-slate-50 data-[state=open]:bg-slate-50", "dark:focus:bg-slate-800/50 dark:data-[state=open]:bg-slate-800/50", t && "pl-8", e),
	...r,
	children: [n, /* @__PURE__ */ f(Yt, { className: "ml-auto h-4 w-4" })]
}));
nh.displayName = Jm.displayName;
var rh = r(({ className: e, ...t }, n) => /* @__PURE__ */ f(Ym, {
	ref: n,
	className: V("agn-menu z-50 min-w-[8rem] overflow-hidden rounded-md border p-1.5", "bg-white text-slate-900 shadow-lg dark:shadow-slate-950/50 border-slate-200", "dark:bg-slate-900 dark:text-slate-100 dark:border-slate-800", "data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95", "data-[side=top]:slide-in-from-bottom-2", "data-[side=right]:slide-in-from-left-2", "data-[side=bottom]:slide-in-from-top-2", "data-[side=left]:slide-in-from-right-2", e),
	...t
}));
rh.displayName = Ym.displayName;
var ih = r(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ f(Im, { children: /* @__PURE__ */ f(Rm, {
	ref: r,
	sideOffset: t,
	className: V("agn-menu z-50 min-w-[8rem] overflow-hidden rounded-md border p-1.5", "bg-white text-slate-900 shadow-md dark:shadow-slate-950/50 border-slate-200", "dark:bg-slate-900 dark:text-slate-100 dark:border-slate-800", "data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95", "data-[side=top]:slide-in-from-bottom-2", "data-[side=right]:slide-in-from-left-2", "data-[side=bottom]:slide-in-from-top-2", "data-[side=left]:slide-in-from-right-2", e),
	...n
}) }));
ih.displayName = Rm.displayName;
var ah = r(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ f(Vm, {
	ref: r,
	className: V("agn-menu-item relative flex cursor-default select-none items-center rounded-md px-2 py-2 text-sm", "outline-none ring-0 border-none", "transition-colors", "focus:bg-slate-50 focus:text-slate-900", "dark:focus:bg-slate-800/50 dark:focus:text-slate-100", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", t && "pl-8", e),
	...n
}));
ah.displayName = Vm.displayName;
var oh = r(({ className: e, children: t, checked: n, ...r }, i) => /* @__PURE__ */ p(Hm, {
	ref: i,
	className: V("agn-menu-item relative flex cursor-default select-none items-center rounded-md py-2 pl-8 pr-2 text-sm", "outline-none ring-0 border-none", "transition-colors", "focus:bg-slate-50 focus:text-slate-900", "dark:focus:bg-slate-800/50 dark:focus:text-slate-100", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", e),
	checked: n,
	...r,
	children: [/* @__PURE__ */ f("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ f(Gm, { children: /* @__PURE__ */ f(Gt, { className: "h-4 w-4" }) })
	}), t]
}));
oh.displayName = Hm.displayName;
var sh = r(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ p(Wm, {
	ref: r,
	className: V("agn-menu-item relative flex cursor-default select-none items-center rounded-md py-2 pl-8 pr-2 text-sm", "outline-none ring-0 border-none", "transition-colors", "focus:bg-slate-50 focus:text-slate-900", "dark:focus:bg-slate-800/50 dark:focus:text-slate-100", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", e),
	...n,
	children: [/* @__PURE__ */ f("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ f(Gm, { children: /* @__PURE__ */ f(fn, { className: "h-2 w-2 fill-current" }) })
	}), t]
}));
sh.displayName = Wm.displayName;
var ch = r(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ f(Bm, {
	ref: r,
	className: V("agn-menu-label px-2 py-2 text-sm font-semibold", "text-slate-900 dark:text-slate-100", t && "pl-8", e),
	...n
}));
ch.displayName = Bm.displayName;
var lh = r(({ className: e, ...t }, n) => /* @__PURE__ */ f(Km, {
	ref: n,
	className: V("agn-menu-sep -mx-1 my-1 h-px bg-slate-200 dark:bg-slate-800", e),
	...t
}));
lh.displayName = Km.displayName;
var uh = ({ className: e, ...t }) => /* @__PURE__ */ f("span", {
	className: V("ml-auto text-xs tracking-widest opacity-60", e),
	...t
});
uh.displayName = "DropdownMenuShortcut";
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-tabs@1.1.22_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@1_450c284a3bb475239d2613877ab2e8e7/node_modules/@radix-ui/react-tabs/dist/index.mjs
var dh = Object.defineProperty, fh = (e, t) => dh(e, "name", {
	value: t,
	configurable: !0
}), ph = {
	Automatic: "automatic",
	Manual: "manual"
}, mh = "Tabs", [hh, gh] = /* @__PURE__ */ Zn(mh, [zu]), _h = zu(), [vh, yh] = hh(mh), bh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ fh(function(e, t) {
	let { __scopeTabs: n, value: r, onValueChange: i, defaultValue: a, orientation: o = "horizontal", dir: s, activationMode: c = ph.Automatic, ...l } = e, u = xu(s), [d, p] = Ls({
		prop: r,
		onChange: i,
		defaultProp: a ?? "",
		caller: mh
	});
	return /* @__PURE__ */ f(vh, {
		scope: n,
		baseId: Y(),
		value: d,
		onValueChange: p,
		orientation: o,
		dir: u,
		activationMode: c,
		children: /* @__PURE__ */ f(G.div, {
			dir: u,
			"data-orientation": o,
			...l,
			ref: t
		})
	});
}, "Tabs")), xh = "TabsList", Sh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ fh(function(e, t) {
	let { __scopeTabs: n, loop: r = !0, ...i } = e, a = yh(xh, n), o = _h(n);
	return /* @__PURE__ */ f(Wu, {
		asChild: !0,
		...o,
		orientation: a.orientation,
		dir: a.dir,
		loop: r,
		children: /* @__PURE__ */ f(G.div, {
			role: "tablist",
			"aria-orientation": a.orientation,
			...i,
			ref: t
		})
	});
}, "TabsList")), Ch = "TabsTrigger", wh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ fh(function(e, t) {
	let { __scopeTabs: n, value: r, disabled: i = !1, ...a } = e, o = yh(Ch, n), s = _h(n), c = Dh(o.baseId, r), l = Oh(o.baseId, r), u = r === o.value;
	return /* @__PURE__ */ f(qu, {
		asChild: !0,
		...s,
		focusable: !i,
		active: u,
		children: /* @__PURE__ */ f(G.button, {
			type: "button",
			role: "tab",
			"aria-selected": u,
			"aria-controls": l,
			"data-state": u ? "active" : "inactive",
			"data-disabled": i ? "" : void 0,
			disabled: i,
			id: c,
			...a,
			ref: t,
			onMouseDown: K(e.onMouseDown, (e) => {
				!i && e.button === 0 && e.ctrlKey === !1 ? (e.currentTarget.focus(), o.onValueChange(r)) : e.preventDefault();
			}),
			onKeyDown: K(e.onKeyDown, (e) => {
				i || e.target !== e.currentTarget || [" ", "Enter"].includes(e.key) && o.onValueChange(r);
			}),
			onFocus: K(e.onFocus, () => {
				let e = o.activationMode !== ph.Manual;
				!u && !i && e && o.onValueChange(r);
			})
		})
	});
}, "TabsTrigger")), Th = "TabsContent", Eh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ fh(function(t, n) {
	let { __scopeTabs: r, value: i, forceMount: a, children: o, ...s } = t, c = yh(Th, r), l = Dh(c.baseId, i), u = Oh(c.baseId, i), d = i === c.value, p = e.useRef(d);
	return e.useEffect(() => {
		let e = requestAnimationFrame(() => p.current = !1);
		return () => cancelAnimationFrame(e);
	}, []), /* @__PURE__ */ f(Cs, {
		present: a || d,
		children: ({ present: e }) => /* @__PURE__ */ f(G.div, {
			"data-state": d ? "active" : "inactive",
			"data-orientation": c.orientation,
			role: "tabpanel",
			"aria-labelledby": l,
			hidden: !e,
			id: u,
			tabIndex: 0,
			...s,
			ref: n,
			style: {
				...t.style,
				animationDuration: p.current ? "0s" : void 0
			},
			children: e && o
		})
	});
}, "TabsContent"));
function Dh(e, t) {
	return `${e}-trigger-${t}`;
}
fh(Dh, "makeTriggerId");
function Oh(e, t) {
	return `${e}-content-${t}`;
}
fh(Oh, "makeContentId");
//#endregion
//#region src/components/molecules/EmptyState/EmptyState.tsx
var kh = r(({ className: e, icon: t, title: n, description: r, action: i, size: a = "md", titleAs: o = "h3", ...s }, c) => {
	let l = {
		sm: {
			container: "py-8 px-4",
			iconWrapper: "h-14 w-14",
			icon: "h-6 w-6",
			title: "text-base",
			description: "text-xs"
		},
		md: {
			container: "py-12 px-6",
			iconWrapper: "h-20 w-20",
			icon: "h-10 w-10",
			title: "text-lg",
			description: "text-sm"
		},
		lg: {
			container: "py-16 px-8",
			iconWrapper: "h-24 w-24",
			icon: "h-12 w-12",
			title: "text-xl",
			description: "text-base"
		}
	};
	return /* @__PURE__ */ p("div", {
		ref: c,
		className: V("flex flex-col items-center justify-center text-center", l[a].container, e),
		role: "status",
		"aria-live": "polite",
		...s,
		children: [
			t && /* @__PURE__ */ f("div", {
				className: V("flex items-center justify-center rounded-full bg-muted", "mb-4", l[a].iconWrapper),
				children: /* @__PURE__ */ f(t, {
					className: V("text-text-placeholder", l[a].icon),
					"aria-hidden": "true"
				})
			}),
			/* @__PURE__ */ f(o, {
				className: V("font-semibold text-text-primary mb-2", l[a].title),
				children: n
			}),
			r && /* @__PURE__ */ f("p", {
				className: V("text-muted-foreground mb-6 max-w-md", l[a].description),
				children: r
			}),
			i && /* @__PURE__ */ f("div", {
				className: "mt-2",
				children: i
			})
		]
	});
});
kh.displayName = "EmptyState";
//#endregion
//#region src/components/organisms/DataTable/DataTable.tsx
var Ah = r(({ className: e, variant: t, density: n = "comfortable", children: r, ...i }, a) => /* @__PURE__ */ f("div", {
	ref: a,
	"data-density": n,
	className: V("w-full overflow-hidden rounded-lg border border-border", n === "compact" && "data-table-compact", e),
	...i,
	children: /* @__PURE__ */ f("div", {
		className: "overflow-x-auto",
		children: /* @__PURE__ */ f("div", {
			className: "inline-block min-w-full align-middle",
			children: r
		})
	})
}));
Ah.displayName = "DataTable";
var jh = r(({ className: e, ...t }, n) => /* @__PURE__ */ f("table", {
	ref: n,
	className: V("min-w-full divide-y divide-border", e),
	...t
}));
jh.displayName = "DataTableTable";
var Mh = r(({ className: e, ...t }, n) => /* @__PURE__ */ f("thead", {
	ref: n,
	className: V("bg-[var(--table-band)]", e),
	...t
}));
Mh.displayName = "DataTableHeader";
var Nh = r(({ className: e, ...t }, n) => /* @__PURE__ */ f("tbody", {
	ref: n,
	className: V("divide-y bg-[var(--surface)]", e),
	...t
}));
Nh.displayName = "DataTableBody";
var Ph = r(({ className: e, isSelected: t, isClickable: n, ...r }, i) => /* @__PURE__ */ f("tr", {
	ref: i,
	className: V(n && "cursor-pointer hover:bg-surface-hover", t && "bg-[var(--surface-selected)]", e),
	...r
}));
Ph.displayName = "DataTableRow";
var Fh = r(({ className: e, sortable: t, sorted: n, align: r = "left", children: i, ...a }, o) => /* @__PURE__ */ f("th", {
	ref: o,
	scope: "col",
	className: V("agn-dt-head px-4 py-3 text-xs font-medium uppercase tracking-wider text-text-muted", r === "left" && "text-left", r === "center" && "text-center", r === "right" && "text-right", t && "agn-dt-head--sortable cursor-pointer select-none hover:text-text-primary", e),
	...a,
	children: /* @__PURE__ */ p("div", {
		className: V("flex items-center gap-1.5", r === "center" && "justify-center", r === "right" && "justify-end"),
		children: [i, t && /* @__PURE__ */ f("span", {
			className: "inline-flex",
			"aria-hidden": "true",
			children: n === "asc" ? /* @__PURE__ */ f(Vt, { className: "agn-dt-head-sort-active h-3 w-3 text-text-secondary" }) : n === "desc" ? /* @__PURE__ */ f(Nt, { className: "agn-dt-head-sort-active h-3 w-3 text-text-secondary" }) : /* @__PURE__ */ f(zt, { className: "agn-dt-head-sort-idle h-3 w-3 text-text-placeholder" })
		})]
	})
}));
Fh.displayName = "DataTableHead";
var Ih = r(({ className: e, align: t = "left", ...n }, r) => /* @__PURE__ */ f("td", {
	ref: r,
	className: V("whitespace-nowrap px-4 py-3 text-sm text-text-primary", t === "center" && "text-center", t === "right" && "text-right", e),
	...n
}));
Ih.displayName = "DataTableCell";
var Lh = r(({ className: e, colSpan: t, message: n = "No data available", icon: r, ...i }, a) => /* @__PURE__ */ f("tr", { children: /* @__PURE__ */ f("td", {
	ref: a,
	colSpan: t,
	className: V("px-4 py-12 text-center", e),
	...i,
	children: /* @__PURE__ */ p("div", {
		className: "flex flex-col items-center justify-center gap-2 text-muted-foreground",
		children: [r && /* @__PURE__ */ f("div", {
			className: "text-[var(--border-hover)]",
			children: r
		}), /* @__PURE__ */ f("p", {
			className: "text-sm",
			children: n
		})]
	})
}) }));
Lh.displayName = "DataTableEmpty";
var Rh = r(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ f("div", {
	ref: r,
	className: V("px-4 py-2 bg-[var(--table-band)] border-b border-border text-sm font-medium text-text-secondary", e),
	...n,
	children: t
}));
Rh.displayName = "DataTableSectionHeader";
var zh = r(({ icon: e, label: t, onClick: n, disabled: r, variant: i = "default" }, a) => /* @__PURE__ */ f(jd, {
	delayDuration: 200,
	children: /* @__PURE__ */ p(Fd, { children: [/* @__PURE__ */ f(Ld, {
		asChild: !0,
		children: /* @__PURE__ */ f("button", {
			ref: a,
			type: "button",
			onClick: n,
			disabled: r,
			className: V("p-1.5 rounded-md transition-colors", "focus:outline-none focus:ring-2 focus:ring-[color:var(--ring-color)] focus:ring-offset-1 focus:ring-offset-surface", "disabled:opacity-50 disabled:cursor-not-allowed", i === "default" && ["text-muted-foreground hover:text-text-secondary hover:bg-surface-hover"], i === "danger" && ["text-muted-foreground hover:text-error-600 hover:bg-error-50"]),
			"aria-label": t,
			children: e
		})
	}), /* @__PURE__ */ f(Vd, { children: /* @__PURE__ */ p(Ud, {
		className: "z-50 rounded-md bg-[var(--action-primary)] px-2 py-1 text-xs text-[var(--action-primary-fg)] shadow-md",
		sideOffset: 5,
		children: [t, /* @__PURE__ */ f(qd, { className: "fill-[var(--action-primary)]" })]
	}) })] })
}));
zh.displayName = "DataTableAction";
var Bh = r(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ f("div", {
	ref: r,
	className: V("flex items-center gap-0.5", e),
	...n,
	children: t
}));
Bh.displayName = "DataTableActions";
var Vh = r(({ className: e, ...t }, n) => /* @__PURE__ */ f("div", {
	ref: n,
	"data-slot": "table-footer",
	className: V("rounded-b-[inherit] overflow-hidden bg-[var(--surface)]", e),
	...t
}));
Vh.displayName = "DataTableFooter";
var Hh = {
	of: "of",
	page: "Page",
	goToFirstPage: "Go to first page",
	goToPreviousPage: "Go to previous page",
	goToNextPage: "Go to next page",
	goToLastPage: "Go to last page",
	goToPage: (e) => `Go to page ${e}`,
	rowsPerPage: "Rows per page"
};
function Uh(e, t, n = 1) {
	let r = [];
	r.push(1);
	let i = Math.max(2, e - n), a = Math.min(t - 1, e + n);
	i > 2 && r.push("ellipsis");
	for (let e = i; e <= a; e++) e !== 1 && e !== t && r.push(e);
	return a < t - 1 && r.push("ellipsis"), t > 1 && r.push(t), r;
}
function Wh({ page: e, children: t, disabled: n, active: r, "aria-label": i, onSelect: a }) {
	return /* @__PURE__ */ f("button", {
		type: "button",
		onClick: () => e && a(e),
		disabled: n,
		"aria-label": i,
		"aria-current": r ? "page" : void 0,
		className: V("flex items-center justify-center min-w-[32px] h-8 px-2 text-sm rounded-md transition-colors", "focus:outline-none focus:ring-2 focus:ring-[color:var(--ring-color)] focus:ring-offset-1 focus:ring-offset-surface", r ? "bg-[var(--action-primary)] text-[var(--action-primary-fg)]" : "text-text-muted hover:bg-surface-hover", n && "opacity-50 cursor-not-allowed hover:bg-transparent"),
		children: t
	});
}
var Gh = r(({ className: e, currentPage: t = 1, totalPages: n = 1, pageSize: r = 10, totalItems: a = 0, onPageChange: o, onPageSizeChange: c, siblingCount: u = 1, labels: m, variant: h = "numbered", pageSizeOptions: g, ..._ }, v) => {
	let y = {
		...Hh,
		...m
	}, b = a === 0 ? 0 : (t - 1) * r + 1, x = Math.min(t * r, a), S = Uh(t, n, u), C = !!(c && g && g.length > 0), w = C && !g.includes(r) ? [...g, r].sort((e, t) => e - t) : g ?? [], T = l(null);
	s(v, () => T.current);
	let E = i((e) => {
		if (e === t) return;
		o?.(e);
		let n = T.current?.parentElement ?? T.current;
		n && requestAnimationFrame(() => {
			n.getBoundingClientRect().top < 0 && n.scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		});
	}, [t, o]);
	return /* @__PURE__ */ p("div", {
		ref: T,
		className: V("flex items-center justify-between border-t bg-[var(--surface)] px-4 py-3 rounded-b-[inherit]", e),
		..._,
		children: [/* @__PURE__ */ p("div", {
			className: "flex items-center gap-4 text-sm text-text-muted",
			children: [C && /* @__PURE__ */ p("label", {
				className: "flex items-center gap-2",
				children: [/* @__PURE__ */ f("span", { children: y.rowsPerPage }), /* @__PURE__ */ f("select", {
					value: r,
					onChange: (e) => c?.(Number(e.target.value)),
					"aria-label": y.rowsPerPage,
					className: V("h-8 rounded-md border border-border bg-[var(--surface)] px-2 text-sm text-text-secondary", "focus:outline-none focus:ring-2 focus:ring-[color:var(--ring-color)] focus:ring-offset-1 focus:ring-offset-surface"),
					children: w.map((e) => /* @__PURE__ */ f("option", {
						value: e,
						children: e
					}, e))
				})]
			}), /* @__PURE__ */ p("div", { children: [
				/* @__PURE__ */ f("span", {
					className: "font-medium",
					children: b
				}),
				" ",
				"–",
				" ",
				/* @__PURE__ */ f("span", {
					className: "font-medium",
					children: x
				}),
				" ",
				y.of,
				" ",
				/* @__PURE__ */ f("span", {
					className: "font-medium",
					children: a
				}),
				h === "numbered" && /* @__PURE__ */ p(d, { children: [
					/* @__PURE__ */ f("span", {
						className: "mx-2 text-[var(--border-hover)]",
						children: "·"
					}),
					y.page,
					" ",
					/* @__PURE__ */ f("span", {
						className: "font-medium",
						children: t
					}),
					" ",
					y.of,
					" ",
					/* @__PURE__ */ f("span", {
						className: "font-medium",
						children: n
					})
				] })
			] })]
		}), h === "simple" ? /* @__PURE__ */ p("div", {
			className: "flex items-center gap-1",
			children: [/* @__PURE__ */ f(Wh, {
				onSelect: E,
				page: t - 1,
				disabled: t === 1,
				"aria-label": y.goToPreviousPage,
				children: /* @__PURE__ */ f(Zt, { className: "h-4 w-4" })
			}), /* @__PURE__ */ f(Wh, {
				onSelect: E,
				page: t + 1,
				disabled: t >= n,
				"aria-label": y.goToNextPage,
				children: /* @__PURE__ */ f(Yt, { className: "h-4 w-4" })
			})]
		}) : /* @__PURE__ */ p("div", {
			className: "flex items-center gap-1",
			children: [
				/* @__PURE__ */ f(Wh, {
					onSelect: E,
					page: 1,
					disabled: t === 1,
					"aria-label": y.goToFirstPage,
					children: /* @__PURE__ */ f(tn, { className: "h-4 w-4" })
				}),
				/* @__PURE__ */ f(Wh, {
					onSelect: E,
					page: t - 1,
					disabled: t === 1,
					"aria-label": y.goToPreviousPage,
					children: /* @__PURE__ */ f(Zt, { className: "h-4 w-4" })
				}),
				/* @__PURE__ */ f("div", {
					className: "flex items-center gap-1 mx-1",
					children: S.map((e, n) => e === "ellipsis" ? /* @__PURE__ */ f("span", {
						className: "px-1 text-text-placeholder",
						children: "…"
					}, `ellipsis-${n}`) : /* @__PURE__ */ f(Wh, {
						onSelect: E,
						page: e,
						active: e === t,
						"aria-label": y.goToPage(e),
						children: e
					}, e))
				}),
				/* @__PURE__ */ f(Wh, {
					onSelect: E,
					page: t + 1,
					disabled: t === n,
					"aria-label": y.goToNextPage,
					children: /* @__PURE__ */ f(Yt, { className: "h-4 w-4" })
				}),
				/* @__PURE__ */ f(Wh, {
					onSelect: E,
					page: n,
					disabled: t === n,
					"aria-label": y.goToLastPage,
					children: /* @__PURE__ */ f(rn, { className: "h-4 w-4" })
				})
			]
		})]
	});
});
Gh.displayName = "DataTablePagination";
//#endregion
//#region src/components/organisms/ExecutionLog/keptOutput.ts
var Kh = {
	keptOutput: "This output is kept on the host that ran the mission.",
	keptOutputUnavailable: "This output is no longer available.",
	keptOutputNotKept: "This output was not kept.",
	keptOutputTooLarge: "This output is too large to open here.",
	keptOutputUnreachable: "Could not reach the host that keeps this output. Try again.",
	openKeptOutput: "Open",
	openKeptOutputNamed: "Open {name}"
};
function qh(e, t, n = "") {
	return (e[t] ?? Kh[t]).replace("{name}", n);
}
function Jh(e) {
	return typeof e == "object" && e && !Array.isArray(e) ? e : void 0;
}
function Yh(e) {
	let t = Jh(e.ref), n = t?.execution_id, r = t?.host_id, i = t?.artifact_id;
	if (typeof n == "string" && typeof r == "string" && typeof i == "string") return {
		executionId: n,
		hostId: r,
		artifactId: i
	};
}
function Xh(e) {
	let t = Jh(e);
	if (!t) return {
		values: e,
		described: []
	};
	let n = {}, r = [];
	for (let [e, i] of Object.entries(t)) {
		let t = Jh(i);
		if (t?.kind !== "description") {
			n[e] = i;
			continue;
		}
		let a = t.type, o = Yh(t);
		r.push({
			name: e,
			isJson: a === "json" || a === "array",
			...t.reason === "output_not_kept" ? { notKept: !0 } : {},
			...o ? { reference: o } : {}
		});
	}
	return {
		values: r.length > 0 ? n : e,
		described: r
	};
}
function Zh(e) {
	return e.described.length === 0 || Object.keys(e.values).length > 0;
}
function Qh(e, t) {
	switch (e.phase) {
		case "opened": return;
		case "notKept": return qh(t, "keptOutputNotKept");
		case "unavailable": return qh(t, "keptOutputUnavailable");
		case "tooLarge": return qh(t, "keptOutputTooLarge");
		case "unreachable": return qh(t, "keptOutputUnreachable");
		default: return qh(t, "keptOutput");
	}
}
function $h(e) {
	return e.reference ? { phase: "kept" } : e.notKept ? { phase: "notKept" } : { phase: "unavailable" };
}
function eg(e) {
	if (typeof e != "object" || !e) return;
	let { kind: t, status: n } = e;
	return t === "http" && typeof n == "number" ? n : void 0;
}
function tg(e) {
	let t = eg(e);
	return t === 404 ? { phase: "unavailable" } : t === 413 ? { phase: "tooLarge" } : { phase: "unreachable" };
}
function ng(e, t, n) {
	let [r, i] = u(() => $h(e)), a = l(!0), s = l(null);
	o(() => (a.current = !0, () => {
		a.current = !1;
	}), []), o(() => {
		r.phase === "opened" && s.current?.focus();
	}, [r.phase]);
	let c = e.reference, d = c !== void 0 && t !== void 0 && t !== "" && n !== void 0;
	return {
		state: r,
		canOpen: d,
		open: () => {
			d && (i({ phase: "opening" }), n({
				missionId: t,
				...c
			}).then((e) => {
				a.current && i({
					phase: "opened",
					content: e
				});
			}, (e) => {
				a.current && i(tg(e));
			}));
		},
		openedRef: s
	};
}
//#endregion
//#region src/components/organisms/ExecutionLog/utils.ts
function rg(e, t) {
	return t === "blocked" && !e ? "blocked" : e ? "succeeded" : "failed";
}
var ig = "cancelled";
function ag(e, t) {
	return e === "mission_end" && typeof t == "string" && t.trim() === "cancelled";
}
function og(e) {
	return e.stopped === !0 && !e.success;
}
var sg = {
	blocked: "Blocked by setup",
	blockedTargetNotBound: "the system is not connected to this mission",
	blockedTargetNotAuthorized: "this mission is not authorized to use the system",
	blockedOperationOutsideScope: "the operation is not allowed in this mission",
	blockedCredentialUnavailable: "the connection has no usable credentials",
	blockedOther: "the mission setup does not allow this request",
	blockedHint: "The mission author or an administrator can change this."
}, cg = (e, t) => `${e} could not finish: ${t}.`, lg = /* @__PURE__ */ new Map([
	["target_not_bound", "blockedTargetNotBound"],
	["target_not_authorized", "blockedTargetNotAuthorized"],
	["operation_outside_scope", "blockedOperationOutsideScope"],
	["credential_unavailable", "blockedCredentialUnavailable"]
]);
function ug(e, t, n = {}) {
	let r = e && lg.get(e) || "blockedOther", i = (e) => n[e] ?? sg[e];
	return `${(n.blockedMessage ?? cg)(t, i(r))} ${i("blockedHint")}`;
}
var dg = {
	forced: "Finished early",
	forcedBudget: "Finished early: ran out of turns. The result may be incomplete. Narrow what the step asks for, or split it.",
	forcedStuckRepeating: "Finished early: kept repeating the same call. The result may be incomplete. Change the step's instructions.",
	forcedRepeatedFailure: "Finished early after repeated tool errors. The result may be incomplete. Check the connection the step uses.",
	forcedSchemaChurn: "Finished early: the source data kept changing shape. The result may be incomplete. Check the source schema."
}, fg = /* @__PURE__ */ new Map([
	["budget", "forcedBudget"],
	["stuck_repeating", "forcedStuckRepeating"],
	["repeated_failure", "forcedRepeatedFailure"],
	["schema_churn", "forcedSchemaChurn"]
]);
function pg(e, t, n = {}) {
	let r = e && t ? fg.get(t) : void 0;
	if (!r) return;
	let i = (e) => n[e] ?? dg[e];
	return {
		severity: "warning",
		label: i("forced"),
		text: i(r)
	};
}
function mg(e) {
	return e < 0 ? "0ms" : e < 1e3 ? `${e}ms` : e < 6e4 ? `${(e / 1e3).toFixed(1)}s` : e < 36e5 ? `${Math.floor(e / 6e4)}m ${Math.round(e % 6e4 / 1e3)}s` : `${Math.floor(e / 36e5)}h ${Math.floor(e % 36e5 / 6e4)}m`;
}
function hg(e) {
	return e > 6e5 ? "Timed out" : mg(e);
}
function gg(e) {
	return e >= 1e3 ? `${(e / 1e3).toFixed(1)}k` : e.toLocaleString();
}
function _g(e) {
	return new Date(e).toLocaleTimeString([], {
		hour: "2-digit",
		minute: "2-digit"
	});
}
function vg(e) {
	let t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set();
	for (let n of e) if (n.type === "tool_call") {
		let e = n;
		e.toolCallId && t.set(e.toolCallId, e);
	}
	for (let r of e) if (r.type === "tool_result") {
		let e = r, i = e.toolCallId ? t.get(e.toolCallId) : void 0;
		i && (i.resolved = !0, i.resolvedSuccess = e.success, i.resolvedOutput = e.output, i.resolvedError = e.error, i.resolvedDeniedByGuard = e.deniedByGuard, i.resolvedDurationMs = e.durationMs, e.outputFiles && e.outputFiles.length > 0 && (i.resolvedOutputFiles = e.outputFiles), n.add(r.id));
	}
	return e.filter((e) => !n.has(e.id));
}
function yg(e) {
	let t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set();
	for (let n of e) if (n.type === "delegation") {
		let e = n;
		e.delegationId && t.set(e.delegationId, e);
	}
	for (let r of e) if (r.type === "delegation_result") {
		let e = r, i = e.delegationId ? t.get(e.delegationId) : void 0;
		i && (i.resolved = !0, i.resolvedSuccess = e.success, i.resolvedSummary = e.summary, i.resolvedError = e.error, i.resolvedDurationMs = e.durationMs, i.resolvedTokensUsed = e.tokensUsed, i.resolvedOutcome = e.outcome, i.resolvedBlockedReason = e.blockedReason, n.add(r.id));
	}
	return e.filter((e) => !n.has(e.id));
}
function bg(e) {
	return e.filter((e) => {
		if (e.type === "turn") {
			let t = e;
			if (t.inputTokens === 0 && t.outputTokens === 0 && t.durationMs === 0 && !t.userPrompt && !t.assistantResponse) return !1;
		}
		if (e.type === "orchestrator_decision") {
			let t = e.reasoning?.trim() ?? "";
			if (!t || t.startsWith("(tool call")) return !1;
		}
		if (e.type === "tool_call") {
			let t = e;
			if (t.toolName === "ask_user" || t.toolName === "synthesize_results") return !1;
		}
		return !0;
	});
}
function xg(e, t = !1) {
	if (e.length === 0) return [];
	let n = [], r = [], i = 1, a = () => {
		if (r.length === 0) return;
		let e = r[0], a = r[r.length - 1], o = "", s = "completed";
		for (let e of r) if (e.type === "hitl_response") {
			let t = e.response || "";
			o = t.length > 50 ? t.slice(0, 47) + "..." : t;
			break;
		}
		if (!o) {
			for (let e of r) if (e.type === "delegation") {
				let n = e;
				o = n.agentLabel || n.task, s = n.resolved ? n.resolvedSuccess ? "completed" : "failed" : t ? "running" : "completed";
				break;
			}
		}
		if (!o) {
			for (let e of r) if (e.type === "hitl_request") {
				let t = e, n = t.prompt || "";
				o = n.length > 50 ? n.slice(0, 47) + "..." : n, t.pending && (s = "running");
				break;
			}
		}
		if (o ||= `Turn ${i}`, s === "completed") {
			for (let e of r) if (e.type === "delegation") {
				let n = e;
				n.resolved && !n.resolvedSuccess && (s = "failed"), !n.resolved && t && (s = "running");
				break;
			}
		}
		let c = 0;
		for (let e of r) e.type === "turn" && (c += e.inputTokens + e.outputTokens), e.type === "orchestrator_decision" && (c += e.tokensUsed ?? 0), e.type === "delegation" && (c += e.resolvedTokensUsed ?? 0);
		n.push({
			id: `cycle-${i}`,
			cycleNumber: i,
			startTimestamp: e.timestamp,
			endTimestamp: a.timestamp,
			summary: o,
			status: s,
			entries: r,
			durationMs: a.timestamp - e.timestamp,
			totalTokens: c
		}), i++, r = [];
	};
	for (let t of e) t.type === "hitl_request" && r.length > 0 && a(), r.push(t);
	return r.length > 0 && a(), t && n.length > 0 && (n[n.length - 1].status = "running"), n;
}
//#endregion
//#region src/components/organisms/ExecutionLog/runChatSteps.ts
var Sg = 3, Cg = "mission";
function wg(e, t, n = 3) {
	let r = [], i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = (e, n, a, o) => {
		if (!n || n === Cg || i.has(n)) return;
		let s = {
			key: e,
			nodeId: n,
			label: t(n, o),
			startedAt: a,
			state: "running",
			tools: [],
			moreTools: 0,
			allTools: []
		};
		r.push(s), i.set(n, s);
	}, s = (e, t, n, r, a, s) => {
		if (!t || t === Cg) return;
		let c = i.get(t);
		!c && (o(e, t, a === void 0 ? n : n - a, s), c = i.get(t), !c) || (c.state = r, c.durationMs = a ?? Math.max(0, n - c.startedAt), i.delete(t));
	};
	for (let t of e) {
		let e = t;
		switch (e.type) {
			case "node_start":
				o(e.id, e.nodeId, e.timestamp, e.nodeLabel);
				break;
			case "node_complete":
				s(e.id, e.nodeId, e.timestamp, e.success ? e.forcedReason ? "warning" : "completed" : "failed", e.durationMs, e.nodeLabel);
				break;
			case "delegation":
				o(e.id, e.agentNodeId, e.timestamp, e.agentLabel);
				break;
			case "delegation_result":
				s(e.id, e.agentNodeId, e.timestamp, e.success ? "completed" : "failed", e.durationMs, e.agentLabel);
				break;
			case "tool_call": {
				let t = i.get(e.nodeId);
				if (!t || a.has(e.toolCallId)) break;
				let n = {
					key: e.toolCallId,
					name: e.toolName,
					status: "running"
				};
				a.set(e.toolCallId, n), t.allTools.push(n);
				break;
			}
			case "tool_result": {
				let t = a.get(e.toolCallId);
				t && (t.status = e.success ? "done" : "failed");
				break;
			}
		}
	}
	return r.map(({ allTools: e, ...t }) => {
		if (t.state !== "running") return t;
		let r = e.slice(-n), i = new Set(r.map((e) => e.key)), a = e.filter((e) => e.status === "running" && !i.has(e.key)).length;
		return {
			...t,
			tools: r.map((e) => ({ ...e })),
			moreTools: a
		};
	});
}
//#endregion
export { eh as $, vn as $n, xu as $t, Vh as A, Dr as An, H as Ar, Tf as At, Sh as B, qn as Bn, hf as Bt, ng as C, Y as Cn, dt as Cr, Mf as Ct, Nh as D, Ur as Dn, ft as Dr, Sf as Dt, Bh as E, Hr as En, pt as Er, Pf as Et, Rh as F, nr as Fn, vf as Ft, Qm as G, Pn as Gn, tf as Gt, Xm as H, Bn as Hn, nf as Ht, jh as I, tr as In, pf as It, $m as J, On as Jn, td as Jt, ah as K, Mn as Kn, rf as Kt, kh as L, Zn as Ln, df as Lt, Mh as M, Er as Mn, Df as Mt, Gh as N, lr as Nn, xf as Nt, Ih as O, K as On, gt as Or, Of as Ot, Ph as P, W as Pn, _f as Pt, uh as Q, bn as Qn, zu as Qt, bh as R, Gn as Rn, gf as Rt, Xh as S, Yo as Sn, lt as Sr, kf as St, zh as T, ti as Tn, mt as Tr, Nf as Tt, oh as U, Rn as Un, of as Ut, wh as V, Kn as Vn, sf as Vt, ih as W, In as Wn, af as Wt, sh as X, wn as Xn, Wu as Xt, th as Y, En as Yn, nd as Yt, lh as Z, Sn as Zn, qu as Zt, vg as _, ys as _n, jt as _r, Ef as _t, ig as a, Rl as an, on as ar, Vm as at, qh as b, ds as bn, ct as br, Ff as bt, pg as c, Pl as cn, Yt as cr, Wf as ct, _g as d, xl as dn, Ut as dr, sp as dt, ou as en, gn as er, rh as et, gg as f, _l as fn, Vt as fr, Qf as ft, yg as g, Cs as gn, Nt as gr, wf as gt, ag as h, Ls as hn, Ft as hr, Kf as ht, dg as i, Fl as in, cn as ir, Rm as it, Fh as j, G as jn, V as jr, yf as jt, Lh as k, Or as kn, ht as kr, Cf as kt, mg as l, pl as ln, qt as lr, lp as lt, og as m, Xs as mn, Lt as mr, op as mt, wg as n, ru as nn, fn as nr, Zm as nt, ug as o, Il as on, $t as or, Im as ot, xg as p, il as pn, zt as pr, Xf as pt, ch as q, An as qn, xd as qt, sg as r, Nl as rn, un as rr, Nm as rt, bg as s, Ll as sn, Zt as sr, Fm as st, Sg as t, iu as tn, mn as tr, nh as tt, hg as u, Cl as un, Gt as ur, np as ut, rg as v, as as vn, U as vr, If as vt, Ah as w, si as wn, st as wr, jf as wt, Qh as x, ns as xn, ot as xr, Af as xt, Zh as y, ss as yn, ut as yr, bf as yt, Eh as z, Vn as zn, ff as zt };

//# sourceMappingURL=runChatSteps-Bg-AIgrf.js.map